'use strict';

angular.module('isahomeApp', ['ngStorage', 'ng-youtube-upload',
    'ngResource', 'ngCookies', 'ngAria', 'ngCacheBuster', 'ngFileUpload','as.sortable', 'summernote', 'ui.grid', 'ng.deviceDetector',
    // jhipster-needle-angularjs-add-module JHipster will add new module here
    'ui.bootstrap', 'ui.bootstrap.datetimepicker', 'ui.router',  'infinite-scroll', 'angular-loading-bar', 'ngFileSaver', 'angular-bind-html-compile'])

    .run(function ($rootScope, $location, $window, $http, $state,  Auth, Principal, ENV, VERSION) {

        $rootScope.ENV = ENV;
        $rootScope.VERSION = VERSION;
        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
            $rootScope.toState = toState;
            $rootScope.toStateParams = toStateParams;

            if (Principal.isIdentityResolved()) {
                Auth.authorize();
            }


        });

        $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
            var titleKey = 'ISA' ;

            // Remember previous state unless we've been redirected to login or we've just
            // reset the state memory after logout. If we're redirected to login, our
            // previousState is already set in the authExpiredInterceptor. If we're going
            // to login directly, we don't want to be sent to some previous state anyway
            if (!$rootScope.redirected && $rootScope.previousStateName) {
              $rootScope.previousStateName = fromState.name;
              $rootScope.previousStateParams = fromParams;
            }

            // Set the page title key to the one configured in state or use default one
            if (toState.data.pageTitle) {
                titleKey = toState.data.pageTitle;
            }
            $window.document.title = titleKey;
        });

        $rootScope.back = function() {
            // If previous state is 'activate' or do not exist go to 'home'
            if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                $state.go('home');
            } else {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
            }
        };
    });

(function() {
    'use strict';

angular.module('isahomeApp')
    .factory('User', function ($resource) {
        return $resource('api/users/:login', {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                },
                'save': { method:'POST' },
                'update': { method:'PUT' },
                'delete':{ method:'DELETE'}
            });
        });
})();
(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$resource'];

    function UserSearch($resource) {
        var resourceUrl =  'api/_search/users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

/*
 Copyright (c) 2010, Linden Research, Inc.
 Copyright (c) 2014, Joshua Bell

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 $/LicenseInfo$
 */

// Original can be found at:
//   https://bitbucket.org/lindenlab/llsd
// Modifications by Joshua Bell inexorabletash@gmail.com
//   https://github.com/inexorabletash/polyfill

// ES3/ES5 implementation of the Krhonos Typed Array Specification
//   Ref: http://www.khronos.org/registry/typedarray/specs/latest/
//   Date: 2011-02-01
//
// Variations:
//  * Allows typed_array.get/set() as alias for subscripts (typed_array[])
//  * Gradually migrating structure from Khronos spec to ES2015 spec
//
// Caveats:
//  * Beyond 10000 or so entries, polyfilled array accessors (ta[0],
//    etc) become memory-prohibitive, so array creation will fail. Set
//    self.TYPED_ARRAY_POLYFILL_NO_ARRAY_ACCESSORS=true to disable
//    creation of accessors. Your code will need to use the
//    non-standard get()/set() instead, and will need to add those to
//    native arrays for interop.
(function(global) {
    'use strict';
    var undefined = (void 0); // Paranoia

    // Beyond this value, index getters/setters (i.e. array[0], array[1]) are so slow to
    // create, and consume so much memory, that the browser appears frozen.
    var MAX_ARRAY_LENGTH = 1e5;

    // Approximations of internal ECMAScript conversion functions
    function Type(v) {
        switch(typeof v) {
            case 'undefined': return 'undefined';
            case 'boolean': return 'boolean';
            case 'number': return 'number';
            case 'string': return 'string';
            default: return v === null ? 'null' : 'object';
        }
    }

    // Class returns internal [[Class]] property, used to avoid cross-frame instanceof issues:
    function Class(v) { return Object.prototype.toString.call(v).replace(/^\[object *|\]$/g, ''); }
    function IsCallable(o) { return typeof o === 'function'; }
    function ToObject(v) {
        if (v === null || v === undefined) throw TypeError();
        return Object(v);
    }
    function ToInt32(v) { return v >> 0; }
    function ToUint32(v) { return v >>> 0; }

    // Snapshot intrinsics
    var LN2 = Math.LN2,
        abs = Math.abs,
        floor = Math.floor,
        log = Math.log,
        max = Math.max,
        min = Math.min,
        pow = Math.pow,
        round = Math.round;

    // emulate ES5 getter/setter API using legacy APIs
    // http://blogs.msdn.com/b/ie/archive/2010/09/07/transitioning-existing-code-to-the-es5-getter-setter-apis.aspx
    // (second clause tests for Object.defineProperty() in IE<9 that only supports extending DOM prototypes, but
    // note that IE<9 does not support __defineGetter__ or __defineSetter__ so it just renders the method harmless)

    (function() {
        var orig = Object.defineProperty;
        var dom_only = !(function(){try{return Object.defineProperty({},'x',{});}catch(_){return false;}}());

        if (!orig || dom_only) {
            Object.defineProperty = function (o, prop, desc) {
                // In IE8 try built-in implementation for defining properties on DOM prototypes.
                if (orig)
                    try { return orig(o, prop, desc); } catch (_) {}
                if (o !== Object(o))
                    throw TypeError('Object.defineProperty called on non-object');
                if (Object.prototype.__defineGetter__ && ('get' in desc))
                    Object.prototype.__defineGetter__.call(o, prop, desc.get);
                if (Object.prototype.__defineSetter__ && ('set' in desc))
                    Object.prototype.__defineSetter__.call(o, prop, desc.set);
                if ('value' in desc)
                    o[prop] = desc.value;
                return o;
            };
        }
    }());

    // ES5: Make obj[index] an alias for obj._getter(index)/obj._setter(index, value)
    // for index in 0 ... obj.length
    function makeArrayAccessors(obj) {
        if ('TYPED_ARRAY_POLYFILL_NO_ARRAY_ACCESSORS' in global)
            return;

        if (obj.length > MAX_ARRAY_LENGTH) throw RangeError('Array too large for polyfill');

        function makeArrayAccessor(index) {
            Object.defineProperty(obj, index, {
                'get': function() { return obj._getter(index); },
                'set': function(v) { obj._setter(index, v); },
                enumerable: true,
                configurable: false
            });
        }

        var i;
        for (i = 0; i < obj.length; i += 1) {
            makeArrayAccessor(i);
        }
    }

    // Internal conversion functions:
    //    pack<Type>()   - take a number (interpreted as Type), output a byte array
    //    unpack<Type>() - take a byte array, output a Type-like number

    function as_signed(value, bits) { var s = 32 - bits; return (value << s) >> s; }
    function as_unsigned(value, bits) { var s = 32 - bits; return (value << s) >>> s; }

    function packI8(n) { return [n & 0xff]; }
    function unpackI8(bytes) { return as_signed(bytes[0], 8); }

    function packU8(n) { return [n & 0xff]; }
    function unpackU8(bytes) { return as_unsigned(bytes[0], 8); }

    function packU8Clamped(n) { n = round(Number(n)); return [n < 0 ? 0 : n > 0xff ? 0xff : n & 0xff]; }

    function packI16(n) { return [n & 0xff, (n >> 8) & 0xff]; }
    function unpackI16(bytes) { return as_signed(bytes[1] << 8 | bytes[0], 16); }

    function packU16(n) { return [n & 0xff, (n >> 8) & 0xff]; }
    function unpackU16(bytes) { return as_unsigned(bytes[1] << 8 | bytes[0], 16); }

    function packI32(n) { return [n & 0xff, (n >> 8) & 0xff, (n >> 16) & 0xff, (n >> 24) & 0xff]; }
    function unpackI32(bytes) { return as_signed(bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0], 32); }

    function packU32(n) { return [n & 0xff, (n >> 8) & 0xff, (n >> 16) & 0xff, (n >> 24) & 0xff]; }
    function unpackU32(bytes) { return as_unsigned(bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0], 32); }

    function packIEEE754(v, ebits, fbits) {

        var bias = (1 << (ebits - 1)) - 1;

        function roundToEven(n) {
            var w = floor(n), f = n - w;
            if (f < 0.5)
                return w;
            if (f > 0.5)
                return w + 1;
            return w % 2 ? w + 1 : w;
        }

        // Compute sign, exponent, fraction
        var s, e, f;
        if (v !== v) {
            // NaN
            // http://dev.w3.org/2006/webapi/WebIDL/#es-type-mapping
            e = (1 << ebits) - 1; f = pow(2, fbits - 1); s = 0;
        } else if (v === Infinity || v === -Infinity) {
            e = (1 << ebits) - 1; f = 0; s = (v < 0) ? 1 : 0;
        } else if (v === 0) {
            e = 0; f = 0; s = (1 / v === -Infinity) ? 1 : 0;
        } else {
            s = v < 0;
            v = abs(v);

            if (v >= pow(2, 1 - bias)) {
                // Normalized
                e = min(floor(log(v) / LN2), 1023);
                var significand = v / pow(2, e);
                if (significand < 1) {
                    e -= 1;
                    significand *= 2;
                }
                if (significand >= 2) {
                    e += 1;
                    significand /= 2;
                }
                var d = pow(2, fbits);
                f = roundToEven(significand * d) - d;
                e += bias;
                if (f / d >= 1) {
                    e += 1;
                    f = 0;
                }
                if (e > 2 * bias) {
                    // Overflow
                    e = (1 << ebits) - 1;
                    f = 0;
                }
            } else {
                // Denormalized
                e = 0;
                f = roundToEven(v / pow(2, 1 - bias - fbits));
            }
        }

        // Pack sign, exponent, fraction
        var bits = [], i;
        for (i = fbits; i; i -= 1) { bits.push(f % 2 ? 1 : 0); f = floor(f / 2); }
        for (i = ebits; i; i -= 1) { bits.push(e % 2 ? 1 : 0); e = floor(e / 2); }
        bits.push(s ? 1 : 0);
        bits.reverse();
        var str = bits.join('');

        // Bits to bytes
        var bytes = [];
        while (str.length) {
            bytes.unshift(parseInt(str.substring(0, 8), 2));
            str = str.substring(8);
        }
        return bytes;
    }

    function unpackIEEE754(bytes, ebits, fbits) {
        // Bytes to bits
        var bits = [], i, j, b, str,
            bias, s, e, f;

        for (i = 0; i < bytes.length; ++i) {
            b = bytes[i];
            for (j = 8; j; j -= 1) {
                bits.push(b % 2 ? 1 : 0); b = b >> 1;
            }
        }
        bits.reverse();
        str = bits.join('');

        // Unpack sign, exponent, fraction
        bias = (1 << (ebits - 1)) - 1;
        s = parseInt(str.substring(0, 1), 2) ? -1 : 1;
        e = parseInt(str.substring(1, 1 + ebits), 2);
        f = parseInt(str.substring(1 + ebits), 2);

        // Produce number
        if (e === (1 << ebits) - 1) {
            return f !== 0 ? NaN : s * Infinity;
        } else if (e > 0) {
            // Normalized
            return s * pow(2, e - bias) * (1 + f / pow(2, fbits));
        } else if (f !== 0) {
            // Denormalized
            return s * pow(2, -(bias - 1)) * (f / pow(2, fbits));
        } else {
            return s < 0 ? -0 : 0;
        }
    }

    function unpackF64(b) { return unpackIEEE754(b, 11, 52); }
    function packF64(v) { return packIEEE754(v, 11, 52); }
    function unpackF32(b) { return unpackIEEE754(b, 8, 23); }
    function packF32(v) { return packIEEE754(v, 8, 23); }

    //
    // 3 The ArrayBuffer Type
    //

    (function() {

        function ArrayBuffer(length) {
            length = ToInt32(length);
            if (length < 0) throw RangeError('ArrayBuffer size is not a small enough positive integer.');
            Object.defineProperty(this, 'byteLength', {value: length});
            Object.defineProperty(this, '_bytes', {value: Array(length)});

            for (var i = 0; i < length; i += 1)
                this._bytes[i] = 0;
        }

        global.ArrayBuffer = global.ArrayBuffer || ArrayBuffer;

        //
        // 5 The Typed Array View Types
        //

        function $TypedArray$() {

            // %TypedArray% ( length )
            if (!arguments.length || typeof arguments[0] !== 'object') {
                return (function(length) {
                    length = ToInt32(length);
                    if (length < 0) throw RangeError('length is not a small enough positive integer.');
                    Object.defineProperty(this, 'length', {value: length});
                    Object.defineProperty(this, 'byteLength', {value: length * this.BYTES_PER_ELEMENT});
                    Object.defineProperty(this, 'buffer', {value: new ArrayBuffer(this.byteLength)});
                    Object.defineProperty(this, 'byteOffset', {value: 0});

                }).apply(this, arguments);
            }

            // %TypedArray% ( typedArray )
            if (arguments.length >= 1 &&
                Type(arguments[0]) === 'object' &&
                arguments[0] instanceof $TypedArray$) {
                return (function(typedArray){
                    if (this.constructor !== typedArray.constructor) throw TypeError();

                    var byteLength = typedArray.length * this.BYTES_PER_ELEMENT;
                    Object.defineProperty(this, 'buffer', {value: new ArrayBuffer(byteLength)});
                    Object.defineProperty(this, 'byteLength', {value: byteLength});
                    Object.defineProperty(this, 'byteOffset', {value: 0});
                    Object.defineProperty(this, 'length', {value: typedArray.length});

                    for (var i = 0; i < this.length; i += 1)
                        this._setter(i, typedArray._getter(i));

                }).apply(this, arguments);
            }

            // %TypedArray% ( array )
            if (arguments.length >= 1 &&
                Type(arguments[0]) === 'object' &&
                !(arguments[0] instanceof $TypedArray$) &&
                !(arguments[0] instanceof ArrayBuffer || Class(arguments[0]) === 'ArrayBuffer')) {
                return (function(array) {

                    var byteLength = array.length * this.BYTES_PER_ELEMENT;
                    Object.defineProperty(this, 'buffer', {value: new ArrayBuffer(byteLength)});
                    Object.defineProperty(this, 'byteLength', {value: byteLength});
                    Object.defineProperty(this, 'byteOffset', {value: 0});
                    Object.defineProperty(this, 'length', {value: array.length});

                    for (var i = 0; i < this.length; i += 1) {
                        var s = array[i];
                        this._setter(i, Number(s));
                    }
                }).apply(this, arguments);
            }

            // %TypedArray% ( buffer, byteOffset=0, length=undefined )
            if (arguments.length >= 1 &&
                Type(arguments[0]) === 'object' &&
                (arguments[0] instanceof ArrayBuffer || Class(arguments[0]) === 'ArrayBuffer')) {
                return (function(buffer, byteOffset, length) {

                    byteOffset = ToUint32(byteOffset);
                    if (byteOffset > buffer.byteLength)
                        throw RangeError('byteOffset out of range');

                    // The given byteOffset must be a multiple of the element
                    // size of the specific type, otherwise an exception is raised.
                    if (byteOffset % this.BYTES_PER_ELEMENT)
                        throw RangeError('buffer length minus the byteOffset is not a multiple of the element size.');

                    if (length === undefined) {
                        var byteLength = buffer.byteLength - byteOffset;
                        if (byteLength % this.BYTES_PER_ELEMENT)
                            throw RangeError('length of buffer minus byteOffset not a multiple of the element size');
                        length = byteLength / this.BYTES_PER_ELEMENT;

                    } else {
                        length = ToUint32(length);
                        byteLength = length * this.BYTES_PER_ELEMENT;
                    }

                    if ((byteOffset + byteLength) > buffer.byteLength)
                        throw RangeError('byteOffset and length reference an area beyond the end of the buffer');

                    Object.defineProperty(this, 'buffer', {value: buffer});
                    Object.defineProperty(this, 'byteLength', {value: byteLength});
                    Object.defineProperty(this, 'byteOffset', {value: byteOffset});
                    Object.defineProperty(this, 'length', {value: length});

                }).apply(this, arguments);
            }

            // %TypedArray% ( all other argument combinations )
            throw TypeError();
        }

        // Properties of the %TypedArray Instrinsic Object

        // %TypedArray%.from ( source , mapfn=undefined, thisArg=undefined )
        Object.defineProperty($TypedArray$, 'from', {value: function(iterable) {
            return new this(iterable);
        }});

        // %TypedArray%.of ( ...items )
        Object.defineProperty($TypedArray$, 'of', {value: function(/*...items*/) {
            return new this(arguments);
        }});

        // %TypedArray%.prototype
        var $TypedArrayPrototype$ = {};
        $TypedArray$.prototype = $TypedArrayPrototype$;

        // WebIDL: getter type (unsigned long index);
        Object.defineProperty($TypedArray$.prototype, '_getter', {value: function(index) {
            if (arguments.length < 1) throw SyntaxError('Not enough arguments');

            index = ToUint32(index);
            if (index >= this.length)
                return undefined;

            var bytes = [], i, o;
            for (i = 0, o = this.byteOffset + index * this.BYTES_PER_ELEMENT;
                 i < this.BYTES_PER_ELEMENT;
                 i += 1, o += 1) {
                bytes.push(this.buffer._bytes[o]);
            }
            return this._unpack(bytes);
        }});

        // NONSTANDARD: convenience alias for getter: type get(unsigned long index);
        Object.defineProperty($TypedArray$.prototype, 'get', {value: $TypedArray$.prototype._getter});

        // WebIDL: setter void (unsigned long index, type value);
        Object.defineProperty($TypedArray$.prototype, '_setter', {value: function(index, value) {
            if (arguments.length < 2) throw SyntaxError('Not enough arguments');

            index = ToUint32(index);
            if (index >= this.length)
                return;

            var bytes = this._pack(value), i, o;
            for (i = 0, o = this.byteOffset + index * this.BYTES_PER_ELEMENT;
                 i < this.BYTES_PER_ELEMENT;
                 i += 1, o += 1) {
                this.buffer._bytes[o] = bytes[i];
            }
        }});

        // get %TypedArray%.prototype.buffer
        // get %TypedArray%.prototype.byteLength
        // get %TypedArray%.prototype.byteOffset
        // -- applied directly to the object in the constructor

        // %TypedArray%.prototype.constructor
        Object.defineProperty($TypedArray$.prototype, 'constructor', {value: $TypedArray$});

        // %TypedArray%.prototype.copyWithin (target, start, end = this.length )
        Object.defineProperty($TypedArray$.prototype, 'copyWithin', {value: function(target, start) {
            var end = arguments[2];

            var o = ToObject(this);
            var lenVal = o.length;
            var len = ToUint32(lenVal);
            len = max(len, 0);
            var relativeTarget = ToInt32(target);
            var to;
            if (relativeTarget < 0)
                to = max(len + relativeTarget, 0);
            else
                to = min(relativeTarget, len);
            var relativeStart = ToInt32(start);
            var from;
            if (relativeStart < 0)
                from = max(len + relativeStart, 0);
            else
                from = min(relativeStart, len);
            var relativeEnd;
            if (end === undefined)
                relativeEnd = len;
            else
                relativeEnd = ToInt32(end);
            var final;
            if (relativeEnd < 0)
                final = max(len + relativeEnd, 0);
            else
                final = min(relativeEnd, len);
            var count = min(final - from, len - to);
            var direction;
            if (from < to && to < from + count) {
                direction = -1;
                from = from + count - 1;
                to = to + count - 1;
            } else {
                direction = 1;
            }
            while (count > 0) {
                o._setter(to, o._getter(from));
                from = from + direction;
                to = to + direction;
                count = count - 1;
            }
            return o;
        }});

        // %TypedArray%.prototype.entries ( )
        // -- defined in es6.js to shim browsers w/ native TypedArrays

        // %TypedArray%.prototype.every ( callbackfn, thisArg = undefined )
        Object.defineProperty($TypedArray$.prototype, 'every', {value: function(callbackfn) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (!IsCallable(callbackfn)) throw TypeError();
            var thisArg = arguments[1];
            for (var i = 0; i < len; i++) {
                if (!callbackfn.call(thisArg, t._getter(i), i, t))
                    return false;
            }
            return true;
        }});

        // %TypedArray%.prototype.fill (value, start = 0, end = this.length )
        Object.defineProperty($TypedArray$.prototype, 'fill', {value: function(value) {
            var start = arguments[1],
                end = arguments[2];

            var o = ToObject(this);
            var lenVal = o.length;
            var len = ToUint32(lenVal);
            len = max(len, 0);
            var relativeStart = ToInt32(start);
            var k;
            if (relativeStart < 0)
                k = max((len + relativeStart), 0);
            else
                k = min(relativeStart, len);
            var relativeEnd;
            if (end === undefined)
                relativeEnd = len;
            else
                relativeEnd = ToInt32(end);
            var final;
            if (relativeEnd < 0)
                final = max((len + relativeEnd), 0);
            else
                final = min(relativeEnd, len);
            while (k < final) {
                o._setter(k, value);
                k += 1;
            }
            return o;
        }});

        // %TypedArray%.prototype.filter ( callbackfn, thisArg = undefined )
        Object.defineProperty($TypedArray$.prototype, 'filter', {value: function(callbackfn) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (!IsCallable(callbackfn)) throw TypeError();
            var res = [];
            var thisp = arguments[1];
            for (var i = 0; i < len; i++) {
                var val = t._getter(i); // in case fun mutates this
                if (callbackfn.call(thisp, val, i, t))
                    res.push(val);
            }
            return new this.constructor(res);
        }});

        // %TypedArray%.prototype.find (predicate, thisArg = undefined)
        Object.defineProperty($TypedArray$.prototype, 'find', {value: function(predicate) {
            var o = ToObject(this);
            var lenValue = o.length;
            var len = ToUint32(lenValue);
            if (!IsCallable(predicate)) throw TypeError();
            var t = arguments.length > 1 ? arguments[1] : undefined;
            var k = 0;
            while (k < len) {
                var kValue = o._getter(k);
                var testResult = predicate.call(t, kValue, k, o);
                if (Boolean(testResult))
                    return kValue;
                ++k;
            }
            return undefined;
        }});

        // %TypedArray%.prototype.findIndex ( predicate, thisArg = undefined )
        Object.defineProperty($TypedArray$.prototype, 'findIndex', {value: function(predicate) {
            var o = ToObject(this);
            var lenValue = o.length;
            var len = ToUint32(lenValue);
            if (!IsCallable(predicate)) throw TypeError();
            var t = arguments.length > 1 ? arguments[1] : undefined;
            var k = 0;
            while (k < len) {
                var kValue = o._getter(k);
                var testResult = predicate.call(t, kValue, k, o);
                if (Boolean(testResult))
                    return k;
                ++k;
            }
            return -1;
        }});

        // %TypedArray%.prototype.forEach ( callbackfn, thisArg = undefined )
        Object.defineProperty($TypedArray$.prototype, 'forEach', {value: function(callbackfn) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (!IsCallable(callbackfn)) throw TypeError();
            var thisp = arguments[1];
            for (var i = 0; i < len; i++)
                callbackfn.call(thisp, t._getter(i), i, t);
        }});

        // %TypedArray%.prototype.indexOf (searchElement, fromIndex = 0 )
        Object.defineProperty($TypedArray$.prototype, 'indexOf', {value: function(searchElement) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (len === 0) return -1;
            var n = 0;
            if (arguments.length > 0) {
                n = Number(arguments[1]);
                if (n !== n) {
                    n = 0;
                } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
                    n = (n > 0 || -1) * floor(abs(n));
                }
            }
            if (n >= len) return -1;
            var k = n >= 0 ? n : max(len - abs(n), 0);
            for (; k < len; k++) {
                if (t._getter(k) === searchElement) {
                    return k;
                }
            }
            return -1;
        }});

        // %TypedArray%.prototype.join ( separator )
        Object.defineProperty($TypedArray$.prototype, 'join', {value: function(separator) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            var tmp = Array(len);
            for (var i = 0; i < len; ++i)
                tmp[i] = t._getter(i);
            return tmp.join(separator === undefined ? ',' : separator); // Hack for IE7
        }});

        // %TypedArray%.prototype.keys ( )
        // -- defined in es6.js to shim browsers w/ native TypedArrays

        // %TypedArray%.prototype.lastIndexOf ( searchElement, fromIndex = this.length-1 )
        Object.defineProperty($TypedArray$.prototype, 'lastIndexOf', {value: function(searchElement) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (len === 0) return -1;
            var n = len;
            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n !== n) {
                    n = 0;
                } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
                    n = (n > 0 || -1) * floor(abs(n));
                }
            }
            var k = n >= 0 ? min(n, len - 1) : len - abs(n);
            for (; k >= 0; k--) {
                if (t._getter(k) === searchElement)
                    return k;
            }
            return -1;
        }});

        // get %TypedArray%.prototype.length
        // -- applied directly to the object in the constructor

        // %TypedArray%.prototype.map ( callbackfn, thisArg = undefined )
        Object.defineProperty($TypedArray$.prototype, 'map', {value: function(callbackfn) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (!IsCallable(callbackfn)) throw TypeError();
            var res = []; res.length = len;
            var thisp = arguments[1];
            for (var i = 0; i < len; i++)
                res[i] = callbackfn.call(thisp, t._getter(i), i, t);
            return new this.constructor(res);
        }});

        // %TypedArray%.prototype.reduce ( callbackfn [, initialValue] )
        Object.defineProperty($TypedArray$.prototype, 'reduce', {value: function(callbackfn) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (!IsCallable(callbackfn)) throw TypeError();
            // no value to return if no initial value and an empty array
            if (len === 0 && arguments.length === 1) throw TypeError();
            var k = 0;
            var accumulator;
            if (arguments.length >= 2) {
                accumulator = arguments[1];
            } else {
                accumulator = t._getter(k++);
            }
            while (k < len) {
                accumulator = callbackfn.call(undefined, accumulator, t._getter(k), k, t);
                k++;
            }
            return accumulator;
        }});

        // %TypedArray%.prototype.reduceRight ( callbackfn [, initialValue] )
        Object.defineProperty($TypedArray$.prototype, 'reduceRight', {value: function(callbackfn) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (!IsCallable(callbackfn)) throw TypeError();
            // no value to return if no initial value, empty array
            if (len === 0 && arguments.length === 1) throw TypeError();
            var k = len - 1;
            var accumulator;
            if (arguments.length >= 2) {
                accumulator = arguments[1];
            } else {
                accumulator = t._getter(k--);
            }
            while (k >= 0) {
                accumulator = callbackfn.call(undefined, accumulator, t._getter(k), k, t);
                k--;
            }
            return accumulator;
        }});

        // %TypedArray%.prototype.reverse ( )
        Object.defineProperty($TypedArray$.prototype, 'reverse', {value: function() {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            var half = floor(len / 2);
            for (var i = 0, j = len - 1; i < half; ++i, --j) {
                var tmp = t._getter(i);
                t._setter(i, t._getter(j));
                t._setter(j, tmp);
            }
            return t;
        }});

        // %TypedArray%.prototype.set(array, offset = 0 )
        // %TypedArray%.prototype.set(typedArray, offset = 0 )
        // WebIDL: void set(TypedArray array, optional unsigned long offset);
        // WebIDL: void set(sequence<type> array, optional unsigned long offset);
        Object.defineProperty($TypedArray$.prototype, 'set', {value: function(index, value) {
            if (arguments.length < 1) throw SyntaxError('Not enough arguments');
            var array, sequence, offset, len,
                i, s, d,
                byteOffset, byteLength, tmp;

            if (typeof arguments[0] === 'object' && arguments[0].constructor === this.constructor) {
                // void set(TypedArray array, optional unsigned long offset);
                array = arguments[0];
                offset = ToUint32(arguments[1]);

                if (offset + array.length > this.length) {
                    throw RangeError('Offset plus length of array is out of range');
                }

                byteOffset = this.byteOffset + offset * this.BYTES_PER_ELEMENT;
                byteLength = array.length * this.BYTES_PER_ELEMENT;

                if (array.buffer === this.buffer) {
                    tmp = [];
                    for (i = 0, s = array.byteOffset; i < byteLength; i += 1, s += 1) {
                        tmp[i] = array.buffer._bytes[s];
                    }
                    for (i = 0, d = byteOffset; i < byteLength; i += 1, d += 1) {
                        this.buffer._bytes[d] = tmp[i];
                    }
                } else {
                    for (i = 0, s = array.byteOffset, d = byteOffset;
                         i < byteLength; i += 1, s += 1, d += 1) {
                        this.buffer._bytes[d] = array.buffer._bytes[s];
                    }
                }
            } else if (typeof arguments[0] === 'object' && typeof arguments[0].length !== 'undefined') {
                // void set(sequence<type> array, optional unsigned long offset);
                sequence = arguments[0];
                len = ToUint32(sequence.length);
                offset = ToUint32(arguments[1]);

                if (offset + len > this.length) {
                    throw RangeError('Offset plus length of array is out of range');
                }

                for (i = 0; i < len; i += 1) {
                    s = sequence[i];
                    this._setter(offset + i, Number(s));
                }
            } else {
                throw TypeError('Unexpected argument type(s)');
            }
        }});

        // %TypedArray%.prototype.slice ( start, end )
        Object.defineProperty($TypedArray$.prototype, 'slice', {value: function(start, end) {
            var o = ToObject(this);
            var lenVal = o.length;
            var len = ToUint32(lenVal);
            var relativeStart = ToInt32(start);
            var k = (relativeStart < 0) ? max(len + relativeStart, 0) : min(relativeStart, len);
            var relativeEnd = (end === undefined) ? len : ToInt32(end);
            var final = (relativeEnd < 0) ? max(len + relativeEnd, 0) : min(relativeEnd, len);
            var count = final - k;
            var c = o.constructor;
            var a = new c(count);
            var n = 0;
            while (k < final) {
                var kValue = o._getter(k);
                a._setter(n, kValue);
                ++k;
                ++n;
            }
            return a;
        }});

        // %TypedArray%.prototype.some ( callbackfn, thisArg = undefined )
        Object.defineProperty($TypedArray$.prototype, 'some', {value: function(callbackfn) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            if (!IsCallable(callbackfn)) throw TypeError();
            var thisp = arguments[1];
            for (var i = 0; i < len; i++) {
                if (callbackfn.call(thisp, t._getter(i), i, t)) {
                    return true;
                }
            }
            return false;
        }});

        // %TypedArray%.prototype.sort ( comparefn )
        Object.defineProperty($TypedArray$.prototype, 'sort', {value: function(comparefn) {
            if (this === undefined || this === null) throw TypeError();
            var t = Object(this);
            var len = ToUint32(t.length);
            var tmp = Array(len);
            for (var i = 0; i < len; ++i)
                tmp[i] = t._getter(i);
            if (comparefn) tmp.sort(comparefn); else tmp.sort(); // Hack for IE8/9
            for (i = 0; i < len; ++i)
                t._setter(i, tmp[i]);
            return t;
        }});

        // %TypedArray%.prototype.subarray(begin = 0, end = this.length )
        // WebIDL: TypedArray subarray(long begin, optional long end);
        Object.defineProperty($TypedArray$.prototype, 'subarray', {value: function(start, end) {
            function clamp(v, min, max) { return v < min ? min : v > max ? max : v; }

            start = ToInt32(start);
            end = ToInt32(end);

            if (arguments.length < 1) { start = 0; }
            if (arguments.length < 2) { end = this.length; }

            if (start < 0) { start = this.length + start; }
            if (end < 0) { end = this.length + end; }

            start = clamp(start, 0, this.length);
            end = clamp(end, 0, this.length);

            var len = end - start;
            if (len < 0) {
                len = 0;
            }

            return new this.constructor(
                this.buffer, this.byteOffset + start * this.BYTES_PER_ELEMENT, len);
        }});

        // %TypedArray%.prototype.toLocaleString ( )
        // %TypedArray%.prototype.toString ( )
        // %TypedArray%.prototype.values ( )
        // %TypedArray%.prototype [ @@iterator ] ( )
        // get %TypedArray%.prototype [ @@toStringTag ]
        // -- defined in es6.js to shim browsers w/ native TypedArrays

        function makeTypedArray(elementSize, pack, unpack) {
            // Each TypedArray type requires a distinct constructor instance with
            // identical logic, which this produces.
            var TypedArray = function() {
                Object.defineProperty(this, 'constructor', {value: TypedArray});
                $TypedArray$.apply(this, arguments);
                makeArrayAccessors(this);
            };
            if ('__proto__' in TypedArray) {
                TypedArray.__proto__ = $TypedArray$;
            } else {
                TypedArray.from = $TypedArray$.from;
                TypedArray.of = $TypedArray$.of;
            }

            TypedArray.BYTES_PER_ELEMENT = elementSize;

            var TypedArrayPrototype = function() {};
            TypedArrayPrototype.prototype = $TypedArrayPrototype$;

            TypedArray.prototype = new TypedArrayPrototype();

            Object.defineProperty(TypedArray.prototype, 'BYTES_PER_ELEMENT', {value: elementSize});
            Object.defineProperty(TypedArray.prototype, '_pack', {value: pack});
            Object.defineProperty(TypedArray.prototype, '_unpack', {value: unpack});

            return TypedArray;
        }

        var Int8Array = makeTypedArray(1, packI8, unpackI8);
        var Uint8Array = makeTypedArray(1, packU8, unpackU8);
        var Uint8ClampedArray = makeTypedArray(1, packU8Clamped, unpackU8);
        var Int16Array = makeTypedArray(2, packI16, unpackI16);
        var Uint16Array = makeTypedArray(2, packU16, unpackU16);
        var Int32Array = makeTypedArray(4, packI32, unpackI32);
        var Uint32Array = makeTypedArray(4, packU32, unpackU32);
        var Float32Array = makeTypedArray(4, packF32, unpackF32);
        var Float64Array = makeTypedArray(8, packF64, unpackF64);

        global.Int8Array = global.Int8Array || Int8Array;
        global.Uint8Array = global.Uint8Array || Uint8Array;
        global.Uint8ClampedArray = global.Uint8ClampedArray || Uint8ClampedArray;
        global.Int16Array = global.Int16Array || Int16Array;
        global.Uint16Array = global.Uint16Array || Uint16Array;
        global.Int32Array = global.Int32Array || Int32Array;
        global.Uint32Array = global.Uint32Array || Uint32Array;
        global.Float32Array = global.Float32Array || Float32Array;
        global.Float64Array = global.Float64Array || Float64Array;
    }());

    //
    // 6 The DataView View Type
    //

    (function() {
        function r(array, index) {
            return IsCallable(array.get) ? array.get(index) : array[index];
        }

        var IS_BIG_ENDIAN = (function() {
            var u16array = new Uint16Array([0x1234]),
                u8array = new Uint8Array(u16array.buffer);
            return r(u8array, 0) === 0x12;
        }());

        // DataView(buffer, byteOffset=0, byteLength=undefined)
        // WebIDL: Constructor(ArrayBuffer buffer,
        //                     optional unsigned long byteOffset,
        //                     optional unsigned long byteLength)
        function DataView(buffer, byteOffset, byteLength) {
            if (!(buffer instanceof ArrayBuffer || Class(buffer) === 'ArrayBuffer')) throw TypeError();

            byteOffset = ToUint32(byteOffset);
            if (byteOffset > buffer.byteLength)
                throw RangeError('byteOffset out of range');

            if (byteLength === undefined)
                byteLength = buffer.byteLength - byteOffset;
            else
                byteLength = ToUint32(byteLength);

            if ((byteOffset + byteLength) > buffer.byteLength)
                throw RangeError('byteOffset and length reference an area beyond the end of the buffer');

            Object.defineProperty(this, 'buffer', {value: buffer});
            Object.defineProperty(this, 'byteLength', {value: byteLength});
            Object.defineProperty(this, 'byteOffset', {value: byteOffset});
        };

        // get DataView.prototype.buffer
        // get DataView.prototype.byteLength
        // get DataView.prototype.byteOffset
        // -- applied directly to instances by the constructor

        function makeGetter(arrayType) {
            return function GetViewValue(byteOffset, littleEndian) {
                byteOffset = ToUint32(byteOffset);

                if (byteOffset + arrayType.BYTES_PER_ELEMENT > this.byteLength)
                    throw RangeError('Array index out of range');

                byteOffset += this.byteOffset;

                var uint8Array = new Uint8Array(this.buffer, byteOffset, arrayType.BYTES_PER_ELEMENT),
                    bytes = [];
                for (var i = 0; i < arrayType.BYTES_PER_ELEMENT; i += 1)
                    bytes.push(r(uint8Array, i));

                if (Boolean(littleEndian) === Boolean(IS_BIG_ENDIAN))
                    bytes.reverse();

                return r(new arrayType(new Uint8Array(bytes).buffer), 0);
            };
        }

        Object.defineProperty(DataView.prototype, 'getUint8', {value: makeGetter(Uint8Array)});
        Object.defineProperty(DataView.prototype, 'getInt8', {value: makeGetter(Int8Array)});
        Object.defineProperty(DataView.prototype, 'getUint16', {value: makeGetter(Uint16Array)});
        Object.defineProperty(DataView.prototype, 'getInt16', {value: makeGetter(Int16Array)});
        Object.defineProperty(DataView.prototype, 'getUint32', {value: makeGetter(Uint32Array)});
        Object.defineProperty(DataView.prototype, 'getInt32', {value: makeGetter(Int32Array)});
        Object.defineProperty(DataView.prototype, 'getFloat32', {value: makeGetter(Float32Array)});
        Object.defineProperty(DataView.prototype, 'getFloat64', {value: makeGetter(Float64Array)});

        function makeSetter(arrayType) {
            return function SetViewValue(byteOffset, value, littleEndian) {
                byteOffset = ToUint32(byteOffset);
                if (byteOffset + arrayType.BYTES_PER_ELEMENT > this.byteLength)
                    throw RangeError('Array index out of range');

                // Get bytes
                var typeArray = new arrayType([value]),
                    byteArray = new Uint8Array(typeArray.buffer),
                    bytes = [], i, byteView;

                for (i = 0; i < arrayType.BYTES_PER_ELEMENT; i += 1)
                    bytes.push(r(byteArray, i));

                // Flip if necessary
                if (Boolean(littleEndian) === Boolean(IS_BIG_ENDIAN))
                    bytes.reverse();

                // Write them
                byteView = new Uint8Array(this.buffer, byteOffset, arrayType.BYTES_PER_ELEMENT);
                byteView.set(bytes);
            };
        }

        Object.defineProperty(DataView.prototype, 'setUint8', {value: makeSetter(Uint8Array)});
        Object.defineProperty(DataView.prototype, 'setInt8', {value: makeSetter(Int8Array)});
        Object.defineProperty(DataView.prototype, 'setUint16', {value: makeSetter(Uint16Array)});
        Object.defineProperty(DataView.prototype, 'setInt16', {value: makeSetter(Int16Array)});
        Object.defineProperty(DataView.prototype, 'setUint32', {value: makeSetter(Uint32Array)});
        Object.defineProperty(DataView.prototype, 'setInt32', {value: makeSetter(Int32Array)});
        Object.defineProperty(DataView.prototype, 'setFloat32', {value: makeSetter(Float32Array)});
        Object.defineProperty(DataView.prototype, 'setFloat64', {value: makeSetter(Float64Array)});

        global.DataView = global.DataView || DataView;

    }());

}(self));

/*
 Copyright 2015 Google Inc. All Rights Reserved.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

var DRIVE_UPLOAD_URL = 'https://www.googleapis.com/upload/drive/v2/files/';


/**
 * Helper for implementing retries with backoff. Initial retry
 * delay is 1 second, increasing by 2x (+jitter) for subsequent retries
 *
 * @constructor
 */
var RetryHandler = function() {
    this.interval = 1000; // Start at one second
    this.maxInterval = 60 * 1000; // Don't wait longer than a minute
};

/**
 * Invoke the function after waiting
 *
 * @param {function} fn Function to invoke
 */
RetryHandler.prototype.retry = function(fn) {
    setTimeout(fn, this.interval);
    this.interval = this.nextInterval_();
};

/**
 * Reset the counter (e.g. after successful request.)
 */
RetryHandler.prototype.reset = function() {
    this.interval = 1000;
};

/**
 * Calculate the next wait time.
 * @return {number} Next wait interval, in milliseconds
 *
 * @private
 */
RetryHandler.prototype.nextInterval_ = function() {
    var interval = this.interval * 2 + this.getRandomInt_(0, 1000);
    return Math.min(interval, this.maxInterval);
};

/**
 * Get a random int in the range of min to max. Used to add jitter to wait times.
 *
 * @param {number} min Lower bounds
 * @param {number} max Upper bounds
 * @private
 */
RetryHandler.prototype.getRandomInt_ = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
};


/**
 * Helper class for resumable uploads using XHR/CORS. Can upload any Blob-like item, whether
 * files or in-memory constructs.
 *
 * @example
 * var content = new Blob(["Hello world"], {"type": "text/plain"});
 * var uploader = new MediaUploader({
 *   file: content,
 *   token: accessToken,
 *   onComplete: function(data) { ... }
 *   onError: function(data) { ... }
 * });
 * uploader.upload();
 *
 * @constructor
 * @param {object} options Hash of options
 * @param {string} options.token Access token
 * @param {blob} options.file Blob-like item to upload
 * @param {string} [options.fileId] ID of file if replacing
 * @param {object} [options.params] Additional query parameters
 * @param {string} [options.contentType] Content-type, if overriding the type of the blob.
 * @param {object} [options.metadata] File metadata
 * @param {function} [options.onComplete] Callback for when upload is complete
 * @param {function} [options.onProgress] Callback for status for the in-progress upload
 * @param {function} [options.onError] Callback if upload fails
 */
var MediaUploader = function(options) {
    var noop = function() {};
    this.file = options.file;
    this.contentType = options.contentType || this.file.type || 'application/octet-stream';
    this.metadata = options.metadata || {
        'title': this.file.name,
        'mimeType': this.contentType
    };
    this.token = options.token;
    this.onComplete = options.onComplete || noop;
    this.onProgress = options.onProgress || noop;
    this.onError = options.onError || noop;
    this.offset = options.offset || 0;
    this.chunkSize = options.chunkSize || 0;
    this.retryHandler = new RetryHandler();

    this.url = options.url;
    if (!this.url) {
        var params = options.params || {};
        params.uploadType = 'resumable';
        this.url = this.buildUrl_(options.fileId, params, options.baseUrl);
    }
    this.httpMethod = options.fileId ? 'PUT' : 'POST';
};

/**
 * Initiate the upload.
 */
MediaUploader.prototype.upload = function() {
    var self = this;
    var xhr = new XMLHttpRequest();

    xhr.open(this.httpMethod, this.url, true);
    xhr.setRequestHeader('Authorization', 'Bearer ' + this.token);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Upload-Content-Length', this.file.size);
    xhr.setRequestHeader('X-Upload-Content-Type', this.contentType);

    xhr.onload = function(e) {
        if (e.target.status < 400) {
            var location = e.target.getResponseHeader('Location');
            this.url = location;
            this.sendFile_();
        } else {
            this.onUploadError_(e);
        }
    }.bind(this);
    xhr.onerror = this.onUploadError_.bind(this);
    xhr.send(JSON.stringify(this.metadata));
};

/**
 * Send the actual file content.
 *
 * @private
 */
MediaUploader.prototype.sendFile_ = function() {
    var content = this.file;
    var end = this.file.size;

    if (this.offset || this.chunkSize) {
        // Only bother to slice the file if we're either resuming or uploading in chunks
        if (this.chunkSize) {
            end = Math.min(this.offset + this.chunkSize, this.file.size);
        }
        content = content.slice(this.offset, end);
    }

    var xhr = new XMLHttpRequest();
    xhr.open('PUT', this.url, true);
    xhr.setRequestHeader('Content-Type', this.contentType);
    xhr.setRequestHeader('Content-Range', 'bytes ' + this.offset + '-' + (end - 1) + '/' + this.file.size);
    xhr.setRequestHeader('X-Upload-Content-Type', this.file.type);
    if (xhr.upload) {
        xhr.upload.addEventListener('progress', this.onProgress);
    }
    xhr.onload = this.onContentUploadSuccess_.bind(this);
    xhr.onerror = this.onContentUploadError_.bind(this);
    xhr.send(content);
};

/**
 * Query for the state of the file for resumption.
 *
 * @private
 */
MediaUploader.prototype.resume_ = function() {
    var xhr = new XMLHttpRequest();
    xhr.open('PUT', this.url, true);
    xhr.setRequestHeader('Content-Range', 'bytes */' + this.file.size);
    xhr.setRequestHeader('X-Upload-Content-Type', this.file.type);
    if (xhr.upload) {
        xhr.upload.addEventListener('progress', this.onProgress);
    }
    xhr.onload = this.onContentUploadSuccess_.bind(this);
    xhr.onerror = this.onContentUploadError_.bind(this);
    xhr.send();
};

/**
 * Extract the last saved range if available in the request.
 *
 * @param {XMLHttpRequest} xhr Request object
 */
MediaUploader.prototype.extractRange_ = function(xhr) {
    var range = xhr.getResponseHeader('Range');
    if (range) {
        this.offset = parseInt(range.match(/\d+/g).pop(), 10) + 1;
    }
};

/**
 * Handle successful responses for uploads. Depending on the context,
 * may continue with uploading the next chunk of the file or, if complete,
 * invokes the caller's callback.
 *
 * @private
 * @param {object} e XHR event
 */
MediaUploader.prototype.onContentUploadSuccess_ = function(e) {
    if (e.target.status == 200 || e.target.status == 201) {
        this.onComplete(e.target.response);
    } else if (e.target.status == 308) {
        this.extractRange_(e.target);
        this.retryHandler.reset();
        this.sendFile_();
    }
};

/**
 * Handles errors for uploads. Either retries or aborts depending
 * on the error.
 *
 * @private
 * @param {object} e XHR event
 */
MediaUploader.prototype.onContentUploadError_ = function(e) {
    if (e.target.status && e.target.status < 500) {
        this.onError(e.target.response);
    } else {
        this.retryHandler.retry(this.resume_.bind(this));
    }
};

/**
 * Handles errors for the initial request.
 *
 * @private
 * @param {object} e XHR event
 */
MediaUploader.prototype.onUploadError_ = function(e) {
    this.onError(e.target.response); // TODO - Retries for initial upload
};

/**
 * Construct a query string from a hash/object
 *
 * @private
 * @param {object} [params] Key/value pairs for query string
 * @return {string} query string
 */
MediaUploader.prototype.buildQuery_ = function(params) {
    params = params || {};
    return Object.keys(params).map(function(key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
};

/**
 * Build the drive upload URL
 *
 * @private
 * @param {string} [id] File ID if replacing
 * @param {object} [params] Query parameters
 * @return {string} URL
 */
MediaUploader.prototype.buildUrl_ = function(id, params, baseUrl) {
    var url = baseUrl || DRIVE_UPLOAD_URL;
    if (id) {
        url += id;
    }
    var query = this.buildQuery_(params);
    if (query) {
        url += '?' + query;
    }
    return url;
};

/**~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Youtube Upload Directive -
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
angular.module('ng-youtube-upload', [
    'ngAnimate',
    'ngFileUpload',
    'mgcrea.ngStrap'
])
    .run(['$window', '$rootScope', function ($window, $rootScope) {

        if (!angular.element('link#youtubeVideoCSS').length) {
            angular.element('head').append('<style id="youtubeVideoCSS">#channel-image{width:2em;height:2em;vertical-align:middle}#channel-name{margin-left:.2em;margin-right:.2em}#disclaimer{font-size:.75em;color:#aeaeae;max-width:350px}body{font-family:"Open Sans",sans-serif;font-size:1.5em}.post-sign-in{display:none}.during-upload{display:none}.post-upload{display:none}label{display:block}progress{font-size:.75em;width:15em;margin-bottom:1em;padding:.5em;font-family:"Open Sans",sans-serif}textarea{height:7em}.btn-file{position:relative;overflow:hidden}.btn-file input[type=file]{position:absolute;top:0;right:0;min-width:100%;min-height:100%;font-size:100px;text-align:right;filter:alpha(opacity=0);opacity:0;outline:none;background:#fff;cursor:inherit;display:block}</style>');
        }

        $window.signinCallback = function (authResult) {
            if (authResult && authResult.access_token) {
                $rootScope.$broadcast('event:google-plus-signin-success', authResult);
            } else {
                $rootScope.$broadcast('event:google-plus-signin-failure', authResult);
            }
        };

    }])
    .directive('youtubeUploader', ['$window', '$alert', function ($window, $alert) {
        'use strict';

        return {
            restrict: 'AE',
            templateUrl: "/templates/ng-youtube-upload.html",
            scope: {
                videoTitle: "@",
                videoDesc: "@"
            },
            link: function ($scope, $element, $attrs) {

                var STATUS_POLLING_INTERVAL_MILLIS = 10 * 1000; // One minute.
                var ending = /\.apps\.googleusercontent\.com$/;

                $attrs.clientid += (ending.test($attrs.clientid) ? '' : '.apps.googleusercontent.com');

                $attrs.$set('data-clientid', $attrs.clientid);
                $attrs.$set('theme', $attrs.theme);

                var status = {
                    init: 10,
                    uploading: 20,
                    processing: 30,
                    final: 40,
                    error: 50
                };

                var setStatus = function (newStatus, params) {
                    $scope.status = newStatus;
                    switch ($scope.status) {
                        case status.init:
                            break;
                        case status.uploading:
                            $scope.$emit('event:youtube-video-uploading');
                            $('#uploadButton').attr('disabled', true);
                            break;
                        case status.processing:
                            $scope.$emit('event:youtube-video-uploaded', params[0]);
                            break;
                        case status.final:
                            $scope.$emit('event:youtube-video-processed', params[0]);
                            $('#uploadButton').attr('disabled', false);
                            break;
                        case status.error:
                            $scope.$emit('event:youtube-video-failed', params[0]);
                            $('#uploadButton').attr('disabled', false);
                            break;
                    }
                };

                setStatus(status.init);

                // Some default values, based on prior versions of this directive
                var defaults = {
                    callback: 'signinCallback',
                    cookiepolicy: 'single_host_origin',
                    requestvisibleactions: 'http://schemas.google.com/AddActivity',
                    scope: 'https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube',
                    height: 'standard',
                    width: 'wide',
                    state: '',
                    showprivacy: false,
                    videoTitle: "Upload a Video",
                    clientid: "YOUR CLIENT ID HERE"
                };

                defaults.clientid = $attrs.clientid;
                defaults.theme = $attrs.theme;

                // Overwrite default values if explicitly set
                angular.forEach(Object.getOwnPropertyNames(defaults), function (propName) {
                    if ($attrs.hasOwnProperty(propName)) {
                        defaults[propName] = $attrs[propName];
                    }
                });

                $scope.displayUploader = false;
                $scope.videoFile = null;
                $scope.videoName = "";

                $scope.$watch('videoFiles', function () {
                    if (($scope.videoFiles) && ($scope.videoFiles.length > 0)) {
                        $scope.videoFile = $scope.videoFiles[0];
                        $scope.videoName = $scope.videoFiles[0].name;
                    }
                });

                $scope.fileNameChanged = function (elem) {
                    $scope.videoFile = elem.files[0];
                    $scope.videoName = elem.files[0].name;
                    $scope.$apply();
                };


                // Default language
                // Supported languages: https://developers.google.com/+/web/api/supported-languages
                $attrs.$observe('language', function (value) {
                    $window.___gcfg = {
                        lang: value ? value : 'en'
                    };
                });

                // Asynchronously load the G+ SDK.
                var po = document.createElement('script');
                po.type = 'text/javascript';
                po.async = true;
                po.src = 'https://apis.google.com/js/client:plusone.js';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(po, s);

                po.onload = function () {
                    var anchor = document.createElement('span');
                    anchor.id = "signInButton";
                    $element.prepend(anchor);

                    gapi.signin.render(anchor, defaults);
                };

                $scope.$on('event:google-plus-signin-success', function (event, authResult) {
                    $('#signInButton').hide();
                    $scope.displayUploader = true;
                    $scope.$apply();
                    if (authResult.access_token) {
                        var uploadVideo = new UploadVideo();
                        uploadVideo.ready(authResult.access_token);
                    }
                });

                /**
                 * YouTube video uploader class
                 *
                 * @constructor
                 */
                var UploadVideo = function () {
                    /**
                     * The array of tags for the new YouTube video.
                     *
                     * @attribute tags
                     * @type Array.<string>
                     * @default ['google-cors-upload']
                     */
                    this.tags = ['youtube-cors-upload'];

                    /**
                     * The numeric YouTube
                     * [category id](https://developers.google.com/apis-explorer/#p/youtube/v3/youtube.videoCategories.list?part=snippet&regionCode=us).
                     *
                     * @attribute categoryId
                     * @type number
                     * @default 22
                     */
                    this.categoryId = 22;

                    /**
                     * The id of the new video.
                     *
                     * @attribute videoId
                     * @type string
                     * @default ''
                     */
                    this.videoId = '';

                    this.uploadStartTime = 0;
                };


                UploadVideo.prototype.ready = function (accessToken) {
                    this.accessToken = accessToken;
                    this.gapi = $window.gapi;
                    this.authenticated = true;
                    this.gapi.client.request({
                        path: '/youtube/v3/channels',
                        params: {
                            part: 'snippet',
                            mine: true
                        },
                        callback: function (response) {
                            if (response.error) {
                                console.log(response.error.message);
                            }
                        }.bind(this)
                    });
                    $('#uploadButton').on("click", this.handleUploadClicked.bind(this));
                };

                /**
                 * Uploads a video file to YouTube.
                 *
                 * @method uploadFile
                 * @param {object} file File object corresponding to the video to upload.
                 */
                UploadVideo.prototype.uploadFile = function (file) {
                    var metadata = {
                        snippet: {
                            title: $scope.videoTitle,
                            description: $scope.videoDesc,
                            tags: this.tags,
                            categoryId: this.categoryId
                        },
                        status: {
                            privacyStatus: "unlisted",
                            embeddable: true
                        }
                    };
                    var uploader = new MediaUploader({
                        baseUrl: 'https://www.googleapis.com/upload/youtube/v3/videos',
                        file: file,
                        token: this.accessToken,
                        metadata: metadata,
                        params: {
                            part: Object.keys(metadata).join(',')
                        },
                        //access_type: 'offline',
                        onError: function (data) {
                            var message = data;
                            // Assuming the error is raised by the YouTube API, data will be
                            // a JSON string with error.message set. That may not be the
                            // only time onError will be raised, though.
                            try {
                                var errorResponse = JSON.parse(data);
                                message = errorResponse.error.message;
                            } finally {
                                alert(message);
                            }
                        }.bind(this),
                        onProgress: function (data) {
                            var currentTime = Date.now();
                            var bytesUploaded = data.loaded;
                            var totalBytes = data.total;
                            // The times are in millis, so we need to divide by 1000 to get seconds.
                            var bytesPerSecond = bytesUploaded / ((currentTime - this.uploadStartTime) / 1000);
                            var estimatedSecondsRemaining = (totalBytes - bytesUploaded) / bytesPerSecond;
                            var percentageComplete = (bytesUploaded * 100) / totalBytes;

                            $('#upload-progress').attr({
                                value: bytesUploaded,
                                max: totalBytes
                            });

                            $('#transferred').css('width', percentageComplete.toFixed(2) + '%').attr('aria-valuenow', percentageComplete.toFixed(2)).text(bytesUploaded + " / " + totalBytes + "  (" + percentageComplete.toFixed(2) + "%)");
                            /*
                             $('#percent-transferred').text(percentageComplete.toFixed(2));
                             $('#bytes-transferred').text(bytesUploaded);
                             $('#total-bytes').text(totalBytes);*/

                            $('.during-upload').show();
                        }.bind(this),
                        onComplete: function (data) {
                            var uploadResponse = JSON.parse(data);
                            this.videoId = uploadResponse.id;
                            $('#video-id').text(this.videoId);
                            $('.post-upload').show();
                            this.pollForVideoStatus();
                        }.bind(this)
                    });
                    // This won't correspond to the *exact* start of the upload, but it should be close enough.
                    this.uploadStartTime = Date.now();
                    uploader.upload();
                };

                UploadVideo.prototype.handleUploadClicked = function () {

                    if ($scope.videoTitle == "") {
                        $alert({
                            content: "Please enter a title for your video.",
                            placement: 'top-right',
                            type: 'warning',
                            duration: 3
                        });
                    } else if ($scope.videoDesc == "") {
                        $alert({
                            content: "Please enter a description for your video.",
                            placement: 'top-right',
                            type: 'warning',
                            duration: 3
                        });
                    } else if ($scope.status == status.uploading) {
                        $alert({
                            content: "Please wait until your video has finished uploading before uploading another one.",
                            placement: 'top-right',
                            type: 'warning',
                            duration: 3
                        });
                    } else if ($scope.status == status.processing) {
                        $alert({
                            content: "Please wait until your video has finished processing before uploading another one.",
                            placement: 'top-right',
                            type: 'warning',
                            duration: 3
                        });
                    } else {
                        setStatus(status.uploading);
                        this.uploadFile($scope.videoFile);
                    }
                };

                UploadVideo.prototype.pollForVideoStatus = function () {
                    this.gapi.client.request({
                        path: '/youtube/v3/videos',
                        params: {
                            part: 'status,player',
                            id: this.videoId
                        },
                        callback: function (response) {
                            if (response.error) {
                                // The status polling failed.
                                console.log(response.error.message);
                                setTimeout(this.pollForVideoStatus.bind(this), STATUS_POLLING_INTERVAL_MILLIS);
                            } else {
                                var uploadStatus = response.items[0].status.uploadStatus;
                                switch (uploadStatus) {
                                    // This is a non-final status, so we need to poll again.
                                    case 'uploaded':
                                        setStatus(status.processing, [{
                                            id: response.items[0].id,
                                            type: response.items[0].kind
                                        }]);
                                        setTimeout(this.pollForVideoStatus.bind(this), STATUS_POLLING_INTERVAL_MILLIS);
                                        break;
                                    // The video was successfully transcoded and is available.
                                    case 'processed':
                                        setStatus(status.final, [{
                                            id: response.items[0].id,
                                            type: response.items[0].kind
                                        }]);
                                        break;
                                    // All other statuses indicate a permanent transcoding failure.
                                    default:
                                        setStatus(status.error, [{message: response.items[0].status.uploadStatus + ": " + response.items[0].status.rejectionReason}]);
                                        break;
                                }
                            }
                        }.bind(this)
                    });
                };
            }
        };
    }]);

angular.module("ng-youtube-upload").run(["$templateCache", function($templateCache) {$templateCache.put("/templates/ng-youtube-upload.html","<div data-ng-show=\"displayUploader\">\r\n    <div>\r\n        <div class=\'row\' style=\"padding-top: 15px;\">\r\n            <div class =\'col-md-12\'>\r\n                <div class=\"form-group drop-box\" style=\"padding-top: 10px;height:100px;\"\r\n                     ngf-drop\r\n                     data-ng-model=\"videoFiles\"\r\n                     ngf-accept=\"\'video/*\'\"\r\n                     ngf-drag-over-class=\"dragover\"\r\n                     ngf-multiple=\"false\"\r\n                        >\r\n                    <p>Choose a video from your computer: .MOV, .MPEG4, MP4, .AVI, .WMV, .MPEGPS, .FLV, 3GPP, WebM</p>\r\n                </div>\r\n                <div ngf-no-file-drop>File Drag/drop is not supported</div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"btn-group-vertical\">\r\n            <div class=\"input-group\">\r\n                <span class=\"input-group-btn\">\r\n                    <span class=\"btn btn-primary btn-file\" >\r\n                       <span class=\"glyphicon glyphicon-folder-open\"></span> Browse <input type=\"file\" id=\"file\" class=\"file\" accept=\"video/*\" onchange=\"angular.element(this).scope().fileNameChanged(this)\">\r\n                    </span>\r\n                </span>\r\n                <input type=\"text\" name=\"videoName\" class=\"form-control\" readonly value=\"{{videoName}}\">\r\n            </div>\r\n            <button type=\"button\" id=\"uploadButton\" class=\"btn btn-success\" data-ng-disabled=\"videoName == \'\'\"><span class=\"glyphicon glyphicon-upload\"></span> Upload Video</button>\r\n        </div>\r\n\r\n        <div class=\"during-upload\">\r\n            <div class=\"progress\">\r\n                <div id=\"transferred\" class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"{{progress.percentTransferred}}\"\r\n                     aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:100%\">\r\n                    {{progress.percentTransferred}}% Complete (success)\r\n                </div>\r\n            </div>\r\n\r\n            <div align=\"center\" class=\"embed-responsive embed-responsive-16by9\">\r\n                <video controls ngf-src=\"videoFile\" ngf-accept=\"\'video/*\'\"></video>\r\n            </div>\r\n        </div>\r\n        <p><small id=\"disclaimer\">* By uploading a video, you certify that you own all rights to the content or that you are\r\n            authorized by the owner to make the content publicly available on YouTube, and that it otherwise complies\r\n            with the YouTube Terms of Service located at <a href=\"http://www.youtube.com/t/terms\" target=\"_blank\">http://www.youtube.com/t/terms</a>\r\n        </small></p>\r\n    </div>\r\n\r\n    <script src=\"//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js\"></script>\r\n    <script src=\"//apis.google.com/js/client:plusone.js\"></script>\r\n</div>");}]);

/*
 * Copyright (c) 2010 Nick Galbreath
 * http://code.google.com/p/stringencoders/source/browse/#svn/trunk/javascript
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* base64 encode/decode compatible with window.btoa/atob
 *
 * window.atob/btoa is a Firefox extension to convert binary data (the "b")
 * to base64 (ascii, the "a").
 *
 * It is also found in Safari and Chrome.  It is not available in IE.
 *
 * if (!window.btoa) window.btoa = base64.encode
 * if (!window.atob) window.atob = base64.decode
 *
 * The original spec's for atob/btoa are a bit lacking
 * https://developer.mozilla.org/en/DOM/window.atob
 * https://developer.mozilla.org/en/DOM/window.btoa
 *
 * window.btoa and base64.encode takes a string where charCodeAt is [0,255]
 * If any character is not [0,255], then an DOMException(5) is thrown.
 *
 * window.atob and base64.decode take a base64-encoded string
 * If the input length is not a multiple of 4, or contains invalid characters
 *   then an DOMException(5) is thrown.
 */
var base64 = {};
base64.PADCHAR = '=';
base64.ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

base64.makeDOMException = function() {
    // sadly in FF,Safari,Chrome you can't make a DOMException
    var e, tmp;

    try {
        return new DOMException(DOMException.INVALID_CHARACTER_ERR);
    } catch (tmp) {
        // not available, just passback a duck-typed equiv
        // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error
        // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error/prototype
        var ex = new Error("DOM Exception 5");

        // ex.number and ex.description is IE-specific.
        ex.code = ex.number = 5;
        ex.name = ex.description = "INVALID_CHARACTER_ERR";

        // Safari/Chrome output format
        ex.toString = function() { return 'Error: ' + ex.name + ': ' + ex.message; };
        return ex;
    }
}

base64.getbyte64 = function(s,i) {
    // This is oddly fast, except on Chrome/V8.
    //  Minimal or no improvement in performance by using a
    //   object with properties mapping chars to value (eg. 'A': 0)
    var idx = base64.ALPHA.indexOf(s.charAt(i));
    if (idx === -1) {
        throw base64.makeDOMException();
    }
    return idx;
}

base64.decode = function(s) {
    // convert to string
    s = '' + s;
    var getbyte64 = base64.getbyte64;
    var pads, i, b10;
    var imax = s.length
    if (imax === 0) {
        return s;
    }

    if (imax % 4 !== 0) {
        throw base64.makeDOMException();
    }

    pads = 0
    if (s.charAt(imax - 1) === base64.PADCHAR) {
        pads = 1;
        if (s.charAt(imax - 2) === base64.PADCHAR) {
            pads = 2;
        }
        // either way, we want to ignore this last block
        imax -= 4;
    }

    var x = [];
    for (i = 0; i < imax; i += 4) {
        b10 = (getbyte64(s,i) << 18) | (getbyte64(s,i+1) << 12) |
            (getbyte64(s,i+2) << 6) | getbyte64(s,i+3);
        x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff, b10 & 0xff));
    }

    switch (pads) {
        case 1:
            b10 = (getbyte64(s,i) << 18) | (getbyte64(s,i+1) << 12) | (getbyte64(s,i+2) << 6);
            x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff));
            break;
        case 2:
            b10 = (getbyte64(s,i) << 18) | (getbyte64(s,i+1) << 12);
            x.push(String.fromCharCode(b10 >> 16));
            break;
    }
    return x.join('');
}

base64.getbyte = function(s,i) {
    var x = s.charCodeAt(i);
    if (x > 255) {
        throw base64.makeDOMException();
    }
    return x;
}

base64.encode = function(s) {
    if (arguments.length !== 1) {
        throw new SyntaxError("Not enough arguments");
    }
    var padchar = base64.PADCHAR;
    var alpha   = base64.ALPHA;
    var getbyte = base64.getbyte;

    var i, b10;
    var x = [];

    // convert to string
    s = '' + s;

    var imax = s.length - s.length % 3;

    if (s.length === 0) {
        return s;
    }
    for (i = 0; i < imax; i += 3) {
        b10 = (getbyte(s,i) << 16) | (getbyte(s,i+1) << 8) | getbyte(s,i+2);
        x.push(alpha.charAt(b10 >> 18));
        x.push(alpha.charAt((b10 >> 12) & 0x3F));
        x.push(alpha.charAt((b10 >> 6) & 0x3f));
        x.push(alpha.charAt(b10 & 0x3f));
    }
    switch (s.length - imax) {
        case 1:
            b10 = getbyte(s,i) << 16;
            x.push(alpha.charAt(b10 >> 18) + alpha.charAt((b10 >> 12) & 0x3F) +
                padchar + padchar);
            break;
        case 2:
            b10 = (getbyte(s,i) << 16) | (getbyte(s,i+1) << 8);
            x.push(alpha.charAt(b10 >> 18) + alpha.charAt((b10 >> 12) & 0x3F) +
                alpha.charAt((b10 >> 6) & 0x3f) + padchar);
            break;
    }
    return x.join('');
}

'use strict';

angular.module('isahomeApp')
    .factory('Sessions', function ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    });




'use strict';

angular.module('isahomeApp')
    .factory('Register', function ($resource) {
        return $resource('api/register', {}, {
        });
    });



'use strict';

angular.module('isahomeApp')
    .factory('Principal', function Principal($q, Account) {
        var _identity,
            _authenticated = false;

        return {
            isIdentityResolved: function () {
                return angular.isDefined(_identity);
            },
            isAuthenticated: function () {
                return _authenticated;
            },
            hasAuthority: function (authority) {
                if (!_authenticated) {
                    return $q.when(false);
                }

                return this.identity().then(function(_id) {
                    return _id.authorities && _id.authorities.indexOf(authority) !== -1;
                }, function(){
                    return false;
                });
            },
            hasAnyAuthority: function (authorities) {
                if (!_authenticated || !_identity || !_identity.authorities) {
                    return false;
                }

                for (var i = 0; i < authorities.length; i++) {
                    if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                        return true;
                    }
                }

                return false;
            },
            authenticate: function (identity) {
                _identity = identity;
                _authenticated = identity !== null;
            },
            identity: function (force) {
                var deferred = $q.defer();

                if (force === true) {
                    _identity = undefined;
                }

                // check and see if we have retrieved the identity data from the server.
                // if we have, reuse it by immediately resolving
                if (angular.isDefined(_identity)) {
                    deferred.resolve(_identity);

                    return deferred.promise;
                }

                // retrieve the identity data from the server, update the identity object, and then resolve.
                Account.get().$promise
                    .then(function (account) {
                        _identity = account.data;
                        _authenticated = true;
                        deferred.resolve(_identity);
                    })
                    .catch(function() {
                        _identity = null;
                        _authenticated = false;
                        deferred.resolve(_identity);
                    });
                return deferred.promise;
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .factory('Password', function ($resource) {
        return $resource('api/account/change_password', {}, {
        });
    });

angular.module('isahomeApp')
    .factory('PasswordResetInit', function ($resource) {
        return $resource('api/account/reset_password/init', {}, {
        });
    });

angular.module('isahomeApp')
    .factory('PasswordResetFinish', function ($resource) {
        return $resource('api/account/reset_password/finish', {}, {
        });
    });

'use strict';

angular.module('isahomeApp')
    .directive('hasAnyAuthority', ['Principal', function (Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function (reset) {
                        var result;
                        if (reset) {
                            setVisible();
                        }

                        result = Principal.hasAnyAuthority(authorities);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    };

                if (authorities.length > 0) {
                    defineVisibility(true);

                    scope.$watch(function() {
                        return Principal.isAuthenticated();
                    }, function() {
                        defineVisibility(true);
                    });
                }
            }
        };
    }])
    .directive('hasAuthority', ['Principal', function (Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var authority = attrs.hasAuthority.replace(/\s+/g, '');

                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function (reset) {

                        if (reset) {
                            setVisible();
                        }

                        Principal.hasAuthority(authority)
                            .then(function (result) {
                                if (result) {
                                    setVisible();
                                } else {
                                    setHidden();
                                }
                            });
                    };

                if (authority.length > 0) {
                    defineVisibility(true);

                    scope.$watch(function() {
                        return Principal.isAuthenticated();
                    }, function() {
                        defineVisibility(true);
                    });
                }
            }
        };
    }]);

'use strict';

angular.module('isahomeApp')
    .factory('AuthServerProvider', function loginService($http, $localStorage ) {
        return {
            login: function(credentials) {
                var data = 'j_username=' + encodeURIComponent(credentials.username) +
                    '&j_password=' + encodeURIComponent(credentials.password) +
                    '&remember-me=' + credentials.rememberMe + '&submit=Login';
                return $http.post('api/authentication', data, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).success(function (response) {
                    return response;
                });
            },
            logout: function() {
                // logout from the server
                $http.post('api/logout').success(function (response) {
                    delete $localStorage.authenticationToken;
                    // to get a new csrf token call the api
                    $http.get('api/account');
                    return response;
                });
            },
            getToken: function () {
                var token = $localStorage.authenticationToken;
                return token;
            },
            hasValidToken: function () {
                var token = this.getToken();
                return !!token;
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .factory('Auth', function Auth($rootScope, $state, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        return {
            login: function (credentials, callback) {
                var cb = callback || angular.noop;
                var deferred = $q.defer();

                AuthServerProvider.login(credentials).then(function (data) {
                    // retrieve the logged account information
                    Principal.identity(true).then(function(account) {
                        deferred.resolve(data);
                    });
                    return cb();
                }).catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

                return deferred.promise;
            },

            logout: function () {
                AuthServerProvider.logout();
                Principal.authenticate(null);
                // Reset state memory if not redirected
                if(!$rootScope.redirected) {
                    $rootScope.previousStateName = undefined;
                    $rootScope.previousStateNameParams = undefined;
                }
            },

            authorize: function(force) {
                return Principal.identity(force)
                    .then(function() {
                        var isAuthenticated = Principal.isAuthenticated();

                        // an authenticated user can't access to login and register pages
                        if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                            $state.go('home');
                        }

                        if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                            if (isAuthenticated) {
                                // user is signed in but not authorized for desired state
                                $state.go('accessdenied');
                            }
                            else {
                                // user is not authenticated. stow the state they wanted before you
                                // send them to the login service, so you can return them when you're done
                                $rootScope.redirected = true;
                                $rootScope.previousStateName = $rootScope.toState;
                                $rootScope.previousStateNameParams = $rootScope.toStateParams;

                                // now, send them to the signin state so they can log in
                                $state.go('accessdenied');
                                LoginService.open();
                            }
                        }
                    });
            },
            createAccount: function (account, callback) {
                var cb = callback || angular.noop;

                return Register.save(account,
                    function () {
                        return cb(account);
                    },
                    function (err) {
                        this.logout();
                        return cb(err);
                    }.bind(this)).$promise;
            },

            updateAccount: function (account, callback) {
                var cb = callback || angular.noop;

                return Account.save(account,
                    function () {
                        return cb(account);
                    },
                    function (err) {
                        return cb(err);
                    }.bind(this)).$promise;
            },

            activateAccount: function (key, callback) {
                var cb = callback || angular.noop;

                return Activate.get(key,
                    function (response) {
                        return cb(response);
                    },
                    function (err) {
                        return cb(err);
                    }.bind(this)).$promise;
            },

            changePassword: function (newPassword, callback) {
                var cb = callback || angular.noop;

                return Password.save(newPassword, function () {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            },

            resetPasswordInit: function (mail, callback) {
                var cb = callback || angular.noop;

                return PasswordResetInit.save(mail, function() {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            },

            resetPasswordFinish: function(keyAndPassword, callback) {
                var cb = callback || angular.noop;

                return PasswordResetFinish.save(keyAndPassword, function () {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .factory('Activate', function ($resource) {
        return $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });
    });



'use strict';

angular.module('isahomeApp')
    .factory('Account', function Account($resource) {
        return $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('search', {
                parent: 'app',
                url: '/search/:query',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/search/search.html',
                        controller: 'SearchController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('SearchController', function ($scope, $sce, CommentSearch, CaseStudySearch, PageContentSearch, $stateParams, LoginService, PageContentByName, PageContent, CarouselImage, $state) {

        $scope.totalResults = 0;

        PageContentSearch.query({query: $stateParams.query}, function(data){
            $scope.results = data;
            $scope.totalResults += data.length;
        });
        CaseStudySearch.query({query: $stateParams.query}, function(data){
            $scope.caseResults = data;
            $scope.totalResults += data.length;
        });
        CommentSearch.query({query: $stateParams.query}, function(data){
            $scope.commentResults = data;
            $scope.totalResults += data.length;
        });
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('page', {
                parent: 'app',
                url: '/p/:name',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/page/page.html',
                        controller: 'PageController'
                    }
                }
            })
            .state('page.new', {
                parent: 'page',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/page/page.edit.dialog.html',
                        controller: 'PageContentDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    linkName: $stateParams.name,
                                    title: null,
                                    content: null,
                                    lastUpdate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('page', null, { reload: true });
                    }, function() {
                        $state.go('page');
                    });
                }]
            })
            .state('page.delete', {
                parent: 'page',
                url: '/{id:int}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/page-content/page-content-delete-dialog.html',
                        controller: 'PageContentDeleteController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['PageContent', function(PageContent) {
                                return PageContent.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('page', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })

            .state('file-upload-download', {
                parent: 'app',
                url: '/file/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'FileUpload'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/page/file.html',
                        controller: 'FileDownloadController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'FileUpload', function($stateParams, FileUpload) {
                        return FileUpload.get({id : $stateParams.id});
                    }]
                }
            })
    });

'use strict';

angular.module('isahomeApp')
    .factory('ContactForm', ContactForm)
    .controller('PageController', function ($scope, ContactForm, $localStorage, $stateParams, PageContent, PageContentByName, $state, $sce, Principal, LoginService, PageCommentByName) {
        $scope.pageName = $stateParams.name;
        $scope.comments = [];
        $scope.commentsEnabled = false
        $scope.showCommentForm = false;
        $scope.showSuccessMessage = false;
        $scope.$storage = $localStorage;
        $scope.isEditing = false;
        $scope.state = $state;
        $scope.message = {};
        $scope.showForm = true;
        $scope.successMsg = false;

        Principal.identity().then(function(account) {
            $scope.isLoggedIn = Principal.isAuthenticated();
            $scope.isAdmin = Principal.hasAuthority('ROLE_ADMIN');
        });
        $scope.login = function () {
            LoginService.open();
        };

        if($scope.pageName == 'case-presentations'){
            $state.go('cases');
            return null;
        }
        if($scope.pageName == 'Member Directory'){
            $state.go('directory');
            return null;
        }

        PageContentByName.get({name:$scope.pageName}, function(result){
            $scope.pageContent = result;
            if ($scope.pageContent.content.indexOf('<logged-in-only') !== -1) {
                if (!$scope.isLoggedIn) {
                    $scope.login();
                    $scope.pageContent.content = '';
                }
            }
            if ($scope.pageContent.content.indexOf('<page-comments') !== -1) {
                if ($scope.isLoggedIn && $scope.isAdmin) {
                    $scope.commentsEnabled = true;
                    $scope.reloadComments()
                }
            }
            if($scope.pageContent.siteHeaders.length > 0){
                var header = $scope.pageContent.siteHeaders[0];
                $scope.topHeaderName = header.topHeaderName;
                $scope.topHeaderLinkName = header.topHeaderLinkName;
                $scope.mainHeaderName = header.mainHeaderName;
                $scope.mainHeaderLinkName = header.mainHeaderLinkName;
                $scope.subHeaderName = header.name;
                $scope.subHeaderLinkName = header.targetPageLinkName;

                var topName = header.topHeaderName || header.mainHeaderName;
                angular.forEach($scope.$storage.headers, function(header){
                    if(header.name == topName){
                        $scope.topHeader = header;
                    }
                })
            }else{
                $scope.mainHeaderName = $scope.pageContent.title;
                $scope.mainHeaderLinkName = $scope.pageContent.linkName;
            }
        }, function(error){
            $scope.pageContent = error;
            $scope.pageContent.content = $sce.trustAsHtml('<h3>No Page Found</h3>');

        });
        $scope.edit = function(){
            $scope.isEditing = true;
        };
        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:pageContentUpdate', result);
            $scope.isSaving = false;
            $scope.isEditing = false;
            $state.go('page', {name:result.linkName}, {reload: true});
        };

        var onSaveError = function () {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.pageContent.lastUpdate = new Date();
            $scope.isSaving = true;
            if ($scope.pageContent.id !== null) {
                PageContent.update($scope.pageContent, onSaveSuccess, onSaveError);
            } else {
                PageContent.save($scope.pageContent, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $scope.isEditing = false;
        };

        $scope.sendMessage = function(){
            console.log($scope.message);
            ContactForm.update($scope.message);
            $scope.showForm = false;
            $scope.successMsg = true;



            $scope.message = { name: null, title: null, message: null};
        }

        // comment related code
        $scope.showCommentForm = false;
        $scope.setShowCommentForm = function(data){
            $scope.showCommentForm = data;
            $scope.showSuccessMessage = false;
        };

        $scope.reloadComments = function(){
            PageCommentByName.query({name:$scope.pageName}, function(data){
                $scope.comments = data;
            })
        }
        $scope.newComment = {author: '', comment: ''};
        $scope.postComment = function(newComment){
            newComment.commentDate = new Date();
            newComment.pageLinkName = $scope.pageName;
            PageCommentByName.create({name: $scope.pageName }, newComment, function(result){
                $scope.newComment = {author: '', comment: ''};
                $scope.showCommentForm = false;
                $scope.showSuccessMessage = true;
                $scope.reloadComments();
            })
        }
    });

ContactForm.$inject = ['$resource'];
function ContactForm ($resource, DateUtils) {
    var resourceUrl =  'api/contact-form';

    return $resource(resourceUrl, {}, {
        'get': {
            method: 'GET',
            transformResponse: function (data) {
                data = angular.fromJson(data);
                return data;
            }
        },
        'update': { method:'PUT' }
    });
}

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('FileDownloadController', FileDownloadController);

    FileDownloadController.$inject = ['$scope', '$rootScope', 'deviceDetector', '$window', '$timeout', '$stateParams', 'DataUtils', 'entity', 'FileUpload', 'FileSaver'];

    function FileDownloadController($scope, $rootScope, deviceDetector, $window, $timeout, $stateParams, DataUtils, entity, FileUpload, FileSaver) {
        var vm = this;
        vm.fileUpload = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        FileUpload.get({id: $stateParams.id}, function(result){
            if(result.attachmentContentType === 'application/pdf' && deviceDetector.browser != 'ie'){
                DataUtils.openFile(result.attachmentContentType, result.attachment);
            }else{
                var blob = DataUtils.toBlob(result.attachment, result.attachmentContentType);
                FileSaver.saveAs(blob, result.name);
            }
            if(deviceDetector.browser != 'ie'){
                $timeout($window.close, 100);
            }
        });

    }
})();

'use strict';

angular.module('isahomeApp')
    .directive('activeLink', function(location) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var clazz = attrs.activeLink;
                var path = attrs.href;
                path = path.substring(1); //hack because path does bot return including hashbang
                scope.location = location;
                scope.$watch('location.path()', function(newPath) {
                    if (path === newPath) {
                        element.addClass(clazz);
                    } else {
                        element.removeClass(clazz);
                    }
                });
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .controller('NavbarController', function ($scope, $localStorage, PageContentSearch, $location, $state, Auth, Principal, ENV, LoginService, MainSiteHeader) {
        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.$state = $state;
        $scope.inProduction = ENV === 'prod';
        $scope.$storage = $localStorage;

        $scope.logout = function () {
            Auth.logout();
            $state.go('home');
        };

        $scope.login = function () {
            LoginService.open();
        };

        $scope.reverse = true;
        MainSiteHeader.query({ page: 0, size: 12, sort: ['orderNum' + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id'] },
            function(result){
                $scope.mainHeaders = result;
                $scope.$storage.headers = result;

            });

        $scope.searchSite = function(query){
            $state.go('search',{query:query+'*'});
        }

    });
$(document).on('click','.navbar-collapse.in',function(e) {
    if( $(e.target).is('a') ) {
        $(this).collapse('hide');
    }
});

'use strict';

angular.module('isahomeApp')
    .controller('FooterController', function ($scope, $location, $state, Auth, Principal, ENV, LoginService, MainSiteHeader) {
        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.$state = $state;
        $scope.inProduction = ENV === 'prod';

        $scope.logout = function () {
            Auth.logout();
            $state.go('home');
        };

        $scope.login = function () {
            LoginService.open();
        };

        $scope.reverse = true;
        MainSiteHeader.query({ page: 0, size: 12, sort: ['orderNum' + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id'] },
            function(result){
                $scope.mainHeaders = result;
                $scope.mainHeaders.push({targetPageLinkName: 'contact-us', name: 'Contact Us'})
            })
    });
$(document).on('click','.navbar-collapse.in',function(e) {
    if( $(e.target).is('a') ) {
        $(this).collapse('hide');
    }
});

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/error/accessdenied.html'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('home', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('HomeController', function ($scope, $sce, Principal, LoginService, PageContentByName, PageContent, CarouselImage, $state) {
        function getAccount() {
            Principal.identity().then(function(account) {
                $scope.account = account;
                $scope.isAuthenticated = Principal.isAuthenticated;
            });
        }
        getAccount();

        $scope.isEditing = false;
        $scope.myInterval = 5000;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        $scope.login = LoginService.open;


        PageContentByName.get({name:'home'}, function(result){
            $scope.pageContent = result;
            $scope.pageContent.trustedContent = $sce.trustAsHtml(result.content);

        });


        $scope.edit = function(){
            $scope.isEditing = true;
        };
        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:pageContentUpdate', result);
            $scope.isSaving = false;
            $scope.isEditing = false;
            $state.go('home', {}, {reload: true});
        };

        var onSaveError = function () {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.pageContent.lastUpdate = new Date();
            $scope.isSaving = true;
            if ($scope.pageContent.id !== null) {
                PageContent.update($scope.pageContent, onSaveSuccess, onSaveError);
            } else {
                PageContent.save($scope.pageContent, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $scope.isEditing = false;
        };

        CarouselImage.query({ page: 0, size: 20, sort: ['orderNum' + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id'] },
            function(images){
               $scope.carouselImages = images;
            });
    });

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('UserProfileDialogController', UserProfileDialogController);

    UserProfileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'UserProfile'];

    function UserProfileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, UserProfile) {
        var vm = this;

        vm.userProfile = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userProfile.id !== null) {
                UserProfile.update(vm.userProfile, onSaveSuccess, onSaveError);
            } else {
                UserProfile.save(vm.userProfile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('isahomeApp:userProfileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('UserProfileDetailController', UserProfileDetailController);

    UserProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'UserProfile'];

    function UserProfileDetailController($scope, $rootScope, $stateParams, entity, UserProfile) {
        var vm = this;

        vm.userProfile = entity;

        var unsubscribe = $rootScope.$on('isahomeApp:userProfileUpdate', function(event, result) {
            vm.userProfile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('UserProfileDeleteController',UserProfileDeleteController);

    UserProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserProfile'];

    function UserProfileDeleteController($uibModalInstance, entity, UserProfile) {
        var vm = this;

        vm.userProfile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserProfile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-profile', {
            parent: 'entity',
            url: '/user-profile?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'UserProfiles'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-profile/user-profiles.html',
                    controller: 'UserProfileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('user-profile-detail', {
            parent: 'entity',
            url: '/user-profile/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'UserProfile'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-profile/user-profile-detail.html',
                    controller: 'UserProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'UserProfile', function($stateParams, UserProfile) {
                    return UserProfile.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('user-profile.new', {
            parent: 'user-profile',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-profile/user-profile-dialog.html',
                    controller: 'UserProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                addressOne: null,
                                addressTwo: null,
                                addressThree: null,
                                middleInitial: null,
                                prefix: null,
                                degree: null,
                                city: null,
                                state: null,
                                zipCode: null,
                                country: null,
                                phone: null,
                                fax: null,
                                email: null,
                                institution: null,
                                paidThrough: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-profile', null, { reload: true });
                }, function() {
                    $state.go('user-profile');
                });
            }]
        })
        .state('user-profile.edit', {
            parent: 'user-profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-profile/user-profile-dialog.html',
                    controller: 'UserProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserProfile', function(UserProfile) {
                            return UserProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-profile', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-profile.delete', {
            parent: 'user-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-profile/user-profile-delete-dialog.html',
                    controller: 'UserProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserProfile', function(UserProfile) {
                            return UserProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-profile', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('isahomeApp')
        .factory('UserProfile', UserProfile);

    UserProfile.$inject = ['$resource'];

    function UserProfile ($resource) {
        var resourceUrl =  'api/user-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('UserProfileSearch', UserProfileSearch);

    UserProfileSearch.$inject = ['$resource'];

    function UserProfileSearch($resource) {
        var resourceUrl =  'api/_search/user-profiles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('UserProfileController', UserProfileController);

    UserProfileController.$inject = ['$scope', '$state', 'UserProfile', 'UserProfileSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function UserProfileController ($scope, $state, UserProfile, UserProfileSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                UserProfileSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                UserProfile.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.userProfiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('SiteHeaderDialogController', SiteHeaderDialogController);

    SiteHeaderDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'SiteHeader', 'PageContentInfo'];

    function SiteHeaderDialogController ($scope, $stateParams, $uibModalInstance, entity, SiteHeader, PageContentInfo) {
        var vm = this;
        vm.siteHeader = entity;
        vm.siteheaders = SiteHeader.query({size:300});
        vm.pagecontents = PageContentInfo.query({size:300});
        vm.load = function(id) {
            SiteHeader.get({id : id}, function(result) {
                vm.siteHeader = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:siteHeaderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            if (vm.siteHeader.id === vm.siteHeader.mainHeaderId) {
                alert('Error: Can not create a Site Header with a Parent Header of itself')
                return;
            }
            vm.isSaving = true;
            if (vm.siteHeader.id !== null) {
                SiteHeader.update(vm.siteHeader, onSaveSuccess, onSaveError);
            } else {
                SiteHeader.save(vm.siteHeader, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('SiteHeaderDetailController', SiteHeaderDetailController);

    SiteHeaderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'SiteHeader', 'PageContent'];

    function SiteHeaderDetailController($scope, $rootScope, $stateParams, entity, SiteHeader, PageContent) {
        var vm = this;
        vm.siteHeader = entity;
        vm.load = function (id) {
            SiteHeader.get({id: id}, function(result) {
                vm.siteHeader = result;
            });
        };
        var unsubscribe = $rootScope.$on('isahomeApp:siteHeaderUpdate', function(event, result) {
            vm.siteHeader = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('SiteHeaderDeleteController',SiteHeaderDeleteController);

    SiteHeaderDeleteController.$inject = ['$uibModalInstance', 'entity', 'SiteHeader'];

    function SiteHeaderDeleteController($uibModalInstance, entity, SiteHeader) {
        var vm = this;
        vm.siteHeader = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            SiteHeader.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site-header', {
            parent: 'entity',
            url: '/site-header?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SiteHeaders'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-header/site-headers.html',
                    controller: 'SiteHeaderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('site-header-detail', {
            parent: 'entity',
            url: '/site-header/{id:int}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SiteHeader'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-header/site-header-detail.html',
                    controller: 'SiteHeaderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SiteHeader', function($stateParams, SiteHeader) {
                    return SiteHeader.get({id : $stateParams.id});
                }]
            }
        })
        .state('site-header.new', {
            parent: 'site-header',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-header/site-header-dialog.html',
                    controller: 'SiteHeaderDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                orderNum: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('site-header', null, { reload: true });
                }, function() {
                    $state.go('site-header');
                });
            }]
        })
        .state('site-header.edit', {
            parent: 'site-header',
            url: '/{id:int}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-header/site-header-dialog.html',
                    controller: 'SiteHeaderDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteHeader', function(SiteHeader) {
                            return SiteHeader.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-header', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-header.delete', {
            parent: 'site-header',
            url: '/{id:int}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-header/site-header-delete-dialog.html',
                    controller: 'SiteHeaderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SiteHeader', function(SiteHeader) {
                            return SiteHeader.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-header', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('SiteHeader', SiteHeader);

    SiteHeader.$inject = ['$resource', 'DateUtils'];

    function SiteHeader ($resource, DateUtils) {
        return $resource('api/site-headers/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('MainSiteHeader', SiteHeader);

    SiteHeader.$inject = ['$resource', 'DateUtils'];

    function SiteHeader ($resource, DateUtils) {
        return $resource('api/site-headers/main-headers', {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('SiteHeaderSearch', SiteHeaderSearch);

    SiteHeaderSearch.$inject = ['$resource'];

    function SiteHeaderSearch($resource) {
        return $resource('api/_search/site-headers', {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('SiteHeaderController', SiteHeaderController);

    SiteHeaderController.$inject = ['$scope', '$state', 'SiteHeader', 'SiteHeaderSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function SiteHeaderController ($scope, $state, SiteHeader, SiteHeaderSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                SiteHeaderSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SiteHeader.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.siteHeaders = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('RegistrationSuccessController', RegistrationSuccessController);

    RegistrationSuccessController.$inject = ['$scope', '$state', '$stateParams', 'entity', 'Registration'];

    function RegistrationSuccessController ($scope, $state, $stateParams, entity, Registration) {
        var vm = this;
        vm.registration = entity;

        $timeout(function(){
           $state.go('page', {name: 'Pay Dues'})
        },6000)
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('RegistrationDialogNewController', RegistrationDialogNewController);

    RegistrationDialogNewController.$inject = ['$scope', '$state', '$stateParams', 'entity', 'Registration'];

    function RegistrationDialogNewController ($scope, $state, $stateParams, entity, Registration) {
        var vm = this;
        vm.registration = entity;
        vm.mathA = Math.floor(Math.random() * 11);
        vm.mathB = Math.floor(Math.random() * 11);
        vm.phoneCell = '';
        vm.load = function(id) {
            Registration.get({id : id}, function(result) {
                vm.registration = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:registrationUpdate', result);
            vm.isSaving = false;
            $state.go('registration-success');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.error = null;
            if (vm.mathA + vm.mathB !== parseInt(vm.phoneCell, 10)) {
                vm.error = 'Incorrect answer';
                return;
            }
            vm.isSaving = true;
            if (vm.registration.id !== null) {
                Registration.update(vm.registration, onSaveSuccess, onSaveError);
            } else {
                Registration.save(vm.registration, onSaveSuccess, onSaveError);
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('RegistrationDialogController', RegistrationDialogController);

    RegistrationDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Registration'];

    function RegistrationDialogController ($scope, $stateParams, $uibModalInstance, entity, Registration) {
        var vm = this;
        vm.registration = entity;

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:registrationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.registration.id !== null) {
                Registration.update(vm.registration, onSaveSuccess, onSaveError);
            } else {
                Registration.save(vm.registration, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('RegistrationDetailController', RegistrationDetailController);

    RegistrationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Registration'];

    function RegistrationDetailController($scope, $rootScope, $stateParams, entity, Registration) {
        var vm = this;
        vm.registration = entity;
        
        var unsubscribe = $rootScope.$on('isahomeApp:registrationUpdate', function(event, result) {
            vm.registration = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('RegistrationDeleteController',RegistrationDeleteController);

    RegistrationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Registration'];

    function RegistrationDeleteController($uibModalInstance, entity, Registration) {
        var vm = this;
        vm.registration = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Registration.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('registration', {
            parent: 'entity',
            url: '/registration?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Registrations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registration/registrations.html',
                    controller: 'RegistrationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('registration-detail', {
            parent: 'entity',
            url: '/registration/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registration/registration-detail.html',
                    controller: 'RegistrationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Registration', function($stateParams, Registration) {
                    return Registration.get({id : $stateParams.id});
                }]
            }
        })
        .state('registration.new', {
            parent: 'registration',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstname: null,
                                middle: null,
                                lastname: null,
                                position: null,
                                subspecialty: null,
                                addressOne: null,
                                addressTwo: null,
                                city: null,
                                state: null,
                                zip: null,
                                country: null,
                                phone: null,
                                fax: null,
                                email: null,
                                referenceOne: null,
                                referenceOneCountry: null,
                                referenceTwo: null,
                                referenceTwoCountry: null,
                                certificateName: null,
                                institution: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('registration', null, { reload: true });
                }, function() {
                    $state.go('registration');
                });
            }]
        })
        .state('registration.guest', {
            parent: 'app',
            url: '/register',
            data: {
                pageTitle: 'Register'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogNewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        firstname: null,
                        middle: null,
                        lastname: null,
                        position: null,
                        subspecialty: null,
                        mailingAddress: null,
                        street: null,
                        city: null,
                        state: null,
                        zip: null,
                        country: null,
                        phone: null,
                        fax: null,
                        email: null,
                        referenceOne: null,
                        referenceOneCountry: null,
                        referenceTwo: null,
                        referenceTwoCountry: null,
                        certificateName: null,
                        id: null
                    };
                }
            }
        })
        .state('registration-success', {
            parent: 'entity',
            url: '/register/success',
            data: {
                pageTitle: 'Registration Success'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/registration/registration-success.html',
                }
            }
        })
        .state('registration.edit', {
            parent: 'registration',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-dialog.html',
                    controller: 'RegistrationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('registration.delete', {
            parent: 'registration',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/registration/registration-delete-dialog.html',
                    controller: 'RegistrationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Registration', function(Registration) {
                            return Registration.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('registration', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('isahomeApp')
        .factory('Registration', Registration);

    Registration.$inject = ['$resource'];

    function Registration ($resource) {
        var resourceUrl =  'api/registrations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('RegistrationSearch', RegistrationSearch);

    RegistrationSearch.$inject = ['$resource'];

    function RegistrationSearch($resource) {
        var resourceUrl =  'api/_search/registrations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('RegistrationController', RegistrationController);

    RegistrationController.$inject = ['$scope', '$uibModal', '$state', 'UserProfile', 'Registration', 'RegistrationSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RegistrationController ($scope, $uibModal, $state, UserProfile, Registration, RegistrationSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.addToDirectory = addToDirectory;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function addToDirectory (registration) {
            registration.zipCode = registration.zip;
            registration.firstName = registration.firstname;
            registration.lastName = registration.lastname;
            registration.middleInitial= registration.middle;
            registration.id = null;
            $uibModal.open({
                templateUrl: 'app/entities/user-profile/user-profile-dialog.html',
                controller: 'UserProfileDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['UserProfile', function(UserProfile) {
                        return registration;
                    }]
                }
            }).result.then(function(result) {
                // $state.go('user-profile', null, { reload: true });
            }, function() {
                // $state.go('^');
            });


            // UserProfile.update(registration, function(result){
            //     console.log(result);
            // });
        }

        function loadAll () {
            if (pagingParams.search) {
                RegistrationSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Registration.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.registrations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();

'use strict';

angular.module('isahomeApp').controller('PageCommentDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PageComment',
        function($scope, $stateParams, $uibModalInstance, DataUtils, entity, PageComment) {

        $scope.pageComment = entity;
        $scope.load = function(id) {
            PageComment.get({id : id}, function(result) {
                $scope.pageComment = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:pageCommentUpdate', result);
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };

        var onSaveError = function (result) {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.pageComment.id != null) {
                PageComment.update($scope.pageComment, onSaveSuccess, onSaveError);
            } else {
                PageComment.save($scope.pageComment, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.abbreviate = DataUtils.abbreviate;

        $scope.byteSize = DataUtils.byteSize;
        $scope.datePickerForCommentDate = {};

        $scope.datePickerForCommentDate.status = {
            opened: false
        };

        $scope.datePickerForCommentDateOpen = function($event) {
            $scope.datePickerForCommentDate.status.opened = true;
        };
}]);

'use strict';

angular.module('isahomeApp')
    .controller('PageCommentDetailController', function ($scope, $rootScope, $stateParams, DataUtils, entity, PageComment) {
        $scope.pageComment = entity;
        $scope.load = function (id) {
            PageComment.get({id: id}, function(result) {
                $scope.pageComment = result;
            });
        };
        var unsubscribe = $rootScope.$on('isahomeApp:pageCommentUpdate', function(event, result) {
            $scope.pageComment = result;
        });
        $scope.$on('$destroy', unsubscribe);

        $scope.byteSize = DataUtils.byteSize;
    });

'use strict';

angular.module('isahomeApp')
	.controller('PageCommentDeleteController', function($scope, $uibModalInstance, entity, PageComment) {

        $scope.pageComment = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            PageComment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });

'use strict';

angular.module('isahomeApp')
    .factory('PageComment', function ($resource, DateUtils) {
        return $resource('api/pageComments/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.commentDate = DateUtils.convertDateTimeFromServer(data.commentDate);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    })
    .factory('PageCommentApproval', function ($resource, DateUtils) {
        return $resource('api/pageComments/approval/:isApproved', {}, {
            'query': { method: 'GET', isArray: true},
        });
    })
    .factory('PageCommentApprovalUpdate', function ($resource, DateUtils) {
        return $resource('api/pageComments/approval/:id/:status', {}, {
            'update': { method:'PUT' },
        });
    }).factory('PageCommentByName', function ($resource, DateUtils) {
        return $resource('api/pageComments/page/:name', {}, {
            'query': { method: 'GET', isArray: true},
            'create': { method:'POST' },
            'update': { method:'PUT' },
            'get': {
                method: 'GET',
                //transformResponse: function (data) {
                //    data = angular.fromJson(data);
                //    data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                //    return data;
                //}
            }
        });
    });

'use strict';

angular.module('isahomeApp')
    .factory('PageCommentSearch', function ($resource) {
        return $resource('api/_search/pageComments/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('pageComment', {
                parent: 'entity',
                url: '/pageComments',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'PageComments'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pageComment/pageComments.html',
                        controller: 'PageCommentController'
                    }
                },
                resolve: {
                }
            })
            .state('pageComment.detail', {
                parent: 'entity',
                url: '/pageComment/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'PageComment'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pageComment/pageComment-detail.html',
                        controller: 'PageCommentDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PageComment', function($stateParams, PageComment) {
                        return PageComment.get({id : $stateParams.id});
                    }]
                }
            })
            .state('pageComment.new', {
                parent: 'pageComment',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pageComment/pageComment-dialog.html',
                        controller: 'PageCommentDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    author: null,
                                    comment: null,
                                    commentDate: null,
                                    pageLinkName: null,
                                    approved: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('pageComment', null, { reload: true });
                    }, function() {
                        $state.go('pageComment');
                    })
                }]
            })
            .state('pageComment.edit', {
                parent: 'pageComment',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pageComment/pageComment-dialog.html',
                        controller: 'PageCommentDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['PageComment', function(PageComment) {
                                return PageComment.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('pageComment', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            })
            .state('pageComment.delete', {
                parent: 'pageComment',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pageComment/pageComment-delete-dialog.html',
                        controller: 'PageCommentDeleteController',
                        size: 'md',
                        resolve: {
                            entity: ['PageComment', function(PageComment) {
                                return PageComment.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('pageComment', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('PageCommentController', function ($scope, $state, DataUtils, PageComment, PageCommentSearch, ParseLinks) {

        $scope.pageComments = [];
        $scope.predicate = 'id';
        $scope.reverse = true;
        $scope.page = 1;
        $scope.loadAll = function() {
            PageComment.query({page: $scope.page - 1, size: 20, sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.pageComments = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.search = function () {
            PageCommentSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.pageComments = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.pageComment = {
                author: null,
                comment: null,
                commentDate: null,
                pageLinkName: null,
                approved: null,
                id: null
            };
        };

        $scope.abbreviate = DataUtils.abbreviate;

        $scope.byteSize = DataUtils.byteSize;
    });

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('PageContentDialogController', PageContentDialogController);

    PageContentDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PageContent', 'SiteHeader'];

    function PageContentDialogController ($scope, $stateParams, $uibModalInstance, DataUtils, entity, PageContent, SiteHeader) {
        var vm = this;
        vm.pageContent = entity;
        vm.siteheaders = SiteHeader.query({size:100});
        vm.load = function(id) {
            PageContent.get({id : id}, function(result) {
                vm.pageContent = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:pageContentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            vm.pageContent.lastUpdate = new Date();
            if (vm.pageContent.id !== null) {
                PageContent.update(vm.pageContent, onSaveSuccess, onSaveError);
            } else {
                PageContent.save(vm.pageContent, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openFile = DataUtils.openFile;

        vm.byteSize = DataUtils.byteSize;
        vm.datePickerForLastUpdate = {};

        vm.datePickerForLastUpdate.status = {
            opened: false
        };

        vm.datePickerForLastUpdateOpen = function($event) {
            vm.datePickerForLastUpdate.status.opened = true;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('PageContentDetailController', PageContentDetailController);

    PageContentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'PageContent', 'SiteHeader'];

    function PageContentDetailController($scope, $rootScope, $stateParams, DataUtils, entity, PageContent, SiteHeader) {
        var vm = this;
        vm.pageContent = entity;
        vm.load = function (id) {
            PageContent.get({id: id}, function(result) {
                vm.pageContent = result;
            });
        };
        var unsubscribe = $rootScope.$on('isahomeApp:pageContentUpdate', function(event, result) {
            vm.pageContent = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('PageContentDeleteController',PageContentDeleteController);

    PageContentDeleteController.$inject = ['$uibModalInstance', 'entity', 'PageContent'];

    function PageContentDeleteController($uibModalInstance, entity, PageContent) {
        var vm = this;
        vm.pageContent = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PageContent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('page-content', {
            parent: 'entity',
            url: '/page-content?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PageContents'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/page-content/page-contents.html',
                    controller: 'PageContentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('page-content-detail', {
            parent: 'entity',
            url: '/page-content/{id:int}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PageContent'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/page-content/page-content-detail.html',
                    controller: 'PageContentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PageContent', function($stateParams, PageContent) {
                    return PageContent.get({id : $stateParams.id});
                }]
            }
        })
        .state('page-content.new', {
            parent: 'page-content',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/page-content/page-content-dialog.html',
                    controller: 'PageContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                linkName: null,
                                title: null,
                                content: null,
                                lastUpdate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('page-content', null, { reload: true });
                }, function() {
                    $state.go('page-content');
                });
            }]
        })
        .state('page-content.edit', {
            parent: 'page-content',
            url: '/{id:int}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/page-content/page-content-dialog.html',
                    controller: 'PageContentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PageContent', function(PageContent) {
                            return PageContent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('page-content', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('page-content.delete', {
            parent: 'page-content',
            url: '/{id:int}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/page-content/page-content-delete-dialog.html',
                    controller: 'PageContentDeleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['PageContent', function(PageContent) {
                            return PageContent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('page-content', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

'use strict';

angular.module('isahomeApp')
    .factory('PageContent', function ($resource, DateUtils) {
        return $resource('api/page-contents/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    })
    .factory('PageContentInfo', function ($resource) {
        return $resource('api/page-contents-info', {}, {
            'query': { method: 'GET', isArray: true},
        });
    })
    .factory('PageContentByName', function ($resource, DateUtils) {
        return $resource('api/page-contents/link/:name', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                //transformResponse: function (data) {
                //    data = angular.fromJson(data);
                //    data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                //    return data;
                //}
            }
        });
    });

'use strict';

angular.module('isahomeApp')
    .factory('PageContentSearch', function ($resource) {
        return $resource('api/_search/page-contents/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('PageContentController', PageContentController);

    PageContentController.$inject = ['$scope', '$state', 'DataUtils', 'PageContent', 'PageContentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PageContentController ($scope, $state, DataUtils, PageContent, PageContentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PageContentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PageContent.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pageContents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('FileUploadDialogController', FileUploadDialogController);

    FileUploadDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'FileUpload'];

    function FileUploadDialogController ($scope, $stateParams, $uibModalInstance, DataUtils, entity, FileUpload) {
        var vm = this;
        vm.fileUpload = entity;

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:fileUploadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.fileUpload.id !== null) {
                FileUpload.update(vm.fileUpload, onSaveSuccess, onSaveError);
            } else {
                FileUpload.save(vm.fileUpload, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.setAttachment = function ($file, fileUpload) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        fileUpload.attachment = base64Data;
                        fileUpload.attachmentContentType = $file.type;
                        fileUpload.name = $file.name;
                    });
                });
            }
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('FileUploadDetailController', FileUploadDetailController);

    FileUploadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'FileUpload'];

    function FileUploadDetailController($scope, $rootScope, $stateParams, DataUtils, entity, FileUpload) {
        var vm = this;
        vm.fileUpload = entity;
        
        var unsubscribe = $rootScope.$on('isahomeApp:fileUploadUpdate', function(event, result) {
            vm.fileUpload = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('FileUploadDeleteController',FileUploadDeleteController);

    FileUploadDeleteController.$inject = ['$uibModalInstance', 'entity', 'FileUpload'];

    function FileUploadDeleteController($uibModalInstance, entity, FileUpload) {
        var vm = this;
        vm.fileUpload = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            FileUpload.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('file-upload', {
            parent: 'entity',
            url: '/file-upload?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'FileUploads'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/file-upload/file-uploads.html',
                    controller: 'FileUploadController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('file-upload-detail', {
            parent: 'entity',
            url: '/file-upload/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'FileUpload'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/file-upload/file-upload-detail.html',
                    controller: 'FileUploadDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'FileUpload', function($stateParams, FileUpload) {
                    return FileUpload.get({id : $stateParams.id});
                }]
            }
        })
        .state('file-upload.new', {
            parent: 'file-upload',
            url: '/file/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-upload/file-upload-dialog.html',
                    controller: 'FileUploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                attachment: null,
                                attachmentContentType: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('file-upload', null, { reload: true });
                }, function() {
                    $state.go('file-upload');
                });
            }]
        })
        .state('file-upload.edit', {
            parent: 'file-upload',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-upload/file-upload-dialog.html',
                    controller: 'FileUploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FileUpload', function(FileUpload) {
                            return FileUpload.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('file-upload', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('file-upload.delete', {
            parent: 'file-upload',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/file-upload/file-upload-delete-dialog.html',
                    controller: 'FileUploadDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FileUpload', function(FileUpload) {
                            return FileUpload.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('file-upload', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('isahomeApp')
        .factory('FileUpload', FileUpload);

    FileUpload.$inject = ['$resource'];

    function FileUpload ($resource) {
        var resourceUrl =  'api/file-uploads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('FileUploadSearch', FileUploadSearch);

    FileUploadSearch.$inject = ['$resource'];

    function FileUploadSearch($resource) {
        var resourceUrl =  'api/_search/file-uploads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('FileUploadController', FileUploadController);

    FileUploadController.$inject = ['$scope', '$state', 'DataUtils', 'FileUpload', 'FileUploadSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FileUploadController ($scope, $state, DataUtils, FileUpload, FileUploadSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FileUploadSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FileUpload.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fileUploads = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('entity', {
                abstract: true,
                parent: 'app'
            });
    });

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('CommentDialogController', CommentDialogController);

    CommentDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Comment', 'CaseStudy'];

    function CommentDialogController ($scope, $stateParams, $uibModalInstance, DataUtils, entity, Comment, CaseStudy) {
        var vm = this;
        vm.comment = entity;
        vm.casestudys = CaseStudy.query();
        vm.load = function(id) {
            Comment.get({id : id}, function(result) {
                vm.comment = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:commentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.comment.id !== null) {
                Comment.update(vm.comment, onSaveSuccess, onSaveError);
            } else {
                Comment.save(vm.comment, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openFile = DataUtils.openFile;

        vm.byteSize = DataUtils.byteSize;
        vm.datePickerForCommentDate = {};

        vm.datePickerForCommentDate.status = {
            opened: false
        };

        vm.datePickerForCommentDateOpen = function($event) {
            vm.datePickerForCommentDate.status.opened = true;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('CommentDetailController', CommentDetailController);

    CommentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Comment', 'CaseStudy'];

    function CommentDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Comment, CaseStudy) {
        var vm = this;
        vm.comment = entity;
        vm.load = function (id) {
            Comment.get({id: id}, function(result) {
                vm.comment = result;
            });
        };
        var unsubscribe = $rootScope.$on('isahomeApp:commentUpdate', function(event, result) {
            vm.comment = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('CommentDeleteController',CommentDeleteController);

    CommentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Comment'];

    function CommentDeleteController($uibModalInstance, entity, Comment) {
        var vm = this;
        vm.comment = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Comment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('comment', {
            parent: 'entity',
            url: '/comment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Comments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comment/comments.html',
                    controller: 'CommentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('comment-detail', {
            parent: 'entity',
            url: '/comment/{id:int}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Comment'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/comment/comment-detail.html',
                    controller: 'CommentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Comment', function($stateParams, Comment) {
                    return Comment.get({id : $stateParams.id});
                }]
            }
        })
        .state('comment.new', {
            parent: 'comment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comment/comment-dialog.html',
                    controller: 'CommentDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                author: null,
                                comment: null,
                                commentDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('comment', null, { reload: true });
                }, function() {
                    $state.go('comment');
                });
            }]
        })
        .state('comment.edit', {
            parent: 'comment',
            url: '/{id:int}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comment/comment-dialog.html',
                    controller: 'CommentDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Comment', function(Comment) {
                            return Comment.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('comment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('comment.delete', {
            parent: 'comment',
            url: '/{id:int}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                    controller: 'CommentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Comment', function(Comment) {
                            return Comment.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('comment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('Comment', Comment)
        .factory('CommentByCase', CommentByCase);

    Comment.$inject = ['$resource', 'DateUtils'];
    CommentByCase.$inject = ['$resource', 'DateUtils'];

    function Comment ($resource, DateUtils) {
        return $resource('api/comments/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.commentDate = DateUtils.convertDateTimeFromServer(data.commentDate);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function CommentByCase ($resource, DateUtils) {
        return $resource('api/comments/case/:id', {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('CommentSearch', CommentSearch);

    CommentSearch.$inject = ['$resource'];

    function CommentSearch($resource) {
        return $resource('api/_search/comments', {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('CommentController', CommentController);

    CommentController.$inject = ['$scope', '$state', 'DataUtils', 'Comment', 'CommentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CommentController ($scope, $state, DataUtils, Comment, CommentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CommentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Comment.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.comments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('CaseStudyDialogController', CaseStudyDialogController);

    CaseStudyDialogController.$inject = ['$scope', '$state', 'AttachmentByCase', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'CaseStudy', 'Attachment', 'Comment'];

    function CaseStudyDialogController ($scope, $state, AttachmentByCase, $stateParams, $uibModalInstance, DataUtils, entity, CaseStudy, Attachment, Comment) {
        var vm = this;
        vm.caseStudy = entity;
        vm.attachments = Attachment.query();
        vm.comments = Comment.query();
        vm.load = function(id) {
            CaseStudy.get({id : id}, function(result) {
                vm.caseStudy = result;
            });
        };

        vm.attachments = [];
        vm.attachmentsToDelete = [];

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:caseStudyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            saveAttachments(result.id);
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.caseStudy.id !== null) {
                CaseStudy.update(vm.caseStudy, onSaveSuccess, onSaveError);
            } else {
                CaseStudy.save(vm.caseStudy, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openFile = DataUtils.openFile;

        vm.byteSize = DataUtils.byteSize;

        vm.addNewChoice = function(itemList) {
            itemList.push({});
        };
        vm.removeChoice = function(index, itemList){
            itemList.splice(index,1);
        };

        vm.removeOldAttachment = function(index, itemList){
            //are you sure you want to remove this image?
            var attIdObject = {id: itemList[index].id}
            vm.attachmentsToDelete.push(attIdObject);
            itemList.splice(index,1);
        };


        vm.setImageFile = function ($file, attachment, index) {
            if ($file && $file.$error == 'pattern') {
                return;
            }
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function (e) {
                    var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                    //compression
                    var image = new Image();
                    image.src = e.target.result;
                    image.onload = function(){
                        $scope.$apply(function() {
                            attachment.image = resizeMe(image).substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                            attachment.imageContentType = $file.type;
                            attachment.fileName = $file.name;
                            var tn = getThumbnail(image);
                            attachment.thumbnail = tn.substr(tn.indexOf('base64,') + 'base64,'.length);
                            attachment.thumbnailContentType = tn.substr(5, tn.indexOf('base64,')-6);
                        });
                    };


                };
            }
        };
        function saveAttachments(id){
            var caseId = id;

            //remove old deleted attachments
            angular.forEach(vm.attachmentsToDelete, function(index){
                Attachment.delete(index, function(result){
                    console.log("Deleted attachment with id: " + index.id)
                });
            });


            vm.totalSaved = vm.attachments.length;
            vm.saved = 0;
            angular.forEach(vm.attachments, function(att){
                att.caseStudyId = id;
                if(att.image){

                    Attachment.update(att, function(result){
                            att.id = result.id;
                            vm.saved += 1;
                            if(vm.totalSaved == vm.saved){
                                $state.go('forum.view', {id: caseId}, {reload: true})
                            }
                        },
                        function(err){
                            console.log(err);
                            vm.saved += 1;
                            if(vm.totalSaved == vm.saved){
                                $state.go('forum.view', {id: caseId}, {reload: true})
                            }
                        })
                }else{
                    vm.saved += 1;
                    if(vm.totalSaved == vm.saved){
                        $state.go('forum.view', {id: caseId}, {reload: true})
                    }
                }

            })
        }

        function resizeMe(img) {
            var base64Start = img.src.indexOf('base64,');
            var imgType = img.src.substr(11,base64Start-11).slice(0,-1).toLowerCase();
            var compressableImageTypes = ["jpg","jpeg"];
            if(compressableImageTypes.indexOf(imgType) != -1){
                var canvas = document.createElement('canvas');
                var width = img.width;
                var height = img.height;
                // resize the canvas and draw the image data into it
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);
                return canvas.toDataURL("image/jpeg",0.7); // get the data from canvas as 70% JPG (can be also PNG, etc.)
            }else{
                return img.src;
            }
        }
        function getThumbnail(img) {
            var base64Start = img.src.indexOf('base64,');
            var imgType = img.src.substr(11,base64Start-11).slice(0,-1).toLowerCase();
            var canvas = document.createElement('canvas');
            var ratio = img.height / 250;
            var width = img.width / ratio;
            var height = img.height / ratio;
            // resize the canvas and draw the image data into it
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            return canvas.toDataURL("image/jpeg",0.7); // get the data from canvas as 70% JPG (can be also PNG, etc.)
        }

        AttachmentByCase.query({id: $stateParams.id},function(data){
            vm.oldAttachments = data;
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('CaseStudyDetailController', CaseStudyDetailController);

    CaseStudyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'CaseStudy', 'Attachment', 'Comment'];

    function CaseStudyDetailController($scope, $rootScope, $stateParams, DataUtils, entity, CaseStudy, Attachment, Comment) {
        var vm = this;
        vm.caseStudy = entity;
        vm.load = function (id) {
            CaseStudy.get({id: id}, function(result) {
                vm.caseStudy = result;
            });
        };
        var unsubscribe = $rootScope.$on('isahomeApp:caseStudyUpdate', function(event, result) {
            vm.caseStudy = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('CaseStudyDeleteController',CaseStudyDeleteController);

    CaseStudyDeleteController.$inject = ['$uibModalInstance', 'entity', 'CaseStudy'];

    function CaseStudyDeleteController($uibModalInstance, entity, CaseStudy) {
        var vm = this;
        vm.caseStudy = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            CaseStudy.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('case-study', {
            parent: 'entity',
            url: '/case-study?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CaseStudies'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/case-study/case-studies.html',
                    controller: 'CaseStudyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('case-study-detail', {
            parent: 'entity',
            url: '/case-study/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CaseStudy'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/case-study/case-study-detail.html',
                    controller: 'CaseStudyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CaseStudy', function($stateParams, CaseStudy) {
                    return CaseStudy.get({id : $stateParams.id});
                }]
            }
        })
        .state('case-study.new', {
            parent: 'case-study',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/case-study/case-study-dialog.html',
                    controller: 'CaseStudyDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                descr: null,
                                descr2: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('case-study', null, { reload: true });
                }, function() {
                    $state.go('case-study');
                });
            }]
        })
        .state('case-study.edit', {
            parent: 'case-study',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/case-study/case-study-dialog.html',
                    controller: 'CaseStudyDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['CaseStudy', function(CaseStudy) {
                            return CaseStudy.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('case-study', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('case-study.delete', {
            parent: 'case-study',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/case-study/case-study-delete-dialog.html',
                    controller: 'CaseStudyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CaseStudy', function(CaseStudy) {
                            return CaseStudy.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('case-study', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('isahomeApp')
        .factory('CaseStudy', CaseStudy);

    CaseStudy.$inject = ['$resource'];

    function CaseStudy ($resource, DateUtils) {
        var resourceUrl =  'api/case-studies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('CaseStudySearch', CaseStudySearch);

    CaseStudySearch.$inject = ['$resource'];

    function CaseStudySearch($resource) {
        var resourceUrl =  'api/_search/case-studies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('CaseStudyController', CaseStudyController);

    CaseStudyController.$inject = ['$scope', '$state', 'DataUtils', 'CaseStudy', 'CaseStudySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CaseStudyController ($scope, $state, DataUtils, CaseStudy, CaseStudySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                CaseStudySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CaseStudy.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.caseStudies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();

'use strict';

angular.module('isahomeApp').controller('CarouselImageManagementDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'CarouselImage',
        function($scope, $stateParams, $uibModalInstance, DataUtils, entity, CarouselImage) {

        $scope.carouselImage = entity;
        $scope.load = function(id) {
            CarouselImage.get({id : id}, function(result) {
                $scope.carouselImage = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:carouselImageUpdate', result);
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };

        var onSaveError = function (result) {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.carouselImage.id != null) {
                CarouselImage.update($scope.carouselImage, onSaveSuccess, onSaveError);
            } else {
                CarouselImage.save($scope.carouselImage, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.openFile = DataUtils.openFile;

        $scope.byteSize = DataUtils.byteSize;

        $scope.setPicture = function ($file, carouselImage) {
            if ($file && $file.$error == 'pattern') {
                return;
            }
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function (e) {
                    //compression
                    var image = new Image();
                    image.src = e.target.result;
                    image.onload = function(){
                        $scope.$apply(function() {
                            carouselImage.picture = resizeMe(image).substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                            carouselImage.pictureContentType = $file.type;
                        });
                    };
                };
            }
        };

            function resizeMe(img) {
                var base64Start = img.src.indexOf('base64,');
                var imgType = img.src.substr(11,base64Start-11).slice(0,-1).toLowerCase();
                var compressableImageTypes = ["jpg","jpeg"];
                if(compressableImageTypes.indexOf(imgType) != -1){
                    var canvas = document.createElement('canvas');
                    var ratio = img.height / 300;
                    var width = img.width / ratio;
                    var height = img.height / ratio;
                    // resize the canvas and draw the image data into it
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, height);
                    return canvas.toDataURL("image/jpeg",0.7); // get the data from canvas as 70% JPG (can be also PNG, etc.)
                }else if(["png"].indexOf(imgType) != -1){
                    var canvas = document.createElement('canvas');
                    var ratio = img.height / 300;
                    var width = img.width / ratio;
                    var height = img.height / ratio;
                    // resize the canvas and draw the image data into it
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, height);
                    return canvas.toDataURL("image/png",0.7); // get the data from canvas as 70% JPG (can be also PNG, etc.)
                    // return img.src;
                }
            }
}]);

'use strict';

angular.module('isahomeApp')
    .controller('CarouselImageManagementDetailController', function ($scope, $rootScope, $stateParams, DataUtils, entity, CarouselImage) {
        $scope.carouselImage = entity;
        $scope.load = function (id) {
            CarouselImage.get({id: id}, function(result) {
                $scope.carouselImage = result;
            });
        };
        var unsubscribe = $rootScope.$on('isahomeApp:carouselImageUpdate', function(event, result) {
            $scope.carouselImage = result;
        });
        $scope.$on('$destroy', unsubscribe);

        $scope.byteSize = DataUtils.byteSize;
        $scope.openFile = DataUtils.openFile;
    });

'use strict';

angular.module('isahomeApp')
	.controller('CarouselImageManagementDeleteController', function($scope, $uibModalInstance, entity, CarouselImage) {

        $scope.carouselImage = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            CarouselImage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('carousel-image-management', {
                parent: 'entity',
                url: '/carousel-image-management?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'CarouselImages'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/carousel-image/carousel-image-management.html',
                        controller: 'CarouselImageManagementController'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        }
                    }],
                }
            })
            .state('carousel-image-management-detail', {
                parent: 'entity',
                url: '/carousel-image-management/{id:int}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'CarouselImage'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/carousel-image/carousel-image-management-detail.html',
                        controller: 'CarouselImageManagementDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'CarouselImage', function($stateParams, CarouselImage) {
                        return CarouselImage.get({id : $stateParams.id});
                    }]
                }
            })
            .state('carousel-image-management.new', {
                parent: 'carousel-image-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/carousel-image/carousel-image-management-dialog.html',
                        controller: 'CarouselImageManagementDialogController',
                        size: 'lg',
                        backdrop: 'static',
                        resolve: {
                            entity: function () {
                                return {
                                    picture: null,
                                    pictureContentType: null,
                                    orderNum: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('carousel-image-management', null, { reload: true });
                    }, function() {
                        $state.go('carousel-image-management');
                    });
                }]
            })
            .state('carousel-image-management.edit', {
                parent: 'carousel-image-management',
                url: '/{id:int}/edit',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/carousel-image/carousel-image-management-dialog.html',
                        controller: 'CarouselImageManagementDialogController',
                        size: 'lg',
                        backdrop: 'static',
                        resolve: {
                            entity: ['CarouselImage', function(CarouselImage) {
                                return CarouselImage.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('carousel-image-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('carousel-image-management.delete', {
                parent: 'carousel-image-management',
                url: '/{id:int}/delete',
                data: {
                    authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/carousel-image/carousel-image-management-delete-dialog.html',
                        controller: 'CarouselImageManagementDeleteController',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            entity: ['CarouselImage', function(CarouselImage) {
                                return CarouselImage.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('carousel-image-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('CarouselImageManagementController', function ($scope, $state, DataUtils, CarouselImage, ParseLinks, AlertService, pagingParams, paginationConstants) {

        $scope.predicate = pagingParams.predicate;
        $scope.reverse = pagingParams.ascending;
        $scope.openFile = DataUtils.openFile;
        $scope.byteSize = DataUtils.byteSize;
        $scope.loadAll = function() {
            var onSuccess = function (data, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.carouselImages = data;
                $scope.page = pagingParams.page;
            };
            var onError = function (error) {
                AlertService.error(error.data.message);
            };
            CarouselImage.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']
            }, onSuccess, onError);
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.transition = function () {
            $state.transitionTo($state.$current, {
                page: $scope.page,
                sort: $scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'),
                search: $scope.currentSearch
            });
        };

        $scope.loadAll();


    });

'use strict';

angular.module('isahomeApp')
    .factory('CarouselImage', function ($resource, DateUtils) {
        return $resource('api/carousel-images/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('AttachmentDialogController', AttachmentDialogController);

    AttachmentDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Attachment', 'CaseStudy'];

    function AttachmentDialogController ($scope, $stateParams, $uibModalInstance, DataUtils, entity, Attachment, CaseStudy) {
        var vm = this;
        vm.attachment = entity;
        vm.casestudys = CaseStudy.query();
        vm.load = function(id) {
            Attachment.get({id : id}, function(result) {
                vm.attachment = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:attachmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.attachment.id !== null) {
                Attachment.update(vm.attachment, onSaveSuccess, onSaveError);
            } else {
                Attachment.save(vm.attachment, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openFile = DataUtils.openFile;

        vm.byteSize = DataUtils.byteSize;

        vm.setImage = function ($file, attachment) {
            if ($file && $file.$error == 'pattern') {
                return;
            }
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function (e) {
                    var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                    $scope.$apply(function() {
                        attachment.image = base64Data;
                        attachment.imageContentType = $file.type;
                    });
                };
            }
        };

        vm.setThumbnail = function ($file, attachment) {
            if ($file && $file.$error == 'pattern') {
                return;
            }
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function (e) {
                    var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                    $scope.$apply(function() {
                        attachment.thumbnail = base64Data;
                        attachment.thumbnailContentType = $file.type;
                    });
                };
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('AttachmentDetailController', AttachmentDetailController);

    AttachmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Attachment', 'CaseStudy'];

    function AttachmentDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Attachment, CaseStudy) {
        var vm = this;
        vm.attachment = entity;
        vm.load = function (id) {
            Attachment.get({id: id}, function(result) {
                vm.attachment = result;
            });
        };
        var unsubscribe = $rootScope.$on('isahomeApp:attachmentUpdate', function(event, result) {
            vm.attachment = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('AttachmentDeleteController',AttachmentDeleteController);

    AttachmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Attachment'];

    function AttachmentDeleteController($uibModalInstance, entity, Attachment) {
        var vm = this;
        vm.attachment = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Attachment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('attachment', {
            parent: 'entity',
            url: '/attachment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Attachments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/attachment/attachments.html',
                    controller: 'AttachmentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('attachment-detail', {
            parent: 'entity',
            url: '/attachment/{id:int}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Attachment'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/attachment/attachment-detail.html',
                    controller: 'AttachmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Attachment', function($stateParams, Attachment) {
                    return Attachment.get({id : $stateParams.id});
                }]
            }
        })
        .state('attachment.new', {
            parent: 'attachment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attachment/attachment-dialog.html',
                    controller: 'AttachmentDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                image: null,
                                imageContentType: null,
                                thumbnail: null,
                                thumbnailContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('attachment', null, { reload: true });
                }, function() {
                    $state.go('attachment');
                });
            }]
        })
        .state('attachment.edit', {
            parent: 'attachment',
            url: '/{id:int}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attachment/attachment-dialog.html',
                    controller: 'AttachmentDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Attachment', function(Attachment) {
                            return Attachment.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('attachment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('attachment.delete', {
            parent: 'attachment',
            url: '/{id:int}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attachment/attachment-delete-dialog.html',
                    controller: 'AttachmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Attachment', function(Attachment) {
                            return Attachment.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('attachment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('Attachment', Attachment)
        .factory('AttachmentByCase', AttachmentByCase);

    Attachment.$inject = ['$resource', 'DateUtils'];
    AttachmentByCase.$inject = ['$resource', 'DateUtils'];

    function Attachment ($resource, DateUtils) {
        return $resource('api/attachments/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function AttachmentByCase ($resource, DateUtils) {
        return $resource('api/attachments/case/:id', {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('AttachmentSearch', AttachmentSearch);

    AttachmentSearch.$inject = ['$resource'];

    function AttachmentSearch($resource) {
        return $resource('api/_search/attachments', {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .controller('AttachmentController', AttachmentController);

    AttachmentController.$inject = ['$scope', '$state', 'DataUtils', 'Attachment', 'AttachmentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AttachmentController ($scope, $state, DataUtils, Attachment, AttachmentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                AttachmentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Attachment.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.attachments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

    }
})();

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('directory', {
                parent: 'app',
                url: '/directory?page&sort&search',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/directory/directory.html',
                        controller: 'DirectoryController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('directory-import', {
                parent: 'app',
                url: '/directory/import',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/directory/import.html',
                        controller: 'DirectoryImportController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('DirectoryImportController', function ($scope, UserProfile, $localStorage, $sce, $stateParams, Principal, LoginService, PageContentByName, PageContent, CarouselImage, $state) {
        $scope.gridOptions = {};

        $scope.reset = reset;

        $scope.createDirectoryEntries = function(){
            console.log($scope.gridOptions.data);
            angular.forEach($scope.gridOptions.data, function(person, i){
                var p = {};
                p.addressOne = person['Address 1'];
                p.addressTwo = person['Address 2'];
                p.firstName = person['First Name'];
                p.lastName = person['Last Name'];
                p.middleInitial = person['M.I.'];
                p.prefix = person['Prefix'];
                p.degree = person['Degree'];
                p.city = person['City'];
                p.state = person['State'];
                p.zipCode = person['Zip Code'];
                p.country = person['Country'];
                p.phone = person['Phone #'];
                p.fax = person['FAX #'];
                p.email = person['Email address'];
                p.institution = person['Institution'];
                p.paidThrough = person['Member Paid Through'];
                //todo prevent duplicates
                UserProfile.update(p, function(data){
                        $scope.gridOptions.data.pop(i);
                        if($scope.gridOptions.data.length == 0){
                            $state.go('directory')
                        }
                    }
                );

            });
        };

        function reset() {
            $scope.gridOptions.data = [];
            $scope.gridOptions.columnDefs = [];
        }
    })


    .directive("fileread", [function () {
    return {
        scope: {
            opts: '='
        },
        link: function ($scope, $elm, $attrs) {
            $elm.on('change', function (changeEvent) {
                var reader = new FileReader();

                reader.onload = function (evt) {
                    $scope.$apply(function () {
                        var data = evt.target.result;

                        var workbook = XLSX.read(data, {type: 'binary'});

                        var headerNames = XLSX.utils.sheet_to_json( workbook.Sheets[workbook.SheetNames[0]], { header: 1 })[0];

                        var data = XLSX.utils.sheet_to_json( workbook.Sheets[workbook.SheetNames[0]]);
                        $scope.opts.columnDefs = [];
                        headerNames.forEach(function (h) {
                            $scope.opts.columnDefs.push({ field: h });
                        });

                        $scope.opts.data = data;

                        $elm.val(null);
                    });
                };

                reader.readAsBinaryString(changeEvent.target.files[0]);
            });
        }
    }
}]);

'use strict';

angular.module('isahomeApp')
    .controller('DirectoryController', function ($scope, pagingParams, paginationConstants, ParseLinks, UserProfile, UserProfileSearch, $localStorage, $sce, $stateParams, Principal, LoginService, PageContentByName, PageContent, CarouselImage, $state) {
        $scope.pageName = 'Member Directory';
        $scope.$storage = $localStorage;
        $scope.isEditing = false;
        $scope.state = $state;
        $scope.message = {};
        $scope.showForm = true;
        $scope.successMsg = false;

        //User Profile code
        var vm = this;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadAll();

        function loadAll () {
            if (pagingParams.search) {
                UserProfileSearch.query({
                    query: pagingParams.search + '*',
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: 'lastName'
                }, onSuccess, onError);
            } else {
                UserProfile.query({
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: 'lastName'
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.userProfiles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                // AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                // return vm.clear();
                searchQuery = " ";
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            pagingParams.search = searchQuery;
            vm.loadAll();
            // vm.transition();
        }

        function clear () {
            vm.searchQuery = null;
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            // vm.transition();
            vm.search();
        }




        //get directory page content and correct sidebars

        PageContentByName.get({name:$scope.pageName}, function(result){
            $scope.pageContent = result;
            $scope.pageContent.trustedContent = $sce.trustAsHtml(result.content);
            if($scope.pageContent.siteHeaders.length > 0){
                var header = $scope.pageContent.siteHeaders[0];
                $scope.topHeaderName = header.topHeaderName;
                $scope.topHeaderLinkName = header.topHeaderLinkName;
                $scope.mainHeaderName = header.mainHeaderName;
                $scope.mainHeaderLinkName = header.mainHeaderLinkName;
                $scope.subHeaderName = header.name;
                $scope.subHeaderLinkName = header.targetPageLinkName;

                var topName = header.topHeaderName || header.mainHeaderName;
                angular.forEach($scope.$storage.headers, function(header){
                    if(header.name == topName){
                        $scope.topHeader = header;
                    }
                })
            }else{
                $scope.mainHeaderName = $scope.pageContent.title;
                $scope.mainHeaderLinkName = $scope.pageContent.linkName;
            }
        }, function(error){
            $scope.pageContent = error;
            $scope.pageContent.content = $sce.trustAsHtml('<h3>No Page Found</h3>');

        });
    });

'use strict';

angular.module('isahomeApp')
    .filter('characters', function () {
        return function (input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        };
    })
    .filter('words', function () {
        return function (input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        };
    });

'use strict';

angular.module('isahomeApp')
    .directive('jhSort', function () {
        return {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: ['$scope', '$element', function ($scope, $element) {
                this.sort = function (field) {
                    if (field !== $scope.predicate) {
                        $scope.ascending = true;
                    } else {
                        $scope.ascending = !$scope.ascending;
                    }
                    $scope.predicate = field;
                    $scope.$apply();
                    $scope.callback();
                };
                this.applyClass = function (element) {
                    var allThIcons = element.parent().find('span.glyphicon'),
                    sortIcon = 'glyphicon-sort',
                    sortAsc = 'glyphicon-sort-by-attributes',
                    sortDesc = 'glyphicon-sort-by-attributes-alt',
                    remove = sortIcon + ' ' + sortDesc,
                    add = sortAsc,
                    thisIcon = element.find('span.glyphicon');
                    if (!$scope.ascending) {
                        remove = sortIcon + ' ' + sortAsc;
                        add = sortDesc;
                    }
                    allThIcons.removeClass(sortAsc + ' ' + sortDesc);
                    allThIcons.addClass(sortIcon);
                    thisIcon.removeClass(remove);
                    thisIcon.addClass(add);
                };
                this.applyClass($element.find('th[jh-sort-by=\'' + $scope.predicate + '\']'));
            }]
        };
    }).directive('jhSortBy', function () {
        return {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: function (scope, element, attrs, parentCtrl) {
                element.bind('click', function () {
                    parentCtrl.sort(attrs.jhSortBy);
                    parentCtrl.applyClass(element);
                });
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .service('ParseLinks', function () {
        this.parse = function (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        };
    });

'use strict';

angular.module('isahomeApp')
    .service('PaginationUtil', function () {
        // sort can be in the format `id,asc` or `id`
        this.parsePredicate = function (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        };
        this.parseAscending = function (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] == 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        };
        // query params are strings, and need to be parsed
        this.parsePage = function (page) {
            return parseInt(page);
        };
    });

'use strict';

angular.module('isahomeApp')
    .service('DateUtils', function ($filter) {

    this.convertLocaleDateToServer = function(date) {
        if (date) {
            return $filter('date')(date, 'yyyy-MM-dd');
        } else {
            return null;
        }
    };

    this.convertLocaleDateFromServer = function(date) {
        if (date) {
            var dateString = date.split('-');
            return new Date(dateString[0], dateString[1] - 1, dateString[2]);
        }
        return null;
    };

    this.convertDateTimeFromServer = function(date) {
        if (date) {
            return new Date(date);
        } else {
            return null;
        }
    };

    // common date format for all date input fields
    this.dateformat = function() {
        return 'yyyy-MM-dd';
    };
});

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64,
            toBlob: toBlob
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
        function toBlob(b64Data, contentType) {
            contentType = contentType || '';
            var sliceSize = 512;
            b64Data = b64Data.replace(/^[^,]+,/, '');
            b64Data = b64Data.replace(/\s/g, '');

            var byteCharacters = base64.decode(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }
            return new Blob(byteArrays, {type: contentType});
        }
    }
})();

'use strict';

angular.module('isahomeApp')
    .filter('capitalize', function () {
        return function (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        };
    });

/*jshint bitwise: false*/
'use strict';

angular.module('isahomeApp')
    .service('Base64', function () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';
        this.encode = function (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        };

        this.decode = function (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        };
    })
    .factory('StorageService', function ($window) {
        return {

            get: function (key) {
                return JSON.parse($window.localStorage.getItem(key));
            },

            save: function (key, data) {
                $window.localStorage.setItem(key, JSON.stringify(data));
            },

            remove: function (key) {
                $window.localStorage.removeItem(key);
            },

            clearAll : function () {
                $window.localStorage.clear();
            }
        };
    });


'use strict';

angular.module('isahomeApp')
    .factory('LoginService', function ($uibModal) {
        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };
        return {
            open: function () {
                if (modalInstance != null) return;
                modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/components/login/login.html',
                    controller: 'LoginController'
            });
        modalInstance.result.then(
            resetModal,
            resetModal
        );
    }
}
});

'use strict';

angular.module('isahomeApp')
    .controller('LoginController', function ($rootScope, $scope, $state, $timeout, Auth, $uibModalInstance, $window) {
        $scope.authenticationError = false;

        $scope.rememberMe = true;
        $timeout(function (){angular.element('[ng-model="username"]').focus();});
        $scope.login = function (event) {
            event.preventDefault();
            Auth.login({
                username: $scope.username,
                password: $scope.password,
                rememberMe: $scope.rememberMe
            }).then(function () {
                $scope.authenticationError = false;
                $uibModalInstance.close();
                // If we're redirected to login, our
                // previousState is already set in the authExpiredInterceptor. When login succesful go to stored state
                if ($rootScope.redirected && $rootScope.previousStateName) {
                    $state.go($rootScope.previousStateName, $rootScope.previousStateParams, {reload:true});
                    $rootScope.redirected = false;
                } else {
                    $rootScope.$broadcast('authenticationSuccess');
                    if($state.current.name === 'page'){
                        $window.location.reload();
                        return;
                    } else if ($state.current.name === 'finishReset') {
                        $state.go('home');
                        return;
                    }
                    $state.go($state.current.name, {}, {reload:true})
                }
            }).catch(function () {
                $scope.authenticationError = true;
            });
        };

        $scope.cancel = function () {
            $scope.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            $scope.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        };

        $scope.requestResetPassword = function () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        };

        $scope.register = function () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        };
        $scope.contactUs = function () {
            $uibModalInstance.dismiss('cancel');
            $state.go('page', {name: 'contact-us'});
        };
    });

 'use strict';

angular.module('isahomeApp')
    .factory('notificationInterceptor', function ($q, AlertService) {
        return {
            response: function(response) {
                var alertKey = response.headers('X-isahomeApp-alert');
                if (angular.isString(alertKey)) {
                    AlertService.success(alertKey, { param : response.headers('X-isahomeApp-params')});
                }
                return response;
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .factory('errorHandlerInterceptor', function ($q, $rootScope) {
        return {
            'responseError': function (response) {
                if (!(response.status === 401 && (response.data === '' ||  (response.data.title !== undefined || response.data.path.indexOf('/api/account') === 0 )))) {
                    $rootScope.$emit('isahomeApp.httpError', response);
                }
                return $q.reject(response);
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    /* globals document */
    .factory('authExpiredInterceptor', function ($rootScope, $q, $injector) {
        function getCSRF() {
            var name = 'CSRF-TOKEN=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {c = c.substring(1);}

                if (c.indexOf(name) !== -1) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }

        return {
            responseError: function(response) {
                // If we have an unauthorized request we redirect to the login page
                // Don't do this check on the account API to avoid infinite loop
                if (response.status === 401 && ((response.data.path !== undefined && response.data.path.indexOf('/api/account') === -1) || (response.data.title !== undefined))){
                    var Auth = $injector.get('Auth');
                    var $state = $injector.get('$state');
                    var to = $rootScope.toState;
                    var params = $rootScope.toStateParams;
                    Auth.logout();
                    if(to.name != 'accessdenied'){
                        $rootScope.previousStateName = to;
                        $rootScope.previousStateNameParams = params;
                    }
                    var LoginPopupService = $injector.get('LoginService');
                    LoginPopupService.open();
                } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                    // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                    var $http = $injector.get('$http');
                    return $http.get('/').finally(function() { return afterCSRFRenewed(response); });
                }
                return $q.reject(response);
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function (uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    });

'use strict';

angular.module('isahomeApp')
    .config(function (uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    });

'use strict';

angular.module('isahomeApp')
    .constant('paginationConstants', {
        'itemsPerPage': 20
    });

'use strict';

angular.module('isahomeApp')
    .directive('minbytes', function () {
        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ngModel) {
                if (!ngModel) {
                    return;
                }

                ngModel.$validators.minbytes = function (modelValue) {
                    return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
                };
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .directive('maxbytes', function () {
        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }

        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ngModel) {
                if (!ngModel) {
                    return;
                }

                ngModel.$validators.maxbytes = function (modelValue) {
                    return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
                };
            }
        };
    });

/* globals $ */
'use strict';

angular.module('isahomeApp')
    .directive('showValidation', function() {
        return {
            restrict: 'A',
            require: 'form',
            link: function (scope, element) {
                element.find('.form-group').each(function() {
                    var $formGroup = $(this);
                    var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                    if ($inputs.length > 0) {
                        $inputs.each(function() {
                            var $input = $(this);
                            scope.$watch(function() {
                                return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                            }, function(isInvalid) {
                                $formGroup.toggleClass('has-error', isInvalid);
                            });
                        });
                    }
                });
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .provider('AlertService', function () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = ['$timeout', '$sce', function($timeout, $sce) {
            var toast = this.toast,
            alertId = 0, // unique id for each alert. Starts from 0.
            alerts = [],
            timeout = 5000; // default timeout

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return exports.closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return this.closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };
        }];

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

    });

'use strict';

angular.module('isahomeApp')
    .directive('jhAlert', function(AlertService) {
        return {
            restrict: 'E',
            template: '<div class="alerts" ng-cloak="">' +
                            '<div ng-repeat="alert in alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                                '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close()"><pre>{{ alert.msg }}</pre></uib-alert>' +
                            '</div>' +
                      '</div>',
            controller: ['$scope',
                function($scope) {
                    $scope.alerts = AlertService.get();
                    $scope.$on('$destroy', function () {
                        $scope.alerts = [];
                    });
                }
            ]
        };
    })
    .directive('jhAlertError', function(AlertService, $rootScope) {
        return {
            restrict: 'E',
            template: '<div class="alerts" ng-cloak="">' +
                            '<div ng-repeat="alert in alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                                '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close(alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                            '</div>' +
                      '</div>',
            controller: ['$scope',
                function($scope) {

                    $scope.alerts = [];


                    var addErrorAlert = function (message, key, data) {
                        $scope.alerts.push(
                            AlertService.add(
                                {
                                    type: 'danger',
                                    msg: message,
                                    timeout: 5000,
                                    toast: AlertService.isToast(),
                                    scoped: true
                                },
                                $scope.alerts
                            )
                        );
                    };

                    var cleanHttpErrorListener = $rootScope.$on('isahomeApp.httpError', function (event, httpResponse) {
                        var i;
                        event.stopPropagation();
                        switch (httpResponse.status) {
                            // connection refused, server not reachable
                            case 0:
                                addErrorAlert('Server not reachable','error.server.not.reachable');
                                break;

                            case 400:
                                var errorHeader = httpResponse.headers('X-isahomeApp-error');
                                var entityKey = httpResponse.headers('X-isahomeApp-params');
                                if (errorHeader) {
                                    var entityName = entityKey;
                                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                                        var fieldError = httpResponse.data.fieldErrors[i];
                                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                                    }
                                } else if (httpResponse.data && httpResponse.data.message) {
                                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                                } else {
                                    addErrorAlert(httpResponse.data);
                                }
                                break;

                            default:
                                if (httpResponse.data && httpResponse.data.message) {
                                    addErrorAlert(httpResponse.data.message);
                                } else {
                                    addErrorAlert(JSON.stringify(httpResponse));
                                }
                        }
                    });

                    $scope.$on('$destroy', function () {
                        if(cleanHttpErrorListener !== undefined && cleanHttpErrorListener !== null){
                            cleanHttpErrorListener();
                            $scope.alerts = [];
                        }
                    });
                }
            ]
        };
    });

'use strict';

angular.module('isahomeApp')
    .controller('CasesViewController', function ($scope, $sce, Principal, Comment, CommentByCase, CaseStudy, $stateParams, PageContent, CarouselImage, $state, AttachmentByCase) {
        function getAccount() {
            Principal.identity().then(function(account) {
                $scope.account = account;
                $scope.isAuthenticated = Principal.isAuthenticated;
            });
        }
        getAccount();

        $scope.showCommentForm = false;
        $scope.showForm = function(data){
            $scope.showCommentForm = data;
        };


        $scope.reloadComments = function(){
            CommentByCase.query({id:$scope.case.id}, function(data){
                $scope.comments = data;
            })
        }

        CaseStudy.query({ size: 10, page: 0, sort: ['id,desc'] }, function(results){
            $scope.caseStudies = results;
        });
        CaseStudy.get({ id: $stateParams.id }, function(result){
            $scope.case = result;
            $scope.case.trustedContent = $sce.trustAsHtml(result.descr);
            $scope.case.trustedContent2 = $sce.trustAsHtml(result.descr2);
            AttachmentByCase.query({id:result.id}, function(data){
                $scope.attachments = data;
            })
            $scope.reloadComments();
        });
        $scope.newComment = {author: '', comment: ''};
        $scope.postComment = function(newComment){
            newComment.commentDate = new Date();
            newComment.caseStudyId = $scope.case.id;
            Comment.update(newComment,function(result){
                $scope.newComment = {author: '', comment: ''};
                $scope.showCommentForm = false;
                $scope.reloadComments();
            })
        }


    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('cases', {
                parent: 'app',
                url: '/strabismus-forum',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/cases/cases.html',
                        controller: 'CasesController'
                    }
                }
            })
            .state('cases.view', {
                parent: 'cases',
                url: '/{id:int}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/cases/cases.view.html',
                        controller: 'CasesViewController'
                    }
                }
            })
            .state('cases.new', {
                parent: 'cases',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/case-study/case-study-dialog.html',
                        controller: 'CaseStudyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    descr: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('cases', {id: result.id}, { reload: true });
                    }, function() {
                        $state.go('cases');
                    });
                }]
            })
            .state('cases.edit', {
                parent: 'cases.view',
                url: '/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/case-study/case-study-dialog.html',
                        controller: 'CaseStudyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CaseStudy', function(CaseStudy) {
                                return CaseStudy.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('cases.view', {id: result.id}, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('cases.delete', {
                parent: 'cases.view',
                url: '/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/case-study/case-study-delete-dialog.html',
                        controller: 'CaseStudyDeleteController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['CaseStudy', function(CaseStudy) {
                                return CaseStudy.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('cases', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('CasesController', function ($scope, $sce, Principal, CaseStudy, PageContentByName, PageContent, CarouselImage, $state) {
        function getAccount() {
            Principal.identity().then(function(account) {
                $scope.account = account;
                $scope.isAuthenticated = Principal.isAuthenticated;
            });
        }
        getAccount();

        CaseStudy.query({ size: 100 }, function(results){
            $scope.caseStudies = results;
        })
        CaseStudy.query({ size: 10, page: 0, sort: ['id,desc'] }, function(results){
            $scope.sideBarCaseStudies = results;
        })
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'navbar@': {
                        templateUrl: 'app/layouts/navbar/navbar.html',
                        controller: 'NavbarController'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'FooterController'
                    }
                },
                resolve: {
                    authorize: ['Auth',
                        function (Auth) {
                            return Auth.authorize();
                        }
                    ]
                }
            });
    });

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('isahomeApp')
        .constant('ENV', "prod")
        .constant('VERSION', "0.0.1-SNAPSHOT")
;
})();

'use strict';

angular.module('isahomeApp')
    // uncomment below to make alerts look like toast
    .config(function ($urlRouterProvider, $httpProvider, $locationProvider, $localStorageProvider,  httpRequestInterceptorCacheBusterProvider/*, AlertServiceProvider*/) {
        //AlertServiceProvider.showAsToast(true);
        $locationProvider.html5Mode({ enabled: true, requireBase: true });

        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/^(?!((api\/page-contents\/link\/*)|(api\/carousel-images)|(api\/main-headers)|(api\/site-headers\/main-headers))(\/|$)).*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application interceptor here

        $localStorageProvider.setKeyPrefix('jhi-');
    })
    // jhipster-needle-angularjs-add-config JHipster will add new application configuration here
    .config(['$urlMatcherFactoryProvider', function($urlMatcherFactory) {
        $urlMatcherFactory.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }]);

'use strict';

angular.module('isahomeApp').controller('UserManagementDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'User', 
        function($scope, $stateParams, $uibModalInstance, entity, User) {

        $scope.user = entity;
        $scope.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        var onSaveSuccess = function (result) {
            $scope.isSaving = false;
            $uibModalInstance.close(result);
        };

        var onSaveError = function () {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.user.id !== null) {
                User.update($scope.user, onSaveSuccess, onSaveError);
            } else {
                $scope.user.langKey = 'en';
                User.save($scope.user, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('isahomeApp')
    .controller('UserManagementDetailController', function ($scope, $stateParams, User) {
        $scope.user = {};
        $scope.load = function (login) {
            User.get({login: login}, function(result) {
                $scope.user = result;
            });
        };
        $scope.load($stateParams.login);
    });

'use strict';

angular.module('isahomeApp')
	.controller('UserManagementDeleteController', function($scope, $uibModalInstance, entity, User) {

        $scope.user = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('user-management', {
                parent: 'admin',
                url: '/user-management?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'isahome'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                }
            })
            .state('user-management-detail', {
                parent: 'admin',
                url: '/user/:login',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'isahome'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController'
                    }
                }
            })
            .state('user-management.new', {
                parent: 'user-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        size: 'lg',
                        backdrop: 'static',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null, login: null, firstName: null, lastName: null, email: null,
                                    activated: true, langKey: null, createdBy: null, createdDate: null,
                                    lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                    resetKey: null, authorities: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('user-management', null, { reload: true });
                    }, function() {
                        $state.go('user-management');
                    });
                }]
            })
            .state('user-management.edit', {
                parent: 'user-management',
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        size: 'lg',
                        backdrop: 'static',
                        resolve: {
                            entity: ['User', function(User) {
                                return User.get({login : $stateParams.login});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('user-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('user-management.delete', {
                parent: 'user-management',
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            entity: ['User', function(User) {
                                return User.get({login : $stateParams.login});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('user-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('UserManagementController', function ($scope, $state, Principal, User, UserSearch, ParseLinks, paginationConstants, pagingParams) {
        $scope.users = [];
        $scope.authorities = ['ROLE_USER', 'ROLE_ADMIN'];

        $scope.page = pagingParams.page;
        $scope.predicate = pagingParams.predicate;
        $scope.reverse = pagingParams.ascending;
        $scope.searchQuery = pagingParams.search;
        $scope.itemsPerPage = paginationConstants.itemsPerPage;
        $scope.currentSearch = pagingParams.search;
        Principal.identity().then(function(account) {
            $scope.currentAccount = account;
        });
        $scope.loadAll = function () {
            if (pagingParams.search) {
                UserSearch.query({
                    query: $scope.currentSearch + '*',
                    page: $scope.page - 1,
                    size: paginationConstants.itemsPerPage,
                }, onSuccess, onError);
            } else {
                User.query({page: $scope.page - 1, size: paginationConstants.itemsPerPage, sort: sort()}, onSuccess, onError);
            }

        };
        function sort() {
            var result = [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc')];
            if ($scope.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }
        function onError(data) {
            console.log(data)
        }
        function onSuccess(data, headers) {
            $scope.links = ParseLinks.parse(headers('link'));
            $scope.totalItems = headers('X-Total-Count');
            $scope.queryCount = $scope.totalItems;
            $scope.users = data;
            $scope.page = pagingParams.page;
        }

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.setActive = function (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                $scope.loadAll();
                $scope.clear();
            });
        };

        $scope.clear = function () {
            $scope.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            if ($scope.editForm) {
                $scope.editForm.$setPristine();
                $scope.editForm.$setUntouched();
            }
            $scope.links = null;
            $scope.page = 1;
            $scope.predicate = 'id';
            $scope.reverse = true;
            $scope.currentSearch = null;
            $scope.transition();
        };

        $scope.transition = function() {
            $state.transitionTo($state.$current, {
                page: $scope.page,
                sort: $scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'),
                search: $scope.currentSearch
            });
        }

        $scope.search = function (searchQuery) {
            if (!searchQuery){
                return $scope.clear();
            }
            $scope.links = null;
            $scope.page = 1;
            $scope.predicate = '_score';
            $scope.reverse = false;
            $scope.currentSearch = searchQuery;
            $scope.transition();
        }

    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('metrics', {
                parent: 'admin',
                url: '/appmetrics',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Application Metrics'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/metrics/metrics.html',
                        controller: 'MetricsController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .factory('MetricsService', function ($rootScope, $http) {
        return {
            getMetrics: function () {
                return $http.get('metrics/metrics').then(function (response) {
                    return response.data;
                });
            },

            threadDump: function () {
                return $http.get('dump').then(function (response) {
                    return response.data;
                });
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .controller('MetricsModalController', function($scope, $uibModalInstance, threadDump) {

        $scope.threadDump = threadDump;
        $scope.threadDumpRunnable = 0;
        $scope.threadDumpWaiting = 0;
        $scope.threadDumpTimedWaiting = 0;
        $scope.threadDumpBlocked = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                $scope.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                $scope.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                $scope.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                $scope.threadDumpBlocked += 1;
            }
        });

        $scope.threadDumpAll = $scope.threadDumpRunnable + $scope.threadDumpWaiting +
            $scope.threadDumpTimedWaiting + $scope.threadDumpBlocked;

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.getLabelClass = function (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .controller('MetricsController', function ($scope, MetricsService, $uibModal) {
        $scope.metrics = {};
        $scope.updatingMetrics = true;

        $scope.refresh = function () {
            $scope.updatingMetrics = true;
            MetricsService.getMetrics().then(function (promise) {
                $scope.metrics = promise;
                $scope.updatingMetrics = false;
            }, function (promise) {
                $scope.metrics = promise.data;
                $scope.updatingMetrics = false;
            });
        };

        $scope.$watch('metrics', function (newValue) {
            $scope.servicesStats = {};
            $scope.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    $scope.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    $scope.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        $scope.refresh();

        $scope.refreshThreadDumpData = function() {
            MetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'MetricsModalController',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('logs', {
                parent: 'admin',
                url: '/logs',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Logs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/logs/logs.html',
                        controller: 'LogsController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .factory('LogsService', function ($resource) {
        return $resource('api/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });
    });

'use strict';

angular.module('isahomeApp')
    .controller('LogsController', function ($scope, LogsService) {
        $scope.loggers = LogsService.findAll();

        $scope.changeLevel = function (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                $scope.loggers = LogsService.findAll();
            });
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('health', {
                parent: 'admin',
                url: '/apphealth',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Health checks'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/health/health.html',
                        controller: 'HealthController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .factory('HealthService', function ($rootScope, $http) {
        return {
            checkHealth: function () {
                return $http.get('health').then(function (response) {
                    return response.data;
                });
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .controller('HealthModalController', function($scope, $uibModalInstance, currentHealth, baseName, subSystemName) {

        $scope.currentHealth = currentHealth;
        $scope.baseName = baseName;
        $scope.subSystemName = subSystemName;

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('isahomeApp')
    .controller('HealthController', function ($scope, HealthService, $uibModal) {
        $scope.updatingHealth = true;
        $scope.separator = '.';

        $scope.refresh = function () {
            $scope.updatingHealth = true;
            HealthService.checkHealth().then(function (response) {
                $scope.healthData = $scope.transformHealthData(response);
                $scope.updatingHealth = false;
            }, function (response) {
                $scope.healthData =  $scope.transformHealthData(response.data);
                $scope.updatingHealth = false;
            });
        };

        $scope.refresh();

        $scope.getLabelClass = function (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        };

        $scope.transformHealthData = function (data) {
            var response = [];
            $scope.flattenHealthData(response, null, data);
            return response;
        };

        $scope.flattenHealthData = function (result, path, data) {
            angular.forEach(data, function (value, key) {
                if ($scope.isHealthObject(value)) {
                    if ($scope.hasSubSystem(value)) {
                        $scope.addHealthObject(result, false, value, $scope.getModuleName(path, key));
                        $scope.flattenHealthData(result, $scope.getModuleName(path, key), value);
                    } else {
                        $scope.addHealthObject(result, true, value, $scope.getModuleName(path, key));
                    }
                }
            });
            return result;
        };

        $scope.getModuleName = function (path, name) {
            var result;
            if (path && name) {
                result = path + $scope.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        };


        $scope.showHealth = function(health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return $scope.baseName;
                    },
                    subSystemName: function() {
                        return $scope.subSystemName;
                    }

                }
            });
        };

        $scope.addHealthObject = function (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!$scope.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        };

        $scope.hasSubSystem = function (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        };

        $scope.isHealthObject = function (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        };

        $scope.baseName = function (name) {
            if (name) {
              var split = name.split('.');
              return split[0];
            }
        };

        $scope.subSystemName = function (name) {
            if (name) {
              var split = name.split('.');
              split.splice(0, 1);
              var remainder = split.join('.');
              return remainder ? ' - ' + remainder : '';
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('docs', {
                parent: 'admin',
                url: '/docs',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'API'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/docs/docs.html'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('configuration', {
                parent: 'admin',
                url: '/configuration',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Configuration'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/configuration/configuration.html',
                        controller: 'ConfigurationController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .factory('ConfigurationService', function ($rootScope, $filter, $http) {
        return {
            get: function() {
                return $http.get('configprops').then(function (response) {
                    var properties = [];
                    angular.forEach(response.data, function (data) {
                        properties.push(data);
                    });
                    var orderBy = $filter('orderBy');
                    return orderBy(properties, 'prefix');
                });
            },
            getEnv: function () {
                return $http.get('env').then(function (response) {
                    var properties = {};
                    angular.forEach(response.data, function (val,key) {
                        var vals = [];
                        angular.forEach(val, function (v,k) {
                            vals.push({ key:k, val:v });
                        });
                        properties[key] = vals;
                    });
                    return properties;
                });
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .controller('ConfigurationController', function ($scope, ConfigurationService) {
        ConfigurationService.get().then(function(configuration) {
            $scope.configuration = configuration;
        });
        ConfigurationService.getEnv().then(function (configuration) {
            $scope.allConfiguration = configuration;
        });
    });

'use strict';

angular.module('isahomeApp')
    .controller('AdminCenterVideosUploadController', function ($scope, $state, $window, PageContent, SiteHeader, MainSiteHeader) {
        $scope.videoTitle = "Title";
        $scope.errorMessage = "";
        $scope.error=false;
        $scope.uploaded=false;
        $scope.success=false;
        $scope.videoId='';
        $scope.reloadPage= function () {
            $window.location.reload();
        };

        $scope.$on('event:youtube-video-uploaded', function (event, info) {
            console.log(event);
            $scope.videoId = info.id;
            $scope.uploaded=true;
            $scope.$apply();

        });
        $scope.$on('event:youtube-video-failed', function (event, info) {
           console.log(event);
            $scope.errorMessage = info.message;
            $scope.uploaded=false;
            $scope.error = true;
            $scope.videoId = null;
            $scope.$apply();
        });
        $scope.$on('event:youtube-video-processed', function (event, info) {
           console.log(event);
            console.log(info);
            $scope.videoId = info.id;
            $scope.uploaded=false;
            $scope.success=true;

            var newPage = {};
            newPage.title = $scope.videoTitle;
            newPage.content = '<logged-in-only/><iframe width="420" height="315" src="https://www.youtube.com/embed/'+ info.id +'" frameborder="0" allowfullscreen></iframe>'
            // create a page
            PageContent.update(newPage, function(result){
                $scope.newPageId = result.id;
                result.linkName = result.id;
                PageContent.update(result, function(result){
                    console.log(result);
                    $state.go('page', {name: result.id});
                });
            });
            // open the youtube video

            $scope.$apply();
        });
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('adminVideos', {
                parent: 'adminCenter',
                url: '/videos',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Video Management'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/center/videos/admin.center.videos.html',
                        controller: 'AdminCenterVideosController'
                    }
                }
            })
            .state('adminVideos.upload', {
                parent: 'adminVideos',
                url: '/upload',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Upload Video'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/center/videos/admin.center.videos.upload.html',
                        controller: 'AdminCenterVideosUploadController'
                    }
                }
            })
    });

'use strict';

angular.module('isahomeApp')
    .controller('AdminCenterVideosController', function ($scope, $state, $http, SiteHeader, MainSiteHeader) {
        // $scope.videoTitle = "Title";
        // $scope.error=false;
        // $scope.uploaded=false;
        // $scope.success=false;
        // $scope.videos = [];
        // $scope.username = 'UCb2yAi4ioIoBLZV616mAmtw';
        // $scope.apiKey='AIzaSyDDfcLmL4n-tOIm-I1yUd-O5jQIVBznPfY';
        //
        // $scope.$on('event:youtube-video-uploaded', function (event) {
        //     console.log(event);
        //     $scope.uploaded=true;
        //     $scope.$apply();
        //
        // });
        // $scope.$on('event:youtube-video-failed', function (event) {
        //    console.log(event);
        //     $scope.uploaded=false;
        //     $scope.error = true;
        //     $scope.$apply();
        // });
        // $scope.$on('event:youtube-video-processed', function (event) {
        //    console.log(event);
        //     $scope.uploaded=false;
        //     $scope.success=true;
        //     $scope.$apply();
        // });
        //
        // $http.get('https://www.googleapis.com/youtube/v3/channels?part=contentDetails&forUsername=' + $scope.username + '&key=' + $scope.apiKey)
        //     .success(function(result){
        //         var uploadsId = result.items[0].contentDetails.relatedPlaylists.uploads;
        //         $http.get('https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId='+ uploadsId +'&key=' + $scope.apiKey)
        //             .success(function(result){
        //                 angular.forEach(result.items, function(data){
        //                     var item = [data.snippet.resourceId.videoId, data.snippet.thumbnails.default];
        //                     $scope.videos.push(item);
        //                 });
        //             })
        //             .error(function(result){
        //                 console.log(result);
        //             })
        //     })
        //     .error(function(result){
        //         console.log(result);
        //     })
    });

'use strict';

angular.module('isahomeApp').controller('UnapprovedCommentDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PageComment',
        function($scope, $stateParams, $uibModalInstance, DataUtils, entity, PageComment) {

        $scope.pageComment = entity;
        $scope.load = function(id) {
            PageComment.get({id : id}, function(result) {
                $scope.pageComment = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('isahomeApp:pageCommentUpdate', result);
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };

        var onSaveError = function (result) {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.pageComment.id != null) {
                PageComment.update($scope.pageComment, onSaveSuccess, onSaveError);
            } else {
                PageComment.save($scope.pageComment, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.abbreviate = DataUtils.abbreviate;

        $scope.byteSize = DataUtils.byteSize;
        $scope.datePickerForCommentDate = {};

        $scope.datePickerForCommentDate.status = {
            opened: false
        };

        $scope.datePickerForCommentDateOpen = function($event) {
            $scope.datePickerForCommentDate.status.opened = true;
        };
}]);

'use strict';

angular.module('isahomeApp')
    .controller('UnapprovedCommentDetailController', function ($scope, $rootScope, $stateParams, DataUtils, entity, PageComment, PageCommentApprovalUpdate) {
        $scope.pageComment = entity;
        $scope.load = function (id) {
            PageComment.get({id: id}, function(result) {
                $scope.pageComment = result;
            });
        };
        var unsubscribe = $rootScope.$on('isahomeApp:pageCommentUpdate', function(event, result) {
            $scope.pageComment = result;
        });
        $scope.$on('$destroy', unsubscribe);

        $scope.byteSize = DataUtils.byteSize;
        $scope.approveComment = function (status) {
            PageCommentApprovalUpdate.update({id: $stateParams.id, status: status}, {}, function (resp) {
                $scope.load($stateParams.id)
            }, function (err) {
                $scope.error = true;
            })
        }
    });

'use strict';

angular.module('isahomeApp')
	.controller('UnapprovedCommentDeleteController', function($scope, $uibModalInstance, entity, PageComment) {

        $scope.pageComment = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            PageComment.delete({id: id},
                function () {
                    $scope.$emit('isahomeApp:pageCommentUpdate', null);
                    $uibModalInstance.close(true);
                });
        };

    });

(function() {
    'use strict';

    angular
        .module('isahomeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('unapproved-comments', {
            parent: 'adminCenter',
            url: '/unapproved-comments?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Unapproved Comments'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/center/unapproved-comments/pageComment.html',
                    controller: 'UnapprovedCommentController',
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
        .state('unapproved-comments.detail', {
            parent: 'unapproved-comments',
            url: '/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Unapproved Comment'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/center/unapproved-comments/pageComment-detail.html',
                    controller: 'UnapprovedCommentDetailController'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PageComment', function($stateParams, PageComment) {
                    return PageComment.get({id : $stateParams.id});
                }]
            }
        })
        .state('unapproved-comments.edit', {
            parent: 'unapproved-comments',
            url: '/{id:int}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/center/unapproved-comments/pageComment-dialog.html',
                    controller: 'UnapprovedCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PageComment', function(PageComment) {
                            return PageComment.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('unapproved-comments.delete', {
            parent: 'unapproved-comments',
            url: '/{id:int}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/center/unapproved-comments/pageComment-delete-dialog.html',
                    controller: 'UnapprovedCommentDeleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['PageComment', function(PageComment) {
                            return PageComment.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('^');
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

'use strict';

angular.module('isahomeApp')
    .controller('UnapprovedCommentController', function ($scope, $rootScope, $state, DataUtils, PageComment, PageCommentSearch, ParseLinks, PageCommentApproval, PageCommentApprovalUpdate) {
        $scope.pageComments = [];
        $scope.predicate = 'id';
        $scope.reverse = true;
        $scope.approved = false;
        $scope.page = 1;
        $scope.loadAll = function() {
            PageCommentApproval.query({isApproved: $scope.approved, page: $scope.page - 1, size: 20, sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.pageComments = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.search = function () {
            PageCommentSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.pageComments = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.pageComment = {
                author: null,
                comment: null,
                commentDate: null,
                pageLinkName: null,
                approved: null,
                id: null
            };
        };

        $scope.abbreviate = DataUtils.abbreviate;

        $scope.byteSize = DataUtils.byteSize;
        $scope.toggleApproved = function () {
            $scope.approved = !$scope.approved;
            $scope.loadAll()
        }
        $scope.approveComment = function (id) {
            PageCommentApprovalUpdate.update({id: id, status: !$scope.approved}, {}, function (resp) {
                $scope.loadAll()
            }, function (err) {
                $scope.error = true;
            })
        }
        var unsubscribe = $rootScope.$on('isahomeApp:pageCommentUpdate', function() {
            $scope.loadAll();
        });
        $scope.$on('$destroy', unsubscribe);

    });

'use strict';

angular.module('isahomeApp')
    .controller('SearchResetController', function ($scope, PageContent, $http) {
        $scope.reindex = function(){
            $http.post("/api/elasticsearch/index", {}).then(function(data){
                console.log(data);
            });
        }
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('adminPages', {
                parent: 'adminCenter',
                url: '/page-management?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Page Management'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/center/pages/admin.center.pages.html',
                        controller: 'AdminCenterPagesController'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        }
                    }],
                }
            })
            .state('adminPages.detail', {
                parent: 'adminCenter',
                url: '/page-management/{id:int}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'PageContent'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/center/pages/admin.center.pages.detail.html',
                        controller: 'PageContentDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PageContent', function($stateParams, PageContent) {
                        return PageContent.get({id : $stateParams.id});
                    }]
                }
            })
            .state('adminPages.new', {
                parent: 'adminPages',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/center/pages/admin.center.pages.dialog.html',
                        controller: 'PageContentDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    linkName: null,
                                    title: null,
                                    content: null,
                                    lastUpdate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('adminPages', null, { reload: true });
                    }, function() {
                        $state.go('adminPages');
                    });
                }]
            })
            .state('adminPages.edit', {
                parent: 'adminPages',
                url: '/{id:int}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/center/pages/admin.center.pages.dialog.html',
                        controller: 'PageContentDialogController',
                        size: 'lg',
                        controllerAs: 'vm',
                        resolve: {
                            entity: ['PageContent', function(PageContent) {
                                return PageContent.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('adminPages', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('adminPages.delete', {
                parent: 'adminPages',
                url: '/{id:int}/delete',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/page-content/page-content-delete-dialog.html',
                        controller: 'PageContentDeleteController',
                        size: 'md',
                        controllerAs: 'vm',
                        resolve: {
                            entity: ['PageContent', function(PageContent) {
                                return PageContent.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('adminPages', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('AdminCenterPagesController', function ($scope, $state, DataUtils, PageContentInfo, PageContentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {

        $scope.predicate = pagingParams.predicate;
        $scope.reverse = pagingParams.ascending;
        $scope.openFile = DataUtils.openFile;
        $scope.byteSize = DataUtils.byteSize;
        $scope.loadAll = function() {
            var onSuccess = function (data, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.pageContents = data;
                $scope.page = pagingParams.page;
            };
            var onError = function (error) {
                AlertService.error(error.data.message);
            };
            PageContentInfo.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']
            }, onSuccess, onError);
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.search = function () {
            PageContentSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.pageContents = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.transition = function () {
            $state.transitionTo($state.$current, {
                page: $scope.page,
                sort: $scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'),
                search: $scope.currentSearch
            });
        };

        $scope.loadAll();


    });

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
            'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
            '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
            'of {{$ctrl.queryCount}} items.' +
            '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('isahomeApp')
        .component('jhiItemCount', jhiItemCount);
})();

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('adminHeaders', {
                parent: 'adminCenter',
                url: '/headers',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Header Management'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/center/headers/admin.center.headers.html',
                        controller: 'AdminCenterHeadersController'
                    }
                }
            })
            .state('adminHeaders.new', {
                parent: 'adminHeaders',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/center/headers/admin.center.header.dialog.html',
                        controller: 'SiteHeaderDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    orderNum: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('adminHeaders', null, { reload: true });
                    }, function() {
                        $state.go('adminHeaders');
                    });
                }]
            })
            .state('adminHeaders.edit', {
                parent: 'adminHeaders',
                url: '/{id:int}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/center/headers/admin.center.header.dialog.html',
                        controller: 'SiteHeaderDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: ['SiteHeader', function(SiteHeader) {
                                return SiteHeader.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('adminHeaders', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('adminHeaders.delete', {
                parent: 'adminHeaders',
                url: '/{id:int}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/site-header/site-header-delete-dialog.html',
                        controller: 'SiteHeaderDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['SiteHeader', function(SiteHeader) {
                                return SiteHeader.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('adminHeaders', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('AdminCenterHeadersController', function ($scope, $state, SiteHeader, MainSiteHeader) {
        // function updateSubHeaders(subheaders){
        //     for(var i = 0; i < subheaders.length; i++){
        //         subheaders[i].orderNum = i+1;
        //         SubHeader.update(subheaders[i]);
        //     }
        // }

        $scope.reverse = true;
        MainSiteHeader.query({ page: 0, size: 300, sort: ['orderNum' + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id'] },
            function(result){
                $scope.mainHeaders = result;
                // angular.forEach($scope.mainHeaders, function(header){
                //     SubHeaderByMainHeader.get({id:header.id}, function(subheaders){
                //         header.subheaders = subheaders;
                //     });
                // });
            });


        $scope.mainHeaderSortOptions = {
            containerPositioning: 'relative',
            accept: function (sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.options.containment === destSortableScope.options.containment;
             },

            itemMoved: function (event) {
                if(event.dest.sortableScope.options.containment !== event.source.sortableScope.options.containment){
                    return null;
                }
                console.log(event);
            },
            orderChanged: function () {
                //update orderNum for all mainHeaders
                // for(var i = 0; i < $scope.mainHeaders.length; i++){
                //     $scope.mainHeaders[i].orderNum = i + 1;
                //     //console.log($scope.mainHeaders[i]);
                //     MainHeader.update($scope.mainHeaders[i], function(result){
                //         if(result.orderNum === $scope.mainHeaders.length){
                //             //console.log("All main headers updated");
                //             $state.go('adminHeaders', null, { reload: true });
                //         }
                //     });
                // }
            },
            containment: '#board1'
        };
        // $scope.subHeaderSortOptions = {
        //     containerPositioning: 'relative',
        //     accept: function (sourceItemHandleScope, destSortableScope) {
        //         return sourceItemHandleScope.itemScope.sortableScope.options.containment === destSortableScope.options.containment;
        //     },
        //     itemMoved: function (event) {
        //         //update main header when moving between columns
        //         event.source.itemScope.modelValue.mainHeaderName = event.dest.sortableScope.$parent.header.name;
        //         event.source.itemScope.modelValue.mainHeaderId = event.dest.sortableScope.$parent.header.id;
        //
        //         updateSubHeaders(event.source.sortableScope.$parent.header.subheaders);
        //         updateSubHeaders(event.dest.sortableScope.$parent.header.subheaders);
        //         //$state.go('adminHeaders', null, { reload: true });
        //
        //     },
        //     orderChanged: function (event) {
        //         //update orderNum for subheaders
        //         updateSubHeaders(event.dest.sortableScope.$parent.header.subheaders);
        //         //$state.go('adminHeaders', null, { reload: true });
        //
        //     },
        //     containment: '#board'
        // };
        // $scope.addNewSubheader = function(header){
        //     console.log(header);
        // };

    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('flipbooks', {
                parent: 'adminCenter',
                url: '/flipbooks',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Flipbook Management'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/center/flipbooks/admin.flipbooks.html',
                        controller: 'AdminFlipbooksController'
                    }
                }
            })
    });

'use strict';

angular.module('isahomeApp')
    .controller('AdminFlipbooksController', function ($scope, $state, $http, SiteHeader, MainSiteHeader) {
        $scope.sites = [];
        $http.get('http://flipbooks.isahome.org').success(function(test){
            var output = test;
            var tableStart = test.indexOf('<table>');
            var tableEnd = test.indexOf('</table>');
            output = output.substr(tableStart+7, tableEnd-tableStart-7);
            var patt = /href="(.*?)"/g;
            var match = "";
            while(match = patt.exec(output)){
                if(match[0][6] != '?'){
                    var plainUrl = match[0].substr(6);
                    $scope.sites.push(plainUrl.substr(0, plainUrl.length-1));
                }
            }
        })
    });

'use strict';

angular.module('isahomeApp')
    .controller('AdminCenterController', function ($scope, PageContent) {

    });

/* globals $ */
'use strict';

angular.module('isahomeApp')
    .directive('adminMenuBar', function () {
        return {
            replace: true,
            restrict: 'E',
            template: '<div id="adminMenuBar">' +
            '<button class="btn btn-info" ui-sref="adminHeaders">Headers</button> ' +
            '<button class="btn btn-info" ui-sref="adminPages">Pages</button> ' +
            '<button class="btn btn-info" ui-sref="carousel-image-management">Carousel</button> ' +
            '<button class="btn btn-info" ui-sref="adminVideos">Videos</button> ' +
            '<button class="btn btn-info" ui-sref="registration">Registrations</button> ' +
            '<button class="btn btn-info" ui-sref="searchReset">Reset Search Index</button> ' +
            '<br />' +
            '<button class="btn btn-info" ui-sref="user-management">Users</button> ' +
            '<button class="btn btn-info" ui-sref="user-profile">Manage Directory</button> ' +
            '<button class="btn btn-info" ui-sref="flipbooks">Flipbooks</button> ' +
            '<button class="btn btn-info" ui-sref="file-upload">File Uploads</button> ' +
            '<button class="btn btn-info" ui-sref="unapproved-comments">Unapproved Comments</button> ' +
            '</div>'
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('adminCenter', {
                parent: 'admin',
                url: '/center',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Admin Center'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/center/admin.center.html',
                        controller: 'AdminCenterController'
                    }
                }
            })
            .state('searchReset', {
                parent: 'admin',
                url: '/search-reset',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Search Reset'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/center/search.reset.html',
                        controller: 'SearchResetController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .factory('AdminCenterService', function ($resource) {
        //return $resource('api/logs', {}, {
        //    'findAll': { method: 'GET', isArray: true},
        //    'changeLevel': { method: 'PUT'}
        //});
    });

'use strict';

angular.module('isahomeApp')
    .controller('AdminCenterController', function ($scope, PageContent) {

    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('audits', {
                parent: 'admin',
                url: '/audits',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Audits'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/audits/audits.html',
                        controller: 'AuditsController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .factory('AuditsService', function ($resource) {
        return $resource('api/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });
    });

'use strict';

angular.module('isahomeApp')
    .controller('AuditsController', function ($scope, $filter, AuditsService, ParseLinks) {
        $scope.page = 1;

        $scope.onChangeDate = function () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')($scope.fromDate, dateFormat);
            var toDate = $filter('date')($scope.toDate, dateFormat);

            AuditsService.query({page: $scope.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                $scope.audits = result;
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
            });
        };

        // Date picker configuration
        $scope.today = function () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            $scope.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        };

        $scope.previousMonth = function () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            $scope.fromDate = fromDate;
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.onChangeDate();
        };

        $scope.today();
        $scope.previousMonth();
        $scope.onChangeDate();
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('admin', {
                abstract: true,
                parent: 'app'
            });
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('settings', {
                parent: 'account',
                url: '/settings',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Settings'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/settings/settings.html',
                        controller: 'SettingsController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('SettingsController', function ($scope, Principal, Auth) {
        $scope.success = null;
        $scope.error = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            $scope.settingsAccount = copyAccount(account);
        });

        $scope.save = function () {
            Auth.updateAccount($scope.settingsAccount).then(function() {
                $scope.error = null;
                $scope.success = 'OK';
                Principal.identity(true).then(function(account) {
                    $scope.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                $scope.success = null;
                $scope.error = 'ERROR';
            });
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('sessions', {
                parent: 'account',
                url: '/sessions',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Sessions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/sessions/sessions.html',
                        controller: 'SessionsController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('SessionsController', function ($scope, Sessions, Principal) {
        Principal.identity().then(function(account) {
            $scope.account = account;
        });

        $scope.success = null;
        $scope.error = null;
        $scope.sessions = Sessions.getAll();
        $scope.invalidate = function (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    $scope.error = null;
                    $scope.success = 'OK';
                    $scope.sessions = Sessions.getAll();
                },
                function () {
                    $scope.success = null;
                    $scope.error = 'ERROR';
                });
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('requestReset', {
                parent: 'account',
                url: '/reset/request',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/reset/request/reset.request.html',
                        controller: 'RequestResetController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('RequestResetController', function ($rootScope, $scope, $state, $timeout, Auth) {

        $scope.success = null;
        $scope.error = null;
        $scope.errorEmailNotExists = null;
        $scope.resetAccount = {};
        $timeout(function (){angular.element('[ng-model="resetAccount.email"]').focus();});

        $scope.requestReset = function () {

            $scope.error = null;
            $scope.errorEmailNotExists = null;

            Auth.resetPasswordInit($scope.resetAccount.email).then(function () {
                $scope.success = 'OK';
            }).catch(function (response) {
                $scope.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    $scope.errorEmailNotExists = 'ERROR';
                } else {
                    $scope.error = 'ERROR';
                }
            });
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('finishReset', {
                parent: 'account',
                url: '/reset/finish?key',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/reset/finish/reset.finish.html',
                        controller: 'ResetFinishController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('ResetFinishController', function ($scope, $stateParams, $timeout, Auth, LoginService) {

        $scope.keyMissing = $stateParams.key === undefined;
        $scope.doNotMatch = null;

        $scope.resetAccount = {};
        $timeout(function (){angular.element('[ng-model="resetAccount.password"]').focus();});

        $scope.finishReset = function() {
            if ($scope.resetAccount.password !== $scope.confirmPassword) {
                $scope.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: $scope.resetAccount.password}).then(function () {
                    $scope.success = 'OK';
                }).catch(function () {
                    $scope.success = null;
                    $scope.error = 'ERROR';
                });
            }
        };

        $scope.login = LoginService.open;
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('register', {
                parent: 'account',
                url: '/registerrr',
                data: {
                    authorities: [],
                    pageTitle: 'Registration'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/register/register.html',
                        controller: 'RegisterController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('RegisterController', function ($scope, $timeout, Auth, LoginService) {
        $scope.success = null;
        $scope.error = null;
        $scope.doNotMatch = null;
        $scope.errorUserExists = null;
        $scope.registerAccount = {};
        $timeout(function (){angular.element('[ng-model="registerAccount.login"]').focus();});

        $scope.register = function () {
            if ($scope.registerAccount.password !== $scope.confirmPassword) {
                $scope.doNotMatch = 'ERROR';
            } else {
                $scope.registerAccount.langKey =  'en' ;
                $scope.doNotMatch = null;
                $scope.error = null;
                $scope.errorUserExists = null;
                $scope.errorEmailExists = null;

                Auth.createAccount($scope.registerAccount).then(function () {
                    $scope.success = 'OK';
                }).catch(function (response) {
                    $scope.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        $scope.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        $scope.errorEmailExists = 'ERROR';
                    } else {
                        $scope.error = 'ERROR';
                    }
                });
            }
        };

        $scope.login = LoginService.open;
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('password', {
                parent: 'account',
                url: '/password',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Password'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/password/password.html',
                        controller: 'PasswordController'
                    }
                }
            });
    });

/* globals $ */
'use strict';

angular.module('isahomeApp')
    .directive('passwordStrengthBar', function () {
        return {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            link: function (scope, iElement, attr) {
                var strength = {
                    colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                    mesureStrength: function (p) {

                        var _force = 0;
                        var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                        var _lowerLetters = /[a-z]+/.test(p);
                        var _upperLetters = /[A-Z]+/.test(p);
                        var _numbers = /[0-9]+/.test(p);
                        var _symbols = _regex.test(p);

                        var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                        var _passedMatches = $.grep(_flags, function (el) {
                            return el === true;
                        }).length;

                        _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                        _force += _passedMatches * 10;

                        // penality (short password)
                        _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                        // penality (poor variety of characters)
                        _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                        _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                        _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                        return _force;

                    },
                    getColor: function (s) {

                        var idx = 0;
                        if (s <= 10) {
                            idx = 0;
                        }
                        else if (s <= 20) {
                            idx = 1;
                        }
                        else if (s <= 30) {
                            idx = 2;
                        }
                        else if (s <= 40) {
                            idx = 3;
                        }
                        else {
                            idx = 4;
                        }

                        return { idx: idx + 1, col: this.colors[idx] };
                    }
                };
                scope.$watch(attr.passwordToCheck, function (password) {
                    if (password) {
                        var c = strength.getColor(strength.mesureStrength(password));
                        iElement.removeClass('ng-hide');
                        iElement.find('ul').children('li')
                            .css({ 'background-color': '#DDD' })
                            .slice(0, c.idx)
                            .css({ 'background-color': c.col });
                    }
                });
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .controller('PasswordController', function ($scope, Auth, Principal) {
        Principal.identity().then(function(account) {
            $scope.account = account;
        });

        $scope.success = null;
        $scope.error = null;
        $scope.doNotMatch = null;
        $scope.changePassword = function () {
            if ($scope.password !== $scope.confirmPassword) {
                $scope.error = null;
                $scope.success = null;
                $scope.doNotMatch = 'ERROR';
            } else {
                $scope.doNotMatch = null;
                Auth.changePassword($scope.password).then(function () {
                    $scope.error = null;
                    $scope.success = 'OK';
                }).catch(function () {
                    $scope.success = null;
                    $scope.error = 'ERROR';
                });
            }
        };
    });

'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('activate', {
                parent: 'account',
                url: '/activate?key',
                data: {
                    authorities: [],
                    pageTitle: 'Activation'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/activate/activate.html',
                        controller: 'ActivationController'
                    }
                }
            });
    });

'use strict';

angular.module('isahomeApp')
    .controller('ActivationController', function ($scope, $stateParams, Auth, LoginService) {
        Auth.activateAccount({key: $stateParams.key}).then(function () {
            $scope.error = null;
            $scope.success = 'OK';
        }).catch(function () {
            $scope.success = null;
            $scope.error = 'ERROR';
        });

        $scope.login = LoginService.open;
    });


'use strict';

angular.module('isahomeApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('account', {
                abstract: true,
                parent: 'app'
            });
    });
(function(){angular.module('isahomeApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/cases/cases.html','<div ng-cloak><div class="row"><ol class="breadcrumb"><li><a ui-sref="home">Home</a></li><li><a ui-sref="cases">Strabismus Forum</a></li></ol><div class="col-md-3 col-sm-3"><div><img src="content/images/world.png" width="100%"></div><div class="red-no-padding"><button ui-sref="cases" style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>Strabismus Forum</strong></span></button> <span style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>Recent Cases</strong></span></span><div data-ng-repeat="caseStudy in sideBarCaseStudies | orderBy: \'-id\'"><button ui-sref="cases.view({id:caseStudy.id})" style="padding-left:40px; text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white">{{caseStudy.title}}</span></button></div></div></div><div class="col-md-6 col-sm-9"><div class="pull-right" has-authority="ROLE_ADMIN"><button ui-sref="cases.new" class="btn btn-success"><span class="fa fa-pencil"></span></button></div><div><h2>Strabismus Forum</h2><table class="table table-striped"><tr><th width="90%">Title</th><th></th></tr><tr data-ng-repeat="caseStudy in caseStudies | orderBy: \'-id\'"><td><a style="font-size: 16pt" ui-sref="cases.view({id:caseStudy.id})">{{caseStudy.title}}</a></td><td><button ui-sref="cases.view({id:caseStudy.id})" class="btn btn-primary">View Case</button></td></tr></table></div></div></div></div>');
$templateCache.put('app/cases/cases.view.html','<div ng-cloak><div class="row"><ol class="breadcrumb"><li><a ui-sref="home">Home</a></li><li><a ui-sref="cases">Case Presentations</a></li><li><a ui-sref="cases.view({id:case.id})">{{case.title}}</a></li></ol><div class="col-md-3 col-sm-3"><div><img src="content/images/world.png" width="100%"></div><div class="red-no-padding"><button ui-sref="cases" style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>All Case Presentations</strong></span></button> <span style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>Recent Cases</strong></span></span><div data-ng-repeat="caseStudy in caseStudies | orderBy: \'-id\'"><button ui-sref="cases.view({id:caseStudy.id})" style="padding-left: 40px; text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white">{{caseStudy.title}}</span></button></div></div></div><div class="col-md-6 col-sm-9"><div class="pull-right" has-authority="ROLE_ADMIN"><button ng-if="!case.id" ui-sref="cases.new" class="btn btn-success"><span class="fa fa-pencil"></span></button> <button ng-if="case.id" ui-sref="cases.edit({id:case.id})" ng-click="edit()" class="btn btn-info"><span class="fa fa-pencil"></span></button> <button ng-if="case.id" ui-sref="cases.delete({id:case.id})" class="btn btn-danger"><span class="fa fa-remove"></span></button></div><div><h2>{{case.title}}</h2><p ng-bind-html="case.trustedContent"></p><div class="row"><div class="col-md-12"><div class="col-md-3" data-ng-repeat="attachment in attachments"><img width="150" data-ng-src="{{\'data:\' + attachment.imageContentType + \';base64,\' + attachment.image}}" style="max-width: 100%" ng-if="attachment.image"></div></div></div><p ng-bind-html="case.trustedContent2"></p><hr><h3>Comments<div class="pull-right"><button class="btn btn-info" ng-if="showCommentForm == false" ng-click="showForm(true)">Add a Comment</button></div></h3><form ng-if="showCommentForm == true" name="form" id="form" role="form" data-ng-submit="postComment(newComment)"><label>Name <strong>*</strong></label><input required type="text" class="form-control" data-ng-model="newComment.author"><label>Comment <strong>*</strong></label><textarea class="form-control" required data-ng-model="newComment.comment"></textarea><br><input ng-diabled="form.$invalid" class="btn btn-success" type="submit" value="Post Comment"> <button class="btn btn-info" ng-click="showForm(false)">Hide Form</button></form><br><div class="well" ng-repeat="comment in comments"><span class="pull-right">{{comment.commentDate | date:\'short\'}} </span><strong>Name:</strong> {{comment.author}}<p style="white-space: pre-wrap; margin-bottom: 0px"><strong>Comment:</strong> {{comment.comment}}</p></div></div></div></div></div>');
$templateCache.put('app/directory/directory.html','<div ng-cloak><div class="row"><ol class="breadcrumb"><li><a ui-sref="home">Home</a></li><li ng-if="topHeaderLinkName.length > 0"><a ui-sref="page({name:topHeaderLinkName})">{{topHeaderName}}</a></li><li ng-if="mainHeaderLinkName.length > 0"><a ui-sref="page({name:mainHeaderLinkName})">{{mainHeaderName}}</a></li><li ng-if="subHeaderName.length > 0"><a ui-sref="page({name:subHeaderLinkName})">{{subHeaderName}}</a></li></ol><div class="col-md-3 col-sm-3"><div><img src="content/images/world.png" width="100%"></div><div class="red-no-padding" ng-if="pageContent.siteHeaders[0].mainHeaderId == null"><button ng-if="pageContent.siteHeaders[0].targetPageLinkName" ui-sref="page({name:pageContent.siteHeaders[0].targetPageLinkName})" style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>{{pageContent.siteHeaders[0].targetPageTitle}}</strong></span></button><div data-ng-repeat="subheader in pageContent.siteHeaders[0].subHeaders | orderBy: \'orderNum\'"><button ui-sref="page({name:subheader.targetPageLinkName})" style="text-align: left; padding-left: 40px" class="form-control banner-button2 red-no-padding"><span style="color: white">{{subheader.targetPageTitle}}</span></button> <button ng-if="subheader.subHeaders.length > 0" style="text-align: left; padding-left: 80px" ng-repeat="thirdheader in subheader.subHeaders" ui-sref="page({name:thirdheader.targetPageLinkName})" class="form-control banner-button2 red-no-padding"><span style="color: white">{{thirdheader.targetPageTitle}}</span></button></div></div><button ng-if="pageContent.siteHeaders.length == 0" ui-sref="page({name:pageContent.linkName})" style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>{{pageContent.title}}</strong></span></button><div class="red-no-padding" ng-if="pageContent.siteHeaders[0].mainHeaderId != null"><button ui-sref="page({name:pageContent.siteHeaders[0].mainHeaderLinkName})" style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>{{pageContent.siteHeaders[0].mainHeaderName}}</strong></span></button></div><div class="red-no-padding" data-ng-repeat="subheader in topHeader.subHeaders | orderBy: \'orderNum\'"><button ui-sref="page({name:subheader.targetPageLinkName})" style="text-align: left; padding-left: 40px" class="form-control banner-button2 red-no-padding"><span style="color: white">{{subheader.targetPageTitle}}</span></button> <button ng-if="subheader.subHeaders.length > 0" style="text-align: left; padding-left: 80px" ng-repeat="thirdheader in subheader.subHeaders" ui-sref="page({name:thirdheader.targetPageLinkName})" class="form-control banner-button2 red-no-padding"><span style="color: white">{{thirdheader.targetPageTitle}}</span></button></div></div><div class="col-md-6 col-sm-9"><h2>Directory <small has-authority="ROLE_ADMIN"><button class="btn btn-xs btn-primary" ui-sref="directory-import">Import</button></small><div class="pull-right col-md-4"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.searchQuery != null"><button class="btn btn-info" ng-click="vm.clear()"><span class="fa fa-ban"></span></button></span></div></form></div></h2><br><div class=""><!--<table class="jh-table table table-striped">--><!--<thead>--><!--<tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">--><!--<th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="firstName"><span>First Name</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="lastName"><span>Last Name</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="addressOne"><span>Address One</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="addressTwo"><span>Address Two</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="addressThree"><span>Address Three</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="middleInitial"><span>Middle Initial</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="prefix"><span>Prefix</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="degree"><span>Degree</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="city"><span>City</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="state"><span>State</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="zipCode"><span>Zip Code</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="country"><span>Country</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="phone"><span>Phone</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="fax"><span>Fax</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--<th jh-sort-by="institution"><span>Institution</span> <span class="glyphicon glyphicon-sort"></span></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><div class="well" ng-repeat="userProfile in vm.userProfiles track by userProfile.id"><strong>{{userProfile.lastName.trim()}}</strong>, {{userProfile.firstName}}<span ng-if="userProfile.middleInitial"> {{userProfile.middleInitial}}</span>, {{userProfile.degree}} <span ng-if="userProfile.paidThrough">({{userProfile.paidThrough}})</span> <span ng-if="userProfile.institution"><br>{{userProfile.institution}}</span> <span ng-if="userProfile.addressOne"><br>{{userProfile.addressOne}}</span> <span ng-if="userProfile.addressTwo"><br>{{userProfile.addressTwo}}</span><br>{{userProfile.city}}, {{userProfile.state}} {{userProfile.zipCode}} <span ng-if="userProfile.country"><br>{{userProfile.country}}</span> <span ng-if="userProfile.email"><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{userProfile.email}}</span> <span ng-if="userProfile.phone"><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{userProfile.phone}}</span> <span ng-if="userProfile.fax"><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{userProfile.fax}} FAX</span></div><!--</tbody>--><!--</table>--></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><div class="text-center"><small>If you see an issue or error in the information, please let us know through the <a ui-sref="page({name:\'contact-us\'})">Contact Form</a></small></div></div></div></div>');
$templateCache.put('app/directory/import.html','<div ng-cloak><div class="row"><admin-menu-bar class="pull-right"></admin-menu-bar><h3>Directory Import <small>Please verify all information in your spreadsheet before uploading.</small></h3><button type="button" class="btn btn-danger" ng-click="reset()">Reset Grid</button> <button type="button" class="btn btn-success" ng-click="createDirectoryEntries()" data-ng-disabled="gridOptions.data.length == 0">Create Directory Entries</button><br><br><div id="grid1" ui-grid="gridOptions" class="grid"><div class="grid-msg-overlay" ng-show="!gridOptions.data.length"><div class="msg"><div class="center"><span class="muted">Select Spreadsheet File</span><br><input type="file" accept=".xls,.xlsx,.ods" fileread="" opts="gridOptions" multiple="false"></div></div></div></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row map"><div class="col-md-6 col-xs-6 col-sm-6 col-sm-offset-3 col-xs-offset-3 col-md-offset-3 caro"><uib-carousel interval="myInterval" no-wrap="noWrapSlides"><uib-slide ng-repeat="carouselImage in carouselImages" active="carouselImage.active"><img data-ng-src="{{\'data:\' + carouselImage.pictureContentType + \';base64,\' + carouselImage.picture}}" style="margin:auto"><div class="carousel-caption"><!--<h4>Slide {{slide.id}}</h4>--><!--<p>{{slide.text}}</p>--></div></uib-slide></uib-carousel><h4 class="text-center">Founded in 1966</h4></div></div><div class="row red text-center" style="min-height: 150px"><div class="col-xs-6 col-sm-3" style="margin-bottom: 20px"><a ui-sref="page({name:\'Case_month\'})" class="btn btn-sq banner-button"><i class="fa fa-star-o fa-5x"></i><br><span class="red-gold-button">Cases</span></a></div><div class="col-xs-6 col-sm-3" style="margin-bottom: 20px"><a ui-sref="cases" class="btn btn-sq banner-button"><i class="fa fa-file-text fa-5x"></i><br><span class="red-gold-button">Forum</span></a></div><div class="col-xs-6 col-sm-3" style="margin-bottom: 20px"><a ui-sref="page({name:\'meetings\'})" class="btn btn-sq banner-button"><i class="fa fa-users fa-5x"></i><br><span class="red-gold-button">Meeting</span></a></div><div class="col-xs-6 col-sm-3" style="margin-bottom: 20px"><a ui-sref="page({name:\'news-and-events\'})" class="btn btn-sq banner-button"><i class="fa fa-info-circle fa-5x"></i><br><span class="red-gold-button">News</span></a></div></div><div class="row"><div class="pull-right" has-authority="ROLE_ADMIN"><button ng-if="!pageContent.id" ui-sref="page.new({})" class="btn btn-success"><span class="fa fa-pencil"></span></button> <button ng-if="pageContent.id" ng-click="edit()" class="btn btn-info"><span class="fa fa-pencil"></span></button> <button ng-if="pageContent.id" ui-sref="page.delete({id:pageContent.id})" class="btn btn-danger"><span class="fa fa-remove"></span></button></div><div ng-if="!isEditing" class="main-content" ng-bind-html="pageContent.trustedContent"></div><div ng-if="isEditing"><form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-body"><div class="form-group"><label class="control-label" for="field_linkName">Link Name (Link in URL)</label><input type="text" class="form-control" name="linkName" id="field_linkName" ng-model="pageContent.linkName"></div><div class="form-group"><label class="control-label" for="field_title">Title (Link on Left)</label><input type="text" class="form-control" name="title" id="field_title" ng-model="pageContent.title"></div><div class="form-group"><label class="control-label">Content</label><summernote name="content" id="field_content" ng-model="pageContent.content"></summernote></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form></div></div></div>');
$templateCache.put('app/page/file.html','<div><div class="alert alert-success">The file will open or download momentarily.</div><button onclick="window.close()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Close Window</span></button></div>');
$templateCache.put('app/page/page.delete.dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pageContent.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this PageContent?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-click="vm.confirmDelete(vm.pageContent.id)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/page/page.edit.dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()">a<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPageContentLabel">Create or edit a PageContent</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_linkName">LinkName</label><input type="text" class="form-control" name="linkName" id="field_linkName" ng-model="vm.pageContent.linkName"></div><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.pageContent.title"></div><div class="form-group"><label class="control-label">Content</label><summernote name="content" id="field_content" ng-model="vm.pageContent.content"></summernote></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/page/page.html','<div ng-cloak><div class="row"><ol class="breadcrumb"><li><a ui-sref="home">Home</a></li><li ng-if="topHeaderLinkName.length > 0"><a ui-sref="page({name:topHeaderLinkName})">{{topHeaderName}}</a></li><li ng-if="mainHeaderLinkName.length > 0"><a ui-sref="page({name:mainHeaderLinkName})">{{mainHeaderName}}</a></li><li ng-if="subHeaderName.length > 0"><a ui-sref="page({name:subHeaderLinkName})">{{subHeaderName}}</a></li></ol><div class="col-md-3 col-sm-3"><div><img src="content/images/world.png" width="100%"></div><div class="red-no-padding" ng-if="pageContent.siteHeaders[0].mainHeaderId == null"><button ng-if="pageContent.siteHeaders[0].targetPageLinkName" ui-sref="page({name:pageContent.siteHeaders[0].targetPageLinkName})" style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>{{pageContent.siteHeaders[0].targetPageTitle}}</strong></span></button><div data-ng-repeat="subheader in pageContent.siteHeaders[0].subHeaders | orderBy: \'orderNum\'"><button ui-sref="page({name:subheader.targetPageLinkName})" style="text-align: left; padding-left: 40px" class="form-control banner-button2 red-no-padding"><span style="color: white">{{subheader.targetPageTitle}}</span></button> <button ng-if="subheader.subHeaders.length > 0" style="text-align: left; padding-left: 80px" ng-repeat="thirdheader in subheader.subHeaders" ui-sref="page({name:thirdheader.targetPageLinkName})" class="form-control banner-button2 red-no-padding"><span style="color: white">{{thirdheader.targetPageTitle}}</span></button></div></div><button ng-if="pageContent.siteHeaders.length == 0" ui-sref="page({name:pageContent.linkName})" style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>{{pageContent.title}}</strong></span></button><div class="red-no-padding" ng-if="pageContent.siteHeaders[0].mainHeaderId != null"><button ui-sref="page({name:pageContent.siteHeaders[0].mainHeaderLinkName})" style="text-align: left" class="form-control banner-button2 red-no-padding"><span style="color: white"><strong>{{pageContent.siteHeaders[0].mainHeaderName}}</strong></span></button></div><div class="red-no-padding" data-ng-repeat="subheader in topHeader.subHeaders | orderBy: \'orderNum\'"><button ui-sref="page({name:subheader.targetPageLinkName})" style="text-align: left; padding-left: 40px" class="form-control banner-button2 red-no-padding"><span style="color: white">{{subheader.targetPageTitle}}</span></button> <button ng-if="subheader.subHeaders.length > 0" style="text-align: left; padding-left: 80px" ng-repeat="thirdheader in subheader.subHeaders" ui-sref="page({name:thirdheader.targetPageLinkName})" class="form-control banner-button2 red-no-padding"><span style="color: white">{{thirdheader.targetPageTitle}}</span></button></div></div><div class="col-md-6 col-sm-9"><div class="pull-right" has-authority="ROLE_ADMIN"><button ng-if="!pageContent.id" ui-sref="page.new({})" class="btn btn-success"><span class="fa fa-pencil"></span></button> <button ng-if="pageContent.id" ng-click="edit()" class="btn btn-info"><span class="fa fa-pencil"></span></button> <button ng-if="pageContent.id" ui-sref="page.delete({id:pageContent.id})" class="btn btn-danger"><span class="fa fa-remove"></span></button></div><div ng-if="!isEditing" bind-html-compile="pageContent.content"></div><div ng-if="isEditing"><form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-body"><div class="form-group"><label class="control-label" for="field_linkName">Link Name (Link in URL)</label><input type="text" class="form-control" name="linkName" id="field_linkName" ng-model="pageContent.linkName"></div><div class="form-group"><label class="control-label" for="field_title">Title (Link on Left)</label><input type="text" class="form-control" name="title" id="field_title" ng-model="pageContent.title"></div><div class="form-group"><label class="control-label">Content</label><summernote name="content" id="field_content" ng-model="pageContent.content"></summernote></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form></div><div ng-if="state.params.name == \'contact-us\'"><div ng-if="successMsg" class="alert alert-success">Thank you for your message. We will respond as soon as possible.</div><form ng-if="showForm" data-ng-submit="sendMessage()" name="form" id="form"><div class="form-group"><label>Name <strong>*</strong></label><input required type="text" class="form-control" data-ng-model="message.name"></div><div class="form-group"><label>Email <strong>*</strong></label><input required type="email" class="form-control" data-ng-model="message.email"></div><div class="form-group"><label>Message <strong>*</strong></label><textarea required class="form-control" data-ng-model="message.message"></textarea></div><button class="btn btn-success">Send Message</button></form></div></div></div><div class="row" ng-if="commentsEnabled" has-authority="ROLE_ADMIN"><div class="col-md-3 col-sm-3"></div><div class="col-md-6 col-sm-9"><hr><h3>Comments<div class="pull-right" has-authority="ROLE_USER"><button class="btn btn-info" ng-if="showCommentForm == false" ng-click="setShowCommentForm(true)">Add a Comment</button></div></h3><form ng-if="showCommentForm == true" name="form" id="commentform" role="form" data-ng-submit="postComment(newComment)" has-authority="ROLE_USER"><label>Name <strong>*</strong></label><input required type="text" class="form-control" data-ng-model="newComment.author"><label>Comment <strong>*</strong></label><textarea class="form-control" required data-ng-model="newComment.comment"></textarea><br><input ng-diabled="commentform.$invalid" class="btn btn-success" type="submit" value="Post Comment"> <button class="btn btn-info" ng-click="setShowCommentForm(false)">Hide Form</button></form><div style="margin-bottom: 0px; margin-top: 10px" class="alert alert-success" ng-if="showSuccessMessage">Thank you for your comment, it will appear after approval from the site admins.</div><br ng-if="!showSuccessMessage"><div class="well" ng-repeat="comment in comments"><span class="pull-right">{{comment.commentDate | date:\'short\'}} </span><strong>{{comment.author}}</strong><p style="white-space: pre-wrap; margin-bottom: 0px">{{comment.comment}}</p></div></div></div></div>');
$templateCache.put('app/search/search.html','<div ng-cloak><div class="row"><ol class="breadcrumb"><li><a ui-sref="home">Home</a></li><li>Search Results</li></ol><div class="col-md-3 col-sm-3"><div><img src="content/images/world.png" width="100%"></div></div><div class="col-md-6 col-sm-9"><h3>Search Results <span ng-if="results">({{totalResults}} results)</span></h3><div class="well" data-ng-repeat="result in results"><div class="pull-right"><button ui-sref="page({name:result.linkName})" class="btn btn-info">View Page</button></div><strong>Page:</strong> {{result.title}}</div><div class="well" data-ng-repeat="result in caseResults"><div class="pull-right"><button ui-sref="forum.view({id: result.id})" class="btn btn-info">View Post</button></div><strong>Post:</strong> {{result.title}}</div><div class="well" data-ng-repeat="result in commentResults"><div class="pull-right"><button ui-sref="forum.view({id: result.caseStudyId})" class="btn btn-info">View Post</button></div><strong>Comment:</strong> {{result.comment}}</div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="login">sign in</a>.</div><div class="alert alert-danger" ng-show="error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{account.login}}</b>]</h2><div class="alert alert-success" ng-show="success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="password" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="confirmPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><div class="alert alert-success" ng-show="success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="errorEmailExists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="doNotMatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!success" name="form" role="form" novalidate ng-submit="register()" show-validation><div class="form-group"><label class="control-label" for="login">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[a-z0-9]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="registerAccount.password" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="confirmPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></form><p></p><div class="alert alert-warning">If you want to <a class="alert-link" href="" ng-click="login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2>Active sessions for [<b>{{account.login}}</b>]</h2><div class="alert alert-success" ng-show="success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>IP Address</th><th>User agent</th><th>Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.formattedTokenDate}}</td><td><button type="submit" class="btn btn-primary" ng-click="invalidate(session.series)">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="success"><strong>Settings saved!</strong></div><div class="alert alert-danger" ng-show="errorEmailExists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="error"><strong>An error has occurred!</strong> Settings could not be saved.</div><form name="form" role="form" novalidate ng-submit="save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="fromDate" ng-change="onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="toDate" ng-change="onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page" ng-change="loadPage(page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/center/admin.center.html','<div><h2>Admin Center</h2><hr><admin-menu-bar></admin-menu-bar></div>');
$templateCache.put('app/admin/center/search.reset.html','<div><h2>Reset Search</h2><hr><button class="btn btn-danger" ng-click="reindex()">Re-index Data</button></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in healthData"><td><span class="text-capitalize">{{ baseName(health.name) }}</span> {{subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ baseName(currentHealth.name) }}</span> {{subSystemName(currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="currentHealth.error"><h4>Error</h4><pre>{{currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div><h2>Logs</h2><p>There are {{ loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="metrics.gauges[\'jvm.memory.total.max\'].value" value="metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{metrics.gauges[\'jvm.memory.total.used\'].value * 100 / metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="metrics.gauges[\'jvm.memory.heap.max\'].value" value="metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="metrics.gauges[\'jvm.threads.runnable.count\'].value" max="metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="metrics.gauges[\'jvm.threads.waiting.count\'].value" max="metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="metrics.gauges[\'jvm.threads.blocked.count\'].value" max="metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3>Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Cache name</th><th class="text-right">Objects</th><th class="text-right">Hits</th><th class="text-right">Misses</th><th class="text-right">Eviction count</th><th class="text-right">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 ng-show="metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value" value="metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="confirmDelete(user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> "{{user.login}}"</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Field</th><th>Value</th></tr></thead><tbody><tr><td><span>Login</span></td><td><input type="text" class="input-sm form-control" value="{{user.login}}" readonly="readonly"></td></tr><tr><td><span>FirstName</span></td><td><input type="text" class="input-sm form-control" value="{{user.firstName}}" readonly="readonly"></td></tr><tr><td><span>LastName</span></td><td><input type="text" class="input-sm form-control" value="{{user.lastName}}" readonly="readonly"></td></tr><tr><td><span>Email</span></td><td><input type="text" class="input-sm form-control" value="{{user.email}}" readonly="readonly"></td></tr><tr><td><span>Activated</span></td><td><input type="text" class="input-sm form-control" value="{{user.activated}}" readonly="readonly"></td></tr><tr><td><span>CreatedBy</span></td><td><input type="text" class="input-sm form-control" value="{{user.createdBy}}" readonly="readonly"></td></tr><tr><td><span>CreatedDate</span></td><td><input type="text" class="input-sm form-control" value="{{user.createdDate | date:\'dd/MM/yy HH:mm\' }}" readonly="readonly"></td></tr><tr><td><span>LastModifiedBy</span></td><td><input type="text" class="input-sm form-control" value="{{user.lastModifiedBy}}" readonly="readonly"></td></tr><tr><td><span>LastCreatedDate</span></td><td><input type="text" class="input-sm form-control" value="{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}" readonly="readonly"></td></tr><tr><td><span>Profiles</span></td><td><ul class="list-unstyled"><li ng-repeat="authority in user.authorities"><span>{{authority}}</span></li></ul></td></tr></tbody></table></div><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="user.login" ng-required="user.id == null" ng-maxlength="50"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">FirstName</label><input type="text" class="form-control" name="firstName" ng-model="user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>LastName</label><input type="text" class="form-control" name="lastName" ng-model="user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="text" class="form-control" name="email" ng-model="user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="user.id === null" type="checkbox" id="activated" ng-model="user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="user.authorities" ng-options="authority for authority in authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Users<admin-menu-bar class="pull-right"></admin-menu-bar></h2><jh-alert></jh-alert><div class="container"><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div><div class="pull-right col-md-4"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="search(searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="searchQuery != null"><button class="btn btn-info" ng-click="clear()"><span class="fa fa-ban"></span></button></span></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>ID</th><th>Login</th><th>Email</th><th></th><th>Profiles</th><th>CreatedDate</th><th>LastModifiedBy</th><th>LastModifiedDate</th><th></th></tr></thead><tbody><tr ng-repeat="user in users track by user.login"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="setActive(user, true)" ng-show="!user.activated" style="cursor: pointer">Desactivated</span> <span class="label label-success" ng-click="setActive(user, false)" ng-show="user.activated" style="cursor: pointer">Activated</span></td><td><div ng-repeat="authority in user.authorities track by authority"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span></button></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="page" total="queryCount" items-per-page="itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page" ng-change="transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="authenticationError"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="login($event)"><div class="form-group"><label for="username">Login</label><input type="text" class="form-control" id="username" placeholder="Your username" ng-model="username"></div><div class="form-group"><label for="password">Password</label><input type="password" class="form-control" id="password" placeholder="Your password" ng-model="password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="rememberMe" checked="checked"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="requestResetPassword()">Did you forget your password?</a></div><div class="alert alert-warning"><!--You don\'t have an account yet? <a class="alert-link" href="" ng-click="register()">Register a new account</a>--> Need help signing in? <a class="alert-link" href="" ng-click="contactUs()">Contact us</a></div><div class="alert alert-info">The year in brackets on the membership directory listing is the year dues are paid through.</div></div></div></div>');
$templateCache.put('app/entities/attachment/attachment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.attachment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Attachment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/attachment/attachment-detail.html','<div><h2><span>Attachment</span> {{vm.attachment.id}}</h2><hr><dl class="dl-horizontal"><dt><span>Image</span></dt><dd><img data-ng-src="{{\'data:\' + attachment.imageContentType + \';base64,\' + vm.attachment.image}}" style="max-width: 100%" ng-if="vm.attachment.image"><div>{{vm.attachment.imageContentType}}, {{vm.byteSize(vm.attachment.image)}}</div></dd><hr><dt><span>Thumbnail</span></dt><dd><img data-ng-src="{{\'data:\' + attachment.thumbnailContentType + \';base64,\' + vm.attachment.thumbnail}}" style="max-width: 100%" ng-if="vm.attachment.thumbnail"><div>{{vm.attachment.thumbnailContentType}}, {{vm.byteSize(vm.attachment.thumbnail)}}</div></dd><hr><dt><span>caseStudy</span></dt><dd><a ui-sref="case-study-detail({id:vm.attachment.caseStudyId})">{{vm.attachment.caseStudyTitle}}</a></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/attachment/attachment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAttachmentLabel">Create or edit a Attachment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.attachment.id" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="vm.setImage($file, vm.attachment)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_image">Image</label><div><img data-ng-src="{{\'data:\' + vm.attachment.imageContentType + \';base64,\' + vm.attachment.image}}" style="max-height: 100px" ng-if="vm.attachment.image"><div class="help-block clearfix"><span class="pull-left">{{vm.attachment.imageContentType}}, {{byteSize(vm.attachment.image)}}</span> <button ng-click="vm.attachment.image=null;vm.attachment.imageContentType=null;" ng-if="vm.attachment.image" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setImage($file, vm.attachment)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="image" id="field_image" ng-model="vm.attachment.image"> <input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType" ng-model="vm.attachment.imageContentType"></div><div class="form-group" ngf-drop ngf-change="vm.setThumbnail($file, vm.attachment)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_thumbnail">Thumbnail</label><div><img data-ng-src="{{\'data:\' + vm.attachment.thumbnailContentType + \';base64,\' + vm.attachment.thumbnail}}" style="max-height: 100px" ng-if="vm.attachment.thumbnail"><div class="help-block clearfix"><span class="pull-left">{{vm.attachment.thumbnailContentType}}, {{byteSize(vm.attachment.thumbnail)}}</span> <button ng-click="vm.attachment.thumbnail=null;vm.attachment.thumbnailContentType=null;" ng-if="vm.attachment.thumbnail" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setThumbnail($file, vm.attachment)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="thumbnail" id="field_thumbnail" ng-model="vm.attachment.thumbnail"> <input type="hidden" class="form-control" name="thumbnailContentType" id="field_thumbnailContentType" ng-model="vm.attachment.thumbnailContentType"></div><div class="form-group"><label for="field_caseStudy">caseStudy</label><select class="form-control" id="field_caseStudy" name="caseStudy" ng-model="vm.attachment.caseStudyId" ng-options="caseStudy.id as caseStudy.title for caseStudy in vm.casestudys"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/attachment/attachments.html','<div><h2>Attachments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="attachment.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Attachment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="image"><span>Image</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="thumbnail"><span>Thumbnail</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caseStudyTitle"><span>caseStudy</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="attachment in vm.attachments track by attachment.id"><td><a ui-sref="attachment-detail({id:attachment.id})">{{attachment.id}}</a></td><td><img data-ng-src="{{\'data:\' + attachment.imageContentType + \';base64,\' + attachment.image}}" style="max-height: 30px" ng-if="attachment.image"> {{attachment.imageContentType}} {{byteSize(attachment.image)}}</td><td><img data-ng-src="{{\'data:\' + attachment.thumbnailContentType + \';base64,\' + attachment.thumbnail}}" style="max-height: 30px" ng-if="attachment.thumbnail"> {{attachment.thumbnailContentType}} {{byteSize(attachment.thumbnail)}}</td><td><a ui-sref="case-study-detail({id:attachment.caseStudyId})">{{attachment.caseStudyTitle}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="attachment-detail({id:attachment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="attachment.edit({id:attachment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="attachment.delete({id:attachment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/carousel-image/carousel-image-management-delete-dialog.html','<form name="deleteForm" ng-submit="confirmDelete(carouselImage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><p>Are you sure you want to delete this CarouselImage?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/carousel-image/carousel-image-management-detail.html','<div><h2><span>CarouselImage</span> {{carouselImage.id}}</h2><hr><dl class="dl-horizontal"><dt><span>Picture</span></dt><dd><img data-ng-src="{{\'data:\' + carouselImage.pictureContentType + \';base64,\' + carouselImage.picture}}" style="max-width: 100%" ng-if="carouselImage.picture"><div>{{carouselImage.pictureContentType}}, {{byteSize(carouselImage.picture)}}</div></dd><hr><dt><span>OrderNum</span></dt><dd><span>{{carouselImage.orderNum}}<span></span></span></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/carousel-image/carousel-image-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myCarouselImageLabel">Create or edit a Carousel Image</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="carouselImage.id" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="setPicture($file, carouselImage)" ngf-pattern="\'image/*\'"><label class="control-label" for="field_picture">Picture</label><div><img data-ng-src="{{\'data:\' + carouselImage.pictureContentType + \';base64,\' + carouselImage.picture}}" style="max-height: 100px" ng-if="carouselImage.picture"><div class="help-block clearfix"><span class="pull-left">{{carouselImage.pictureContentType}}, {{byteSize(carouselImage.picture)}}</span> <button ng-click="carouselImage.picture=null;carouselImage.pictureContentType=null;" ng-if="carouselImage.picture" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="setPicture($file, carouselImage)" accept="image/*">Add image</button></div><input type="hidden" class="form-control" name="picture" id="field_picture" ng-model="carouselImage.picture" required> <input type="hidden" class="form-control" name="pictureContentType" id="field_pictureContentType" ng-model="carouselImage.pictureContentType"><div ng-show="editForm.picture.$invalid"><p class="help-block" ng-show="editForm.picture.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_orderNum">OrderNum</label><input type="number" class="form-control" name="orderNum" id="field_orderNum" ng-model="carouselImage.orderNum"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/carousel-image/carousel-image-management.html','<div><h2>Carousel Images<admin-menu-bar class="pull-right"></admin-menu-bar></h2><jh-alert></jh-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="carousel-image-management.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Carousel Image</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="predicate" ascending="reverse" callback="transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="picture"><span>Picture</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="orderNum"><span>OrderNum</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="carouselImage in carouselImages track by carouselImage.id"><td><a ui-sref="carousel-image-management-detail({id:carouselImage.id})">{{carouselImage.id}}</a></td><td><img data-ng-src="{{\'data:\' + carouselImage.pictureContentType + \';base64,\' + carouselImage.picture}}" style="max-height: 30px" ng-if="carouselImage.picture"> {{carouselImage.pictureContentType}} {{byteSize(carouselImage.picture)}}</td><td>{{carouselImage.orderNum}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="carousel-image-management-detail({id:carouselImage.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="carousel-image-management.edit({id:carouselImage.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="carousel-image-management.delete({id:carouselImage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page" ng-change="transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/case-study/case-studies.html','<div><h2>CaseStudies</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="case-study.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new CaseStudy</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span>Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descr"><span>Descr</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descr2"><span>Descr2</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="caseStudy in vm.caseStudies track by caseStudy.id"><td><a ui-sref="case-study-detail({id:caseStudy.id})">{{caseStudy.id}}</a></td><td>{{caseStudy.title}}</td><td>{{caseStudy.descr}}</td><td>{{caseStudy.descr2}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="case-study-detail({id:caseStudy.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="case-study.edit({id:caseStudy.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="case-study.delete({id:caseStudy.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/case-study/case-study-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.caseStudy.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this CaseStudy?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/case-study/case-study-detail.html','<div><h2><span>CaseStudy</span> {{vm.caseStudy.id}}</h2><hr><dl class="dl-horizontal"><dt><span>Title</span></dt><dd><span>{{vm.caseStudy.title}}<span></span></span></dd><hr><dt><span>Descr</span></dt><dd><span>{{vm.caseStudy.descr}}<span></span></span></dd><hr><dt><span>Descr2</span></dt><dd><span>{{vm.caseStudy.descr2}}<span></span></span></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/case-study/case-study-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCaseStudyLabel">Create or edit a Case</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.caseStudy.title"></div><div class="form-group"><label class="control-label">Description</label><summernote name="descr" id="field_descr" ng-model="vm.caseStudy.descr"></summernote></div><!--<label>Attachments</label>--><!--<div class="row">--><!--<div class="col-md-offset-10">--><!--<a class="btn btn-primary glyphicon-plus" ng-click="vm.addNewChoice(vm.attachments)"> Add attachment</a>--><!--</div>--><!--</div>--><!--<div class="row">--><!--<div ng-repeat="attachment in vm.oldAttachments" class="form-group col-md-4" >--><!--<label for="field_attachment">Attached Already</label>--><!--<div>--><!--<img id="{{ \'oldAttachment-\' + $index }}" data-ng-src="{{\'data:\' + attachment.imageContentType + \';base64,\' + attachment.image}}" style="max-height: 100px;" ng-if="attachment.image"/>--><!--<button ng-if="!attachment.imageContentType" type="file" ngf-select class="btn btn-default btn-block"--><!--ngf-change="vm.setImageFile($file, attachment, $index)" accept="image/*">--><!--Upload--><!--</button>--><!--</div>--><!--<input type="hidden" class="hiddenUploadTextbox" name="attachment" id="field_attachment"--><!--ng-model="attachment.image"--><!--/>--><!--<input type="hidden" class="hiddenUploadTextbox" name="attachment_thumbnail" id="field_attachment_thumbnail"--><!--ng-model="attachment.thumbnail"--><!--/>--><!--<input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType"--><!--ng-model="attachment.imageContentType" />--><!--<a ng-click="vm.removeOldAttachment($index, vm.oldAttachments)" class="btn btn-danger">Remove</a>--><!--</div>--><!--<div ng-repeat="attachment in vm.attachments" class="form-group col-md-4" ngf-drop ngf-change="vm.setImageFile($file, attachment, $index)" ngf-pattern="\'image/*\'">--><!--<label for="field_attachment">Attachment</label>--><!--<div>--><!--<img id="{{ \'attachment-\' + $index }}" data-ng-src="{{\'data:\' + attachment.imageContentType + \';base64,\' + attachment.image}}" style="max-height: 100px;" ng-if="attachment.image"/>--><!--<div class="help-block clearfix">--><!--<button ng-click="attachment.image=null;attachment.imageContentType=null;"--><!--ng-if="attachment.image"--><!--class="btn btn-default btn-xs pull-right">--><!--<span class="glyphicon glyphicon-remove"></span>--><!--</button>--><!--</div>--><!--<button ng-if="!attachment.imageContentType" type="file" ngf-select class="btn btn-default btn-block"--><!--ngf-change="vm.setImageFile($file, attachment, $index)" accept="image/*">--><!--Upload--><!--</button>--><!--</div>--><!--<input type="hidden" class="hiddenUploadTextbox" name="attachment" id="field_attachment"--><!--ng-model="attachment.image"--><!--/>--><!--<input type="hidden" class="hiddenUploadTextbox" name="attachment_thumbnail" id="field_attachment_thumbnail"--><!--ng-model="attachment.thumbnail"--><!--/>--><!--<input type="hidden" class="form-control" name="imageContentType" id="field_imageContentType"--><!--ng-model="attachment.imageContentType" />--><!--<a ng-click="vm.removeChoice($index, vm.attachments)" class="btn btn-danger">Remove</a>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label">Description 2 (Under Pictures)</label>--><!--<summernote  name="descr2" id="field_descr2"--><!--ng-model="vm.caseStudy.descr2"></summernote>--><!--</div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/comment/comment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.comment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Comment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/comment/comment-detail.html','<div><h2><span>Comment</span> {{vm.comment.id}}</h2><hr><dl class="dl-horizontal"><dt><span>Author</span></dt><dd><span>{{vm.comment.author}}<span></span></span></dd><hr><dt><span>Comment</span></dt><dd><span>{{vm.comment.comment}}<span></span></span></dd><hr><dt><span>CommentDate</span></dt><dd><span>{{vm.comment.commentDate | date:\'medium\'}}</span></dd><hr><dt><span>caseStudy</span></dt><dd><a ui-sref="case-study-detail({id:vm.comment.caseStudyId})">{{vm.comment.caseStudyTitle}}</a></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/comment/comment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCommentLabel">Create or edit a Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.comment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_author">Author</label><input type="text" class="form-control" name="author" id="field_author" ng-model="vm.comment.author"></div><div class="form-group"><label class="control-label" for="field_comment">Comment</label><textarea class="form-control" name="comment" id="field_comment" ng-model="vm.comment.comment"></textarea></div><div class="form-group"><label class="control-label" for="field_commentDate">CommentDate</label><div class="input-group"><input id="field_commentDate" type="text" class="form-control" datetime-picker="{{dateformat}}" ng-model="vm.comment.commentDate" is-open="datePickerForCommentDate.status.opened"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerForCommentDateOpen($event)"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_caseStudy">caseStudy</label><select class="form-control" id="field_caseStudy" name="caseStudy" ng-model="vm.comment.caseStudyId" ng-options="caseStudy.id as caseStudy.title for caseStudy in vm.casestudys"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/comment/comments.html','<div><h2>Comments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="comment.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Comment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="author"><span>Author</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span>Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commentDate"><span>CommentDate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="caseStudyTitle"><span>caseStudy</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="comment in vm.comments track by comment.id"><td><a ui-sref="comment-detail({id:comment.id})">{{comment.id}}</a></td><td>{{comment.author}}</td><td>{{comment.comment}}</td><td>{{comment.commentDate | date:\'medium\'}}</td><td><a ui-sref="case-study-detail({id:comment.caseStudyId})">{{comment.caseStudyTitle}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="comment-detail({id:comment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="comment.edit({id:comment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="comment.delete({id:comment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/file-upload/file-upload-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.fileUpload.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this File Upload?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/file-upload/file-upload-detail.html','<div><h2><span>File Upload</span> {{vm.fileUpload.id}}</h2><hr><dl class="dl-horizontal"><dt><span>Attachment</span></dt><dd><a ng-click="vm.openFile(vm.fileUpload.attachmentContentType, vm.fileUpload.attachment)" ng-if="vm.fileUpload.attachment" target="_blank">open</a><div>{{vm.fileUpload.attachmentContentType}}, {{vm.byteSize(vm.fileUpload.attachment)}}</div></dd><hr><dt><span>Name</span></dt><dd><span>{{vm.fileUpload.name}}</span></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/file-upload/file-upload-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFileUploadLabel">Create or edit a File Upload</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.fileUpload.id" readonly="readonly"></div><div class="form-group" ngf-drop ngf-change="vm.setAttachment($file, vm.fileUpload)"><label class="control-label" for="field_attachment">Attachment</label><div><div class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.fileUpload.attachmentContentType, vm.fileUpload.attachment)" ng-if="vm.fileUpload.attachment" target="_blank">open</a><br><span class="pull-left">{{vm.fileUpload.attachmentContentType}}, {{byteSize(vm.fileUpload.attachment)}}</span> <button ng-click="vm.fileUpload.attachment=null;vm.fileUpload.attachmentContentType=null;" ng-if="vm.fileUpload.attachment" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="file" ngf-select class="btn btn-default btn-block" ngf-change="vm.setAttachment($file, vm.fileUpload)">Add blob</button></div><input type="hidden" class="form-control" name="attachment" id="field_attachment" ng-model="vm.fileUpload.attachment"> <input type="hidden" class="form-control" name="attachmentContentType" id="field_attachmentContentType" ng-model="vm.fileUpload.attachmentContentType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/file-upload/file-uploads.html','<div><h2>File Uploads<div class="pull-right"><admin-menu-bar></admin-menu-bar></div></h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="file-upload.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new File Upload</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="attachment"><span>Attachment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Link</span></th><th></th></tr></thead><tbody><tr ng-repeat="fileUpload in vm.fileUploads track by fileUpload.id"><td><a ui-sref="file-upload-detail({id:fileUpload.id})">{{fileUpload.id}}</a></td><td><a ng-click="vm.openFile(fileUpload.attachmentContentType, fileUpload.attachment)" ng-if="fileUpload.attachment" target="_blank">open</a> {{fileUpload.attachmentContentType}}, {{byteSize(fileUpload.attachment)}}</td><td>{{fileUpload.name}}</td><td><input type="text" value="<a href=\'/file/{{fileUpload.id}}\' target=\'_blank\'>Link</a>"> - <a href="/file/{{fileUpload.id}}" target="_blank">Link</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="file-upload-detail({id:fileUpload.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="file-upload.edit({id:fileUpload.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="file-upload.delete({id:fileUpload.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/page-content/page-content-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pageContent.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Page {{vm.pageContent.linkName}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-click="vm.confirmDelete(vm.pageContent.id)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/page-content/page-content-detail.html','<div><h2><span>PageContent</span> {{vm.pageContent.id}}</h2><hr><dl class="dl-horizontal"><dt><span>LinkName</span></dt><dd><span>{{vm.pageContent.linkName}}<span></span></span></dd><hr><dt><span>Title</span></dt><dd><span>{{vm.pageContent.title}}<span></span></span></dd><hr><dt><span>Content</span></dt><dd><span>{{vm.pageContent.content}}<span></span></span></dd><hr><dt><span>LastUpdate</span></dt><dd><span>{{vm.pageContent.lastUpdate | date:\'medium\'}}</span></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/page-content/page-content-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPageContentLabel">Create or edit a PageContent</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.pageContent.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_linkName">LinkName</label><input type="text" class="form-control" name="linkName" id="field_linkName" ng-model="vm.pageContent.linkName"></div><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.pageContent.title"></div><div class="form-group"><label class="control-label" for="field_content">Content</label><textarea class="form-control" name="content" id="field_content" ng-model="vm.pageContent.content"></textarea></div><div class="form-group"><label class="control-label" for="field_lastUpdate">LastUpdate</label><div class="input-group"><input id="field_lastUpdate" type="text" class="form-control" datetime-picker="{{dateformat}}" ng-model="vm.pageContent.lastUpdate" is-open="datePickerForLastUpdate.status.opened"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.datePickerForLastUpdateOpen($event)"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/page-content/page-contents.html','<div><h2>PageContents</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="page-content.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new PageContent</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="linkName"><span>LinkName</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span>Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="content"><span>Content</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastUpdate"><span>LastUpdate</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="pageContent in vm.pageContents track by pageContent.id"><td><a ui-sref="page-content-detail({id:pageContent.id})">{{pageContent.id}}</a></td><td>{{pageContent.linkName}}</td><td>{{pageContent.title}}</td><td>{{pageContent.content}}</td><td>{{pageContent.lastUpdate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="page-content-detail({id:pageContent.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="page-content.edit({id:pageContent.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="page-content.delete({id:pageContent.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/pageComment/pageComment-delete-dialog.html','<form name="deleteForm" ng-submit="confirmDelete(pageComment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><p>Are you sure you want to delete this PageComment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/pageComment/pageComment-detail.html','<div><h2><span>PageComment</span> {{pageComment.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Field</th><th>Value</th></tr></thead><tbody><tr><td><span>Author</span></td><td><span class="form-control-static">{{pageComment.author}}</span></td></tr><tr><td><span>Comment</span></td><td><span class="form-control-static">{{pageComment.comment}}</span></td></tr><tr><td><span>CommentDate</span></td><td><span class="form-control-static">{{pageComment.commentDate | date:\'medium\'}}</span></td></tr><tr><td><span>PageLinkName</span></td><td><span class="form-control-static">{{pageComment.pageLinkName}}</span></td></tr><tr><td><span>Approved</span></td><td><span class="form-control-static">{{pageComment.approved}}</span></td></tr></tbody></table></div><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/pageComment/pageComment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myPageCommentLabel">Create or edit a PageComment</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="pageComment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_author">Author</label><input type="text" class="form-control" name="author" id="field_author" ng-model="pageComment.author"></div><div class="form-group"><label class="control-label" for="field_comment">Comment</label><textarea class="form-control" name="comment" id="field_comment" ng-model="pageComment.comment"></textarea></div><div class="form-group"><label class="control-label" for="field_commentDate">CommentDate</label><input id="field_commentDate" type="text" class="form-control" uib-datepicker-popup="{{dateformat}}" ng-model="pageComment.commentDate" is-open="datePickerForCommentDate.status.opened"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="datePickerForCommentDateOpen($event)"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div class="form-group"><label class="control-label" for="field_pageLinkName">PageLinkName</label><input type="text" class="form-control" name="pageLinkName" id="field_pageLinkName" ng-model="pageComment.pageLinkName"></div><div class="form-group"><label class="control-label" for="field_approved">Approved</label><input type="checkbox" class="form-control" name="approved" id="field_approved" ng-model="pageComment.approved"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/pageComment/pageComments.html','<div><h2>PageComments</h2><jh-alert></jh-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="pageComment.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new PageComment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="searchQuery" id="searchQuery" placeholder="{{ \'isahomeApp.pageComment.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="search()"><span class="glyphicon glyphicon-search"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="predicate" ascending="reverse" callback="loadAll()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="author"><span>Author</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span>Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commentDate"><span>CommentDate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pageLinkName"><span>PageLinkName</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="approved"><span>Approved</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="pageComment in pageComments track by pageComment.id"><td><a ui-sref="pageComment.detail({id:pageComment.id})">{{pageComment.id}}</a></td><td>{{pageComment.author}}</td><td>{{pageComment.comment}}</td><td>{{pageComment.commentDate | date:\'medium\'}}</td><td>{{pageComment.pageLinkName}}</td><td>{{pageComment.approved}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="pageComment.detail({id:pageComment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="pageComment.edit({id:pageComment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="pageComment.delete({id:pageComment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page" ng-change="loadAll()"></uib-pagination></div></div>');
$templateCache.put('app/entities/registration/registration-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.registration.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Registration?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/registration/registration-detail.html','<div><h2><span>Registration</span> {{vm.registration.id}}</h2><hr><dl class="dl-horizontal"><dt><span>Firstname</span></dt><dd><span>{{vm.registration.firstname}}</span></dd><hr><dt><span>Middle</span></dt><dd><span>{{vm.registration.middle}}</span></dd><hr><dt><span>Lastname</span></dt><dd><span>{{vm.registration.lastname}}</span></dd><hr><dt><span>Position</span></dt><dd><span>{{vm.registration.position}}</span></dd><hr><dt><span>Subspecialty</span></dt><dd><span>{{vm.registration.subspecialty}}</span></dd><hr><dt><span>Address One</span></dt><dd><span>{{vm.registration.addressOne}}</span></dd><hr><dt><span>Address Two</span></dt><dd><span>{{vm.registration.addressTwo}}</span></dd><hr><dt><span>City</span></dt><dd><span>{{vm.registration.city}}</span></dd><hr><dt><span>State</span></dt><dd><span>{{vm.registration.state}}</span></dd><hr><dt><span>Zip</span></dt><dd><span>{{vm.registration.zip}}</span></dd><hr><dt><span>Country</span></dt><dd><span>{{vm.registration.country}}</span></dd><hr><dt><span>Phone</span></dt><dd><span>{{vm.registration.phone}}</span></dd><hr><dt><span>Fax</span></dt><dd><span>{{vm.registration.fax}}</span></dd><hr><dt><span>Email</span></dt><dd><span>{{vm.registration.email}}</span></dd><hr><dt><span>Reference One</span></dt><dd><span>{{vm.registration.referenceOne}}</span></dd><hr><dt><span>Reference One Country</span></dt><dd><span>{{vm.registration.referenceOneCountry}}</span></dd><hr><dt><span>Reference Two</span></dt><dd><span>{{vm.registration.referenceTwo}}</span></dd><hr><dt><span>Reference Two Country</span></dt><dd><span>{{vm.registration.referenceTwoCountry}}</span></dd><hr><dt><span>Certificate Name</span></dt><dd><span>{{vm.registration.certificateName}}</span></dd><hr><dt><span>Institution</span></dt><dd><span>{{vm.registration.institution}}</span></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/registration/registration-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="col-md-8 col-md-offset-2"><div class="modal-header"><h3 class="modal-title" id="myRegistrationLabel">Application for ISA Membership</h3></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-5"><div class="form-group"><label class="control-label" for="field_firstname">First</label><input type="text" class="form-control" name="firstname" id="field_firstname" ng-model="vm.registration.firstname"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" for="field_middle">Middle</label><input type="text" class="form-control" name="middle" id="field_middle" ng-model="vm.registration.middle"></div></div><div class="col-md-5"><div class="form-group"><label class="control-label" for="field_lastname">Last (Surname or Family Name)</label><input type="text" class="form-control" name="lastname" id="field_lastname" ng-model="vm.registration.lastname"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_position">Position</label><input type="text" class="form-control" name="position" id="field_position" ng-model="vm.registration.position"></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_subspecialty">Subspecialty</label><input type="text" class="form-control" name="subspecialty" id="field_subspecialty" ng-model="vm.registration.subspecialty"></div></div></div><div class="form-group"><label class="control-label" for="field_institution">Name of Institution/Practice</label><input type="text" class="form-control" name="institution" id="field_institution" ng-model="vm.registration.institution"></div><div class="row"><div class="form-group"><div class="col-md-12"><label class="control-label" for="field_addressOne">Address 1 (Street Address)</label><input type="text" class="form-control" name="addressOne" id="field_addressOne" ng-model="vm.registration.addressOne"></div></div></div><div class="row"><div class="form-group"><div class="col-md-12"><label class="control-label" for="field_addressTwo">Address 2 (Apt/Suite/Floor)</label><input type="text" class="form-control" name="addressTwo" id="field_addressTwo" ng-model="vm.registration.addressTwo"></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label class="control-label" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.registration.city"></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.registration.state"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_zip">Zip</label><input type="text" class="form-control" name="zip" id="field_zip" ng-model="vm.registration.zip"></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_country">Country</label><input type="text" class="form-control" name="country" id="field_country" ng-model="vm.registration.country"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.registration.phone"></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.registration.fax"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.registration.email"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_referenceOne">Reference</label><input type="text" class="form-control" name="referenceOne" id="field_referenceOne" ng-model="vm.registration.referenceOne"></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_referenceOneCountry">Reference Country</label><input type="text" class="form-control" name="referenceOneCountry" id="field_referenceOneCountry" ng-model="vm.registration.referenceOneCountry"></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_certificateName">Exact Name for Certificate of Membership</label><input type="text" class="form-control" name="certificateName" id="field_certificateName" ng-model="vm.registration.certificateName"></div></div></div><div class="row" ng-if="vm.mathA"><div class="col-md-12"><div class="alert alert-danger" role="alert" ng-if="vm.error">{{vm.error}}</div><div class="form-group"><label class="control-label" for="field_phone_cell">Please enter the answer to the following math problem: {{vm.mathA}} + {{vm.mathB}}</label><input type="text" class="form-control" name="phone_cell" id="field_phone_cell" ng-model="vm.phoneCell"></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Submit</span></button></div></div></form>');
$templateCache.put('app/entities/registration/registration-success.html','<div><h2>Application Sent</h2><div class="alert alert-success">Your application has been sent to the ISA office for review and you will receive a response. To complete the application process, please pay the required dues found on the <a ui-sref="page({name: \'Pay Dues\'})">Pay Dues</a> page.</div><button class="btn btn-primary" ui-sref="home"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/registration/registrations.html','<div><h2>Registrations<admin-menu-bar class="pull-right"></admin-menu-bar></h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--<button class="btn btn-primary" ui-sref="registration.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span class="hidden-xs" >--><!--Create new Registration--><!--</span>--><!--</button>--></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstname"><span>Firstname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="middle"><span>Middle</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastname"><span>Lastname</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="position"><span>Position</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="subspecialty"><span>Subspecialty</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressOne"><span>Address One</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressTwo"><span>Address Two</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city"><span>City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="state"><span>State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="zip"><span>Zip</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="country"><span>Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span>Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fax"><span>Fax</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="referenceOne"><span>Reference One</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="referenceOneCountry"><span>Reference One Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="referenceTwo"><span>Reference Two</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="referenceTwoCountry"><span>Reference Two Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="certificateName"><span>Certificate Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="institution"><span>Institution</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="registration in vm.registrations track by registration.id"><td><a ui-sref="registration-detail({id:registration.id})">{{registration.id}}</a></td><td>{{registration.firstname}}</td><td>{{registration.middle}}</td><td>{{registration.lastname}}</td><td>{{registration.position}}</td><td>{{registration.subspecialty}}</td><td>{{registration.addressOne}}</td><td>{{registration.addressTwo}}</td><td>{{registration.city}}</td><td>{{registration.state}}</td><td>{{registration.zip}}</td><td>{{registration.country}}</td><td>{{registration.phone}}</td><td>{{registration.fax}}</td><td>{{registration.email}}</td><td>{{registration.referenceOne}}</td><td>{{registration.referenceOneCountry}}</td><td>{{registration.referenceTwo}}</td><td>{{registration.referenceTwoCountry}}</td><td>{{registration.certificateName}}</td><td>{{registration.institution}}</td><td><button ng-click="vm.addToDirectory(registration)" class="btn btn-success">Add to Directory</button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="registration-detail({id:registration.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="registration.edit({id:registration.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="registration.delete({id:registration.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/site-header/site-header-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.siteHeader.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this SiteHeader?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/site-header/site-header-detail.html','<div><h2><span>SiteHeader</span> {{vm.siteHeader.id}}</h2><hr><dl class="dl-horizontal"><dt><span>Name</span></dt><dd><span>{{vm.siteHeader.name}}<span></span></span></dd><hr><dt><span>OrderNum</span></dt><dd><span>{{vm.siteHeader.orderNum}}<span></span></span></dd><hr><dt><span>mainHeader</span></dt><dd><a ui-sref="site-header-detail({id:vm.siteHeader.mainHeaderId})">{{vm.siteHeader.mainHeaderName}}</a></dd><hr><dt><span>targetPage</span></dt><dd><a ui-sref="page-content-detail({id:vm.siteHeader.targetPageId})">{{vm.siteHeader.targetPageTitle}}</a></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/site-header/site-header-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySiteHeaderLabel">Create or edit a SiteHeader</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.siteHeader.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.siteHeader.name"></div><div class="form-group"><label class="control-label" for="field_orderNum">OrderNum</label><input type="number" class="form-control" name="orderNum" id="field_orderNum" ng-model="vm.siteHeader.orderNum"></div><div class="form-group"><label for="field_mainHeader">mainHeader</label><select class="form-control" id="field_mainHeader" name="mainHeader" ng-model="vm.siteHeader.mainHeaderId" ng-options="siteHeader.id as siteHeader.name for siteHeader in vm.siteheaders"><option value=""></option></select></div><div class="form-group"><label for="field_targetPage">targetPage</label><select class="form-control" id="field_targetPage" name="targetPage" ng-model="vm.siteHeader.targetPageId" ng-options="pageContent.id as pageContent.title for pageContent in vm.pagecontents"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/site-header/site-headers.html','<div><h2>Site Headers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="site-header.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Site Header</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="orderNum"><span>OrderNum</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mainHeaderName"><span>mainHeader</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="targetPageTitle"><span>targetPage</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="siteHeader in vm.siteHeaders track by siteHeader.id"><td><a ui-sref="site-header-detail({id:siteHeader.id})">{{siteHeader.id}}</a></td><td>{{siteHeader.name}}</td><td>{{siteHeader.orderNum}}</td><td><a ng-if="siteHeader.mainHeaderName" ui-sref="site-header-detail({id:siteHeader.mainHeaderId})">{{siteHeader.mainHeaderName}}</a></td><td><a ui-sref="page-content-detail({id:siteHeader.targetPageId})">{{siteHeader.targetPageTitle}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="site-header-detail({id:siteHeader.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="site-header.edit({id:siteHeader.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="site-header.delete({id:siteHeader.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/user-profile/user-profile-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.userProfile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User Profile?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/user-profile/user-profile-detail.html','<div><h2><span>User Profile</span> {{vm.userProfile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>First Name</span></dt><dd><span>{{vm.userProfile.firstName}}</span></dd><dt><span>Last Name</span></dt><dd><span>{{vm.userProfile.lastName}}</span></dd><dt><span>Address One</span></dt><dd><span>{{vm.userProfile.addressOne}}</span></dd><dt><span>Address Two</span></dt><dd><span>{{vm.userProfile.addressTwo}}</span></dd><dt><span>Address Three</span></dt><dd><span>{{vm.userProfile.addressThree}}</span></dd><dt><span>Middle Initial</span></dt><dd><span>{{vm.userProfile.middleInitial}}</span></dd><dt><span>Prefix</span></dt><dd><span>{{vm.userProfile.prefix}}</span></dd><dt><span>Degree</span></dt><dd><span>{{vm.userProfile.degree}}</span></dd><dt><span>City</span></dt><dd><span>{{vm.userProfile.city}}</span></dd><dt><span>State</span></dt><dd><span>{{vm.userProfile.state}}</span></dd><dt><span>Zip Code</span></dt><dd><span>{{vm.userProfile.zipCode}}</span></dd><dt><span>Country</span></dt><dd><span>{{vm.userProfile.country}}</span></dd><dt><span>Phone</span></dt><dd><span>{{vm.userProfile.phone}}</span></dd><dt><span>Fax</span></dt><dd><span>{{vm.userProfile.fax}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.userProfile.email}}</span></dd><dt><span>Institution</span></dt><dd><span>{{vm.userProfile.institution}}</span></dd><dt><span>Paid Through</span></dt><dd><span>{{vm.userProfile.paidThrough}}</span></dd></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/user-profile/user-profile-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserProfileLabel">Create or edit a User Profile</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.userProfile.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.userProfile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.userProfile.firstName"></div><div class="form-group"><label class="control-label" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.userProfile.lastName"></div><div class="form-group"><label class="control-label" for="field_addressOne">Address One</label><input type="text" class="form-control" name="addressOne" id="field_addressOne" ng-model="vm.userProfile.addressOne"></div><div class="form-group"><label class="control-label" for="field_addressTwo">Address Two</label><input type="text" class="form-control" name="addressTwo" id="field_addressTwo" ng-model="vm.userProfile.addressTwo"></div><div class="form-group"><label class="control-label" for="field_addressThree">Address Three</label><input type="text" class="form-control" name="addressThree" id="field_addressThree" ng-model="vm.userProfile.addressThree"></div><div class="form-group"><label class="control-label" for="field_middleInitial">Middle Initial</label><input type="text" class="form-control" name="middleInitial" id="field_middleInitial" ng-model="vm.userProfile.middleInitial"></div><div class="form-group"><label class="control-label" for="field_prefix">Prefix</label><input type="text" class="form-control" name="prefix" id="field_prefix" ng-model="vm.userProfile.prefix"></div><div class="form-group"><label class="control-label" for="field_degree">Degree</label><input type="text" class="form-control" name="degree" id="field_degree" ng-model="vm.userProfile.degree"></div><div class="form-group"><label class="control-label" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.userProfile.city"></div><div class="form-group"><label class="control-label" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.userProfile.state"></div><div class="form-group"><label class="control-label" for="field_zipCode">Zip Code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" ng-model="vm.userProfile.zipCode"></div><div class="form-group"><label class="control-label" for="field_country">Country</label><input type="text" class="form-control" name="country" id="field_country" ng-model="vm.userProfile.country"></div><div class="form-group"><label class="control-label" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.userProfile.phone"></div><div class="form-group"><label class="control-label" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.userProfile.fax"></div><div class="form-group"><label class="control-label" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.userProfile.email"></div><div class="form-group"><label class="control-label" for="field_institution">Institution</label><input type="text" class="form-control" name="institution" id="field_institution" ng-model="vm.userProfile.institution"></div><div class="form-group"><label class="control-label" for="field_paidThrough">Paid Through</label><input type="text" class="form-control" name="paidThrough" id="field_paidThrough" ng-model="vm.userProfile.paidThrough"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/user-profile/user-profiles.html','<div><h2>User Profiles</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="user-profile.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new User Profile</span></button> <button class="btn btn-success" ui-sref="directory-import"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Import XLSX</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firstName"><span>First Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastName"><span>Last Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressOne"><span>Address One</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressTwo"><span>Address Two</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressThree"><span>Address Three</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="middleInitial"><span>Middle Initial</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="prefix"><span>Prefix</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="degree"><span>Degree</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city"><span>City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="state"><span>State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="zipCode"><span>Zip Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="country"><span>Country</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="phone"><span>Phone</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fax"><span>Fax</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="institution"><span>Institution</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="paidThrough"><span>Paid Through</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="userProfile in vm.userProfiles track by userProfile.id"><td><a ui-sref="user-profile-detail({id:userProfile.id})">{{userProfile.id}}</a></td><td>{{userProfile.firstName}}</td><td>{{userProfile.lastName}}</td><td>{{userProfile.addressOne}}</td><td>{{userProfile.addressTwo}}</td><td>{{userProfile.addressThree}}</td><td>{{userProfile.middleInitial}}</td><td>{{userProfile.prefix}}</td><td>{{userProfile.degree}}</td><td>{{userProfile.city}}</td><td>{{userProfile.state}}</td><td>{{userProfile.zipCode}}</td><td>{{userProfile.country}}</td><td>{{userProfile.phone}}</td><td>{{userProfile.fax}}</td><td>{{userProfile.email}}</td><td>{{userProfile.institution}}</td><td>{{userProfile.paidThrough}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-profile-detail({id:userProfile.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-profile.edit({id:userProfile.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-profile.delete({id:userProfile.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.html','<div class="footer row" ng-cloak><div class="col-md-4 col-sm-4 col-xs-6"><!--<ul style="float: left;">--><div class="row"><div ng-repeat="header in mainHeaders"><div class="clearfix" ng-if="$index % 2 == 0"></div><div class="col-sm-4"><a ui-sref="page({name:header.targetPageLinkName})">{{header.name}}</a></div></div></div><!--<div  data-ng-repeat="header in mainHeaders"><a ui-sref="page({name:header.targetPageLinkName})">{{header.name}}</a></div>--><!--</ul>--></div><div class="col-md-4 col-sm-4 col-xs-6 row text-center" style="padding-top: 10px"><div class="col-md-12 text-center">1160 W. Michigan Street, #220<br>Indianapolis, IN 46202 USA<br><br></div><div class="col-md-12 text-center">\xA9 2016 International Strabismological Association<br>All Rights Reserved.</div></div><div class="col-md-4"><div class="pull-right"><div class="col-md-12 text-center"><a href="https://twitter.com/IntlStrabAssoc"><button class="btn btn-social-icon btn-twitter"><i class="fa fa-twitter"></i></button> </a><a href="https://www.facebook.com/isahome.org/"><button class="btn btn-social-icon btn-facebook"><i class="fa fa-facebook"></i></button> </a><a href="https://www.linkedin.com/company/7952077"><button class="btn btn-social-icon btn-linkedin"><i class="fa fa-linkedin"></i></button></a><br><br></div><div class="text-center"><a ui-sref="page({name:\'privacy-policy\'})">Privacy</a> &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; <a ui-sref="page({name:\'terms\'})">Terms</a></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default main_nav" role="navigation"><div class="container"><div class="navbar-header" style="width: 300px"><div style="margin-top: 10px"><a href="/"><img src="content/images/isalogo.png" class="pull-left main-logo"></a><div class="col-md-2 col-sm-2 col-xs-2 header-text"><strong><a href="/">International Strabismological Association</a></strong></div></div></div><div class="hidden-xs pull-right" ng-switch="isAuthenticated()" style="margin-top: 10px"><a href="" ng-click="login()" id="login" ng-switch-when="false">&#xA0;<span>Member Login</span></a> <span ng-switch-when="false">&nbsp;|&nbsp;</span><!--<a ui-sref="registration.guest" ng-switch-when="false">--> <a ui-sref="page({name: \'join-isa\'})" ng-switch-when="false">&#xA0;<span>Join ISA</span></a> <span ng-switch-when="false">&nbsp;|&nbsp;</span><!--<a ui-sref="#" ng-switch-when="true">--><!--&#xA0;<span>Your Account</span></a>--> <a ui-sref="adminCenter" ng-switch-when="true" has-authority="ROLE_ADMIN">&#xA0;<span>Admin Center</span></a> <span ng-switch-when="true" has-authority="ROLE_ADMIN">&nbsp;|&nbsp;</span> <a href="" ng-click="logout()" id="logout" ng-switch-when="true">&#xA0;<span>Sign out</span></a> <span ng-switch-when="true">&nbsp;|&nbsp;</span> <a ui-sref="page({name:\'contact-us\'})">&#xA0;<span>Contact Us</span></a> <span ng-switch-when="true" has-authority="ROLE_ADMIN"><br></span><form data-ng-submit="searchSite(query)"><input data-ng-model="query" placeholder="Search" type="text" class="form-control"></form></div></div></nav><nav class="navbar navbar-default secondary_nav" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse2"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></div><div class="collapse navbar-collapse" id="navbar-collapse2" ng-switch="isAuthenticated()"><ul class="nav navbar-nav"><li class="dropdown" ng-repeat="header in mainHeaders"><a ui-sref="page({name:header.targetPageLinkName})" class="dropdown-toggle header-menu" data-toggle="dropdown" data-hover="dropdown" data-delay="1000" data-close-others="false">{{header.name}}</a><ul class="dropdown-menu" ng-if="header.subHeaders && header.subHeaders.length"><!--if there are subheaders--><li ng-repeat="subheader in header.subHeaders | orderBy: \'orderNum\'"><a ng-if="subheader.subHeaders.length == 0" tabindex="-1" ui-sref="page({name:subheader.targetPageLinkName})">{{subheader.name}} </a><!--if there are third level headers--> <a ng-if="subheader.subHeaders.length > 0" tabindex="-1" ui-sref="page({name:subheader.targetPageLinkName})">{{subheader.name}}<!--<a ng-repeat="thirdHeader in subheader.subHeaders" tabindex="-1" ui-sref="page({name:thirdHeader.targetPageLinkName})">--><!--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{thirdHeader.name}}--><!--</a>--></a></li></ul></li><li ui-sref-active="active" class="visible-xs"><a ui-sref="page({name:header.targetPageLinkName})" class="tiny-nav-button header-menu" data-toggle="collapse" data-target=".navbar-collapse.in">{{header.name}}</a></li><li ui-sref-active="active" class="visible-xs"><a ui-sref="page({name:\'contact-us\'})" class="tiny-nav-button header-menu" data-toggle="collapse" data-target=".navbar-collapse.in"><span>&nbsp;Contact Us</span></a></li><li ui-sref-active="active" ng-switch-when="true" has-authority="ROLE_ADMIN" class="visible-xs"><a ui-srec="adminCenter" class="tiny-nav-button header-menu" data-toggle="collapse" data-target=".navbar-collapse.in"><span>&nbsp;Admin Center</span></a></li><li ui-sref-active="active" ng-switch-when="true" class="visible-xs"><a ui-srec="#" class="tiny-nav-button header-menu" data-toggle="collapse" data-target=".navbar-collapse.in"><span>&nbsp;Your Account</span></a></li><li ui-sref-active="active" ng-switch-when="true" class="visible-xs"><a ng-click="logout()" class="tiny-nav-button header-menu" data-toggle="collapse" data-target=".navbar-collapse.in"><span>&nbsp;Sign Out</span></a></li><li ui-sref-active="active" ng-switch-when="false" class="visible-xs"><a ui-sref="registration.guest" class="tiny-nav-button header-menu" data-toggle="collapse" data-target=".navbar-collapse.in"><span>&nbsp;Join ISA</span></a></li><li ui-sref-active="active" ng-switch-when="false" class="visible-xs"><a ng-click="login()" class="tiny-nav-button header-menu" data-toggle="collapse" data-target=".navbar-collapse.in"><span>&nbsp;Login</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="success || keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 72 hours.</p></div><div class="alert alert-success" ng-show="success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" style="pointer: cursor" ng-click="login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="doNotMatch">The password and its confirmation do not match!</div><div ng-hide="keyMissing"><form ng-show="!success" name="form" role="form" novalidate ng-submit="finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="resetAccount.password" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="confirmPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="success"><p>Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="success == \'OK\'"><p>Check your e-mails for details on how to reset your password.</p></div><form ng-show="!success" name="form" role="form" novalidate ng-submit="requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');
$templateCache.put('app/admin/center/flipbooks/admin.flipbooks.html','<div><h2>Flipbooks<admin-menu-bar class="pull-right"></admin-menu-bar></h2><hr><div class="row"><table class="table table-striped"><tr><th>Title</th><th>Link</th><th>Full Embed Code</th><th>Mini Embed Code</th></tr><tr data-ng-repeat="book in sites track by $index"><td>{{book}}</td><td><a href="http://flipbooks.isahome.org/{{book}}">Link</a></td><td><textarea><iframe frameborder="0" allowfullscreen="true" width="100%" height="300" title="" src="http://flipbooks.isahome.org/{{book}}" type="text/html" scrolling="no" marginwidth="0" marginheight="0"></iframe></textarea></td><td><textarea><iframe frameborder="0" allowfullscreen="true" width="100%" height="300" title="" src="http://flipbooks.isahome.org/BitcoinImprovementProposal/#PreviewMode=Miniature" type="text/html" scrolling="no" marginwidth="0" marginheight="0"></iframe></textarea></td></tr></table></div></div>');
$templateCache.put('app/admin/center/headers/admin.center.header.dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySiteHeaderLabel">Create or edit a Site Header {{vm.siteHeader.id}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.siteHeader.name"></div><div class="form-group"><label class="control-label" for="field_orderNum">Order Num</label><input type="number" class="form-control" name="orderNum" id="field_orderNum" ng-model="vm.siteHeader.orderNum"></div><div class="form-group"><label for="field_mainHeader">Parent Header</label><select class="form-control" id="field_mainHeader" name="mainHeader" ng-model="vm.siteHeader.mainHeaderId" ng-options="siteHeader.id as (siteHeader.id + \': \' + siteHeader.name) for siteHeader in vm.siteheaders"><option value=""></option></select></div><div class="form-group"><label for="field_targetPage">Target Page</label><select class="form-control" id="field_targetPage" name="targetPage" ng-model="vm.siteHeader.targetPageId" ng-options="pageContent.id as (pageContent.id + \': \' + pageContent.title) for pageContent in vm.pagecontents"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/center/headers/admin.center.headers.html','<div><h2>Headers<admin-menu-bar class="pull-right"></admin-menu-bar></h2><hr><div class="row"><div class="col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2"><h3>Headers <button class="btn btn-success btn-sm pull-right" title="Add card to column" ui-sref="adminHeaders.new"><i class="glyphicon glyphicon-plus"></i></button></h3><div id="board1" data-ng-model="mainHeaders"><div id="columns1" class="row"><div data-columnindex="{{$index}}" id="column-{{$index}}"><div class="column"><ul class="list-group" as-sortable="mainHeaderSortOptions" data-ng-model="mainHeaders"><div ng-repeat="header in mainHeaders | orderBy: orderNum"><li class="list-group-item" as-sortable-item>{{header.orderNum}}. <a ui-sref="page({name:header.targetPageLinkName})">{{header.name}}</a><div class="text-right"><!--<button class="btn btn-sm btn-primary" as-sortable-item-handle><span class="fa fa-hand-grab-o"></span></button>--> <button ui-sref="adminHeaders.edit({id:header.id})" class="btn btn-sm btn-info"><span class="fa fa-pencil"></span></button> <button ui-sref="adminHeaders.delete({id:header.id})" class="btn btn-sm btn-danger"><span class="fa fa-remove"></span></button></div></li><div ng-repeat="subHeader in header.subHeaders | orderBy: orderNum"><li class="list-group-item" as-sortable-item>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{subHeader.orderNum}}. <a ui-sref="page({name:subHeader.targetPageLinkName})">{{subHeader.name}}</a><div class="text-right"><!--<button class="btn btn-sm btn-primary" as-sortable-item-handle><span class="fa fa-hand-grab-o"></span></button>--> <button ui-sref="adminHeaders.edit({id:subHeader.id})" class="btn btn-sm btn-info"><span class="fa fa-pencil"></span></button> <button ui-sref="adminHeaders.delete({id:subHeader.id})" class="btn btn-sm btn-danger"><span class="fa fa-remove"></span></button></div></li><div ng-repeat="thirdHeader in subHeader.subHeaders | orderBy: orderNum"><li class="list-group-item" as-sortable-item>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{thirdHeader.orderNum}}. <a ui-sref="page({name:thirdHeader.targetPageLinkName})">{{thirdHeader.name}}</a><div class="text-right"><!--<button class="btn btn-sm btn-primary" as-sortable-item-handle><span class="fa fa-hand-grab-o"></span></button>--> <button ui-sref="adminHeaders.edit({id:thirdHeader.id})" class="btn btn-sm btn-info"><span class="fa fa-pencil"></span></button> <button ui-sref="adminHeaders.delete({id:thirdHeader.id})" class="btn btn-sm btn-danger"><span class="fa fa-remove"></span></button></div></li></div></div></div></ul></div></div></div></div><!--</div>--><!--<div class="col-md-9">--><!--<h3>Sub Headers</h3>--><!--<div id="board" data-ng-model="mainHeaders">--><!--<div id="columns" class="row">--><!--<div class="col-sm-4 col-md-3 col-xs-6 subheader-column"--><!--ng-repeat="header in mainHeaders"--><!--data-columnindex="{{$index}}" id="column{{$index}}">--><!--<button class="btn btn-success btn-sm pull-right"--><!--ui-sref="adminHeaders.newSubHeader({mainHeaderId:header.id, mainHeaderName:header.name})">--><!--<i class="glyphicon glyphicon-plus addNewCard"></i>--><!--</button>--><!--<div class="column">--><!--<div class="columnHeader"><h5>{{header.name}} ({{header.subHeaders.length}})</h5></div>--><!--<ul class="list-group" as-sortable="subHeaderSortOptions" data-ng-model="header.subHeaders">--><!--<li class="list-group-item" ng-repeat="subheader in header.subHeaders" as-sortable-item>--><!--<span><a ui-sref="page({name:subheader.targetPageLinkName})">{{subheader.name}}</a></span>--><!--<div class="text-right">--><!--<button class="btn btn-sm btn-primary" as-sortable-item-handle><span class="fa fa-hand-grab-o"></span></button>--><!--<button ui-sref="adminHeaders.editSubHeader({id:subheader.id})" class="btn btn-sm btn-info"><span class="fa fa-pencil"></span></button>--><!--<button ui-sref="adminHeaders.deleteSubHeader({id:subheader.id})" class="btn btn-sm btn-danger"><span class="fa fa-remove"></span></button>--><!--</div>--><!--</li>--><!--</ul>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--></div></div></div>');
$templateCache.put('app/admin/center/pages/admin.center.pages.detail.html','<div><h2><span>Page</span> {{pageContent.id}}</h2><hr><dl class="dl-horizontal"><dt><span>Name</span></dt><dd><span>{{pageContent.name}}<span></span></span></dd><hr><dt><span>Title</span></dt><dd><span>{{pageContent.title}}<span></span></span></dd><hr><dt><span>Content</span></dt><dd><span>{{pageContent.content}}<span></span></span></dd><hr><dt><span>LastUpdate</span></dt><dd><span>{{pageContent.lastUpdate | date:\'medium\'}}</span></dd><hr></dl><button type="submit" onclick="window.history.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/center/pages/admin.center.pages.dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPageContentLabel">Create or edit a Page</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label class="control-label" for="field_linkName">Link Name (used in URL) <strong>*</strong></label><input required type="text" class="form-control" name="linkName" id="field_linkName" ng-model="vm.pageContent.linkName"></div><div class="form-group"><label class="control-label" for="field_title">Title (Appears in menu bars) <strong>*</strong></label><input required type="text" class="form-control" name="title" id="field_title" ng-model="vm.pageContent.title"></div><div class="form-group"><label class="control-label">Content</label><summernote name="field_content" id="field_content" ng-model="vm.pageContent.content"></summernote></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/center/pages/admin.center.pages.html','<div><h2>Pages<admin-menu-bar class="pull-right"></admin-menu-bar></h2><hr><h3>Pages</h3><jh-alert></jh-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="adminPages.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create a new Page</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="search()"><span class="glyphicon glyphicon-search"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="predicate" ascending="reverse" callback="transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="linkName"><span>Link Name (Used in URL)</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span>Title (Appears on Left Link Menu)</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastUpdate"><span>LastUpdate</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="pageContent in pageContents track by pageContent.id"><td><a ui-sref="adminPages.detail({id:pageContent.id})">{{pageContent.id}}</a></td><td>{{pageContent.linkName}}</td><td>{{pageContent.title}}</td><td>{{pageContent.lastUpdate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="page({name:pageContent.linkName})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="adminPages.delete({id:pageContent.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><uib-pagination class="pagination" total-items="totalItems" ng-model="page" ng-change="transition()"></uib-pagination></div></div>');
$templateCache.put('app/admin/center/unapproved-comments/pageComment-delete-dialog.html','<form name="deleteForm" ng-submit="confirmDelete(pageComment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><p>Are you sure you want to delete this PageComment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/center/unapproved-comments/pageComment-detail.html','<div><h2><span>PageComment</span> {{pageComment.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Field</th><th>Value</th></tr></thead><tbody><tr><td><span>Author</span></td><td><span class="form-control-static">{{pageComment.author}}</span></td></tr><tr><td><span>Comment</span></td><td><span class="form-control-static">{{pageComment.comment}}</span></td></tr><tr><td><span>CommentDate</span></td><td><span class="form-control-static">{{pageComment.commentDate | date:\'medium\'}}</span></td></tr><tr><td><span>PageLinkName</span></td><td><span class="form-control-static"><a target="_blank" ng-href="/p/{{pageComment.pageLinkName}}">{{pageComment.pageLinkName}}</a></span></td></tr><tr><td><span>Approved</span></td><td><span class="form-control-static">{{pageComment.approved}}</span></td></tr></tbody></table></div><button type="submit" ui-sref="unapproved-comments" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="submit" ng-if="!pageComment.approved" ng-click="approveComment(true)" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp;<span> Approve Comment</span></button> <button type="submit" ng-if="pageComment.approved" ng-click="approveComment(false)" class="btn btn-danger"><span class="glyphicon glyphicon-alert"></span>&nbsp;<span> Unapprove Comment</span></button></div>');
$templateCache.put('app/admin/center/unapproved-comments/pageComment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myPageCommentLabel">Create or edit a PageComment</h4></div><div class="modal-body"><jh-alert-error></jh-alert-error><div class="form-group"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="pageComment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_author">Author</label><input type="text" class="form-control" name="author" id="field_author" ng-model="pageComment.author"></div><div class="form-group"><label class="control-label" for="field_comment">Comment</label><textarea class="form-control" name="comment" id="field_comment" ng-model="pageComment.comment"></textarea></div><div class="form-group"><label class="control-label" for="field_commentDate">CommentDate</label><input id="field_commentDate" type="text" class="form-control" uib-datepicker-popup="{{dateformat}}" ng-model="pageComment.commentDate" is-open="datePickerForCommentDate.status.opened"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="datePickerForCommentDateOpen($event)"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div class="form-group"><label class="control-label" for="field_pageLinkName">PageLinkName</label><input type="text" class="form-control" name="pageLinkName" id="field_pageLinkName" ng-model="pageComment.pageLinkName"></div><div class="form-group"><label class="control-label" for="field_approved">Approved</label><input type="checkbox" class="form-control" name="approved" id="field_approved" ng-model="pageComment.approved"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/center/unapproved-comments/pageComment.html','<div><h2>{{approved ? \'Approved\' : \'Unapproved\'}} Comments</h2><div><button class="btn btn-success" ng-click="toggleApproved()">View {{approved ? \'Unapproved\' : \'Approved\'}}</button></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="predicate" ascending="reverse" callback="loadAll()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="author"><span>Author</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span>Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="commentDate"><span>CommentDate</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pageLinkName"><span>Link</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="approved"><span>Approval</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="pageComment in pageComments track by pageComment.id"><td><a ui-sref="unapproved-comments.detail({id:pageComment.id})">{{pageComment.id}}</a></td><td>{{pageComment.author}}</td><td>{{pageComment.comment}}</td><td>{{pageComment.commentDate | date:\'medium\'}}</td><td><a target="_blank" ng-href="/p/{{pageComment.pageLinkName}}">{{pageComment.pageLinkName}}</a></td><td><button ng-if="!approved" ng-click="approveComment(pageComment.id, true)" class="btn btn-success">Approve</button> <button ng-if="approved" ng-click="approveComment(pageComment.id, false)" class="btn btn-danger">Unapprove</button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="unapproved-comments.detail({id:pageComment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="unapproved-comments.edit({id:pageComment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="unapproved-comments.delete({id:pageComment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><uib-pagination class="pagination-sm" total-items="totalItems" ng-model="page" ng-change="loadAll()"></uib-pagination></div></div>');
$templateCache.put('app/admin/center/videos/admin.center.videos.dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySiteHeaderLabel">Create or edit a Site Header</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.siteHeader.name"></div><div class="form-group"><label class="control-label" for="field_orderNum">Order Num</label><input type="number" class="form-control" name="orderNum" id="field_orderNum" ng-model="vm.siteHeader.orderNum"></div><div class="form-group"><label for="field_mainHeader">Parent Header</label><select class="form-control" id="field_mainHeader" name="mainHeader" ng-model="vm.siteHeader.mainHeaderId" ng-options="siteHeader.id as siteHeader.name for siteHeader in vm.siteheaders"><option value=""></option></select></div><div class="form-group"><label for="field_targetPage">Target Page</label><select class="form-control" id="field_targetPage" name="targetPage" ng-model="vm.siteHeader.targetPageId" ng-options="pageContent.id as pageContent.title for pageContent in vm.pagecontents"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/center/videos/admin.center.videos.html','<div><h2>Videos<admin-menu-bar class="pull-right"></admin-menu-bar></h2><hr><div class="row"><div class="col-md-12"><h3>All Videos from {{username}}</h3><a href="https://www.youtube.com/my_videos" target="_blank"><button class="btn btn-google">View Your Videos on Youtube</button></a><br><br><button class="btn btn-info" ui-sref="adminVideos.upload">Upload Videos</button></div></div></div>');
$templateCache.put('app/admin/center/videos/admin.center.videos.upload.html','<div><h2>Admin Center<admin-menu-bar class="pull-right"></admin-menu-bar></h2><hr><div class="row"><div class="col-md-12"><h3>Upload Video</h3><div class="alert alert-info" ng-show="uploaded == true">Successfully uploaded video ({{videoId}}) - it is still proccessing. Please wait.</div><div class="alert alert-success" ng-show="success == true">Video ({{videoId}}) has successfully proccessed.</div><div class="alert alert-danger" ng-show="error == true">Error uploading video: {{errorMessage}}</div><label>Title</label><input type="text" ng-model="videoTitle" placeholder="Title"><div youtube-uploader clientid="227142557779-nqg8rr0o9fnc6npf541d38f0paqavnfn.apps.googleusercontent.com" data-video-title="{{videoTitle}}"></div><button class="btn btn-sm btn-primary" ng-click="reloadPage()">Form not showing? Click here</button></div></div></div>');}]);})();